var __create = Object.create;
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __require = /* @__PURE__ */ ((x) => typeof require !== "undefined" ? require : typeof Proxy !== "undefined" ? new Proxy(x, {
  get: (a, b) => (typeof require !== "undefined" ? require : a)[b]
}) : x)(function(x) {
  if (typeof require !== "undefined")
    return require.apply(this, arguments);
  throw new Error('Dynamic require of "' + x + '" is not supported');
});
var __commonJS = (cb, mod) => function __require2() {
  return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));

// node_modules/bn.js/lib/bn.js
var require_bn = __commonJS({
  "node_modules/bn.js/lib/bn.js"(exports, module) {
    (function(module2, exports2) {
      "use strict";
      function assert(val, msg) {
        if (!val)
          throw new Error(msg || "Assertion failed");
      }
      function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {
        };
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
      }
      function BN2(number, base, endian) {
        if (BN2.isBN(number)) {
          return number;
        }
        this.negative = 0;
        this.words = null;
        this.length = 0;
        this.red = null;
        if (number !== null) {
          if (base === "le" || base === "be") {
            endian = base;
            base = 10;
          }
          this._init(number || 0, base || 10, endian || "be");
        }
      }
      if (typeof module2 === "object") {
        module2.exports = BN2;
      } else {
        exports2.BN = BN2;
      }
      BN2.BN = BN2;
      BN2.wordSize = 26;
      var Buffer2;
      try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") {
          Buffer2 = window.Buffer;
        } else {
          Buffer2 = __require("buffer").Buffer;
        }
      } catch (e) {
      }
      BN2.isBN = function isBN(num) {
        if (num instanceof BN2) {
          return true;
        }
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN2.wordSize && Array.isArray(num.words);
      };
      BN2.max = function max(left, right) {
        if (left.cmp(right) > 0)
          return left;
        return right;
      };
      BN2.min = function min(left, right) {
        if (left.cmp(right) < 0)
          return left;
        return right;
      };
      BN2.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") {
          return this._initNumber(number, base, endian);
        }
        if (typeof number === "object") {
          return this._initArray(number, base, endian);
        }
        if (base === "hex") {
          base = 16;
        }
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
          start++;
          this.negative = 1;
        }
        if (start < number.length) {
          if (base === 16) {
            this._parseHex(number, start, endian);
          } else {
            this._parseBase(number, base, start);
            if (endian === "le") {
              this._initArray(this.toArray(), base, endian);
            }
          }
        }
      };
      BN2.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
          this.negative = 1;
          number = -number;
        }
        if (number < 67108864) {
          this.words = [number & 67108863];
          this.length = 1;
        } else if (number < 4503599627370496) {
          this.words = [
            number & 67108863,
            number / 67108864 & 67108863
          ];
          this.length = 2;
        } else {
          assert(number < 9007199254740992);
          this.words = [
            number & 67108863,
            number / 67108864 & 67108863,
            1
          ];
          this.length = 3;
        }
        if (endian !== "le")
          return;
        this._initArray(this.toArray(), base, endian);
      };
      BN2.prototype._initArray = function _initArray(number, base, endian) {
        assert(typeof number.length === "number");
        if (number.length <= 0) {
          this.words = [0];
          this.length = 1;
          return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for (var i = 0; i < this.length; i++) {
          this.words[i] = 0;
        }
        var j, w;
        var off = 0;
        if (endian === "be") {
          for (i = number.length - 1, j = 0; i >= 0; i -= 3) {
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 67108863;
            this.words[j + 1] = w >>> 26 - off & 67108863;
            off += 24;
            if (off >= 26) {
              off -= 26;
              j++;
            }
          }
        } else if (endian === "le") {
          for (i = 0, j = 0; i < number.length; i += 3) {
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 67108863;
            this.words[j + 1] = w >>> 26 - off & 67108863;
            off += 24;
            if (off >= 26) {
              off -= 26;
              j++;
            }
          }
        }
        return this._strip();
      };
      function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        if (c >= 48 && c <= 57) {
          return c - 48;
        } else if (c >= 65 && c <= 70) {
          return c - 55;
        } else if (c >= 97 && c <= 102) {
          return c - 87;
        } else {
          assert(false, "Invalid character in " + string);
        }
      }
      function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) {
          r |= parseHex4Bits(string, index - 1) << 4;
        }
        return r;
      }
      BN2.prototype._parseHex = function _parseHex(number, start, endian) {
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for (var i = 0; i < this.length; i++) {
          this.words[i] = 0;
        }
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") {
          for (i = number.length - 1; i >= start; i -= 2) {
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 67108863;
            if (off >= 18) {
              off -= 18;
              j += 1;
              this.words[j] |= w >>> 26;
            } else {
              off += 8;
            }
          }
        } else {
          var parseLength = number.length - start;
          for (i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2) {
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 67108863;
            if (off >= 18) {
              off -= 18;
              j += 1;
              this.words[j] |= w >>> 26;
            } else {
              off += 8;
            }
          }
        }
        this._strip();
      };
      function parseBase(str, start, end, mul) {
        var r = 0;
        var b = 0;
        var len = Math.min(str.length, end);
        for (var i = start; i < len; i++) {
          var c = str.charCodeAt(i) - 48;
          r *= mul;
          if (c >= 49) {
            b = c - 49 + 10;
          } else if (c >= 17) {
            b = c - 17 + 10;
          } else {
            b = c;
          }
          assert(c >= 0 && b < mul, "Invalid character");
          r += b;
        }
        return r;
      }
      BN2.prototype._parseBase = function _parseBase(number, base, start) {
        this.words = [0];
        this.length = 1;
        for (var limbLen = 0, limbPow = 1; limbPow <= 67108863; limbPow *= base) {
          limbLen++;
        }
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for (var i = start; i < end; i += limbLen) {
          word = parseBase(number, i, i + limbLen, base);
          this.imuln(limbPow);
          if (this.words[0] + word < 67108864) {
            this.words[0] += word;
          } else {
            this._iaddn(word);
          }
        }
        if (mod !== 0) {
          var pow = 1;
          word = parseBase(number, i, number.length, base);
          for (i = 0; i < mod; i++) {
            pow *= base;
          }
          this.imuln(pow);
          if (this.words[0] + word < 67108864) {
            this.words[0] += word;
          } else {
            this._iaddn(word);
          }
        }
        this._strip();
      };
      BN2.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for (var i = 0; i < this.length; i++) {
          dest.words[i] = this.words[i];
        }
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
      };
      function move(dest, src) {
        dest.words = src.words;
        dest.length = src.length;
        dest.negative = src.negative;
        dest.red = src.red;
      }
      BN2.prototype._move = function _move(dest) {
        move(dest, this);
      };
      BN2.prototype.clone = function clone() {
        var r = new BN2(null);
        this.copy(r);
        return r;
      };
      BN2.prototype._expand = function _expand(size) {
        while (this.length < size) {
          this.words[this.length++] = 0;
        }
        return this;
      };
      BN2.prototype._strip = function strip() {
        while (this.length > 1 && this.words[this.length - 1] === 0) {
          this.length--;
        }
        return this._normSign();
      };
      BN2.prototype._normSign = function _normSign() {
        if (this.length === 1 && this.words[0] === 0) {
          this.negative = 0;
        }
        return this;
      };
      if (typeof Symbol !== "undefined" && typeof Symbol.for === "function") {
        try {
          BN2.prototype[Symbol.for("nodejs.util.inspect.custom")] = inspect;
        } catch (e) {
          BN2.prototype.inspect = inspect;
        }
      } else {
        BN2.prototype.inspect = inspect;
      }
      function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
      }
      var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
      ];
      var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
      ];
      var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        1e7,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64e6,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        243e5,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
      ];
      BN2.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
          out = "";
          var off = 0;
          var carry = 0;
          for (var i = 0; i < this.length; i++) {
            var w = this.words[i];
            var word = ((w << off | carry) & 16777215).toString(16);
            carry = w >>> 24 - off & 16777215;
            off += 2;
            if (off >= 26) {
              off -= 26;
              i--;
            }
            if (carry !== 0 || i !== this.length - 1) {
              out = zeros[6 - word.length] + word + out;
            } else {
              out = word + out;
            }
          }
          if (carry !== 0) {
            out = carry.toString(16) + out;
          }
          while (out.length % padding !== 0) {
            out = "0" + out;
          }
          if (this.negative !== 0) {
            out = "-" + out;
          }
          return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
          var groupSize = groupSizes[base];
          var groupBase = groupBases[base];
          out = "";
          var c = this.clone();
          c.negative = 0;
          while (!c.isZero()) {
            var r = c.modrn(groupBase).toString(base);
            c = c.idivn(groupBase);
            if (!c.isZero()) {
              out = zeros[groupSize - r.length] + r + out;
            } else {
              out = r + out;
            }
          }
          if (this.isZero()) {
            out = "0" + out;
          }
          while (out.length % padding !== 0) {
            out = "0" + out;
          }
          if (this.negative !== 0) {
            out = "-" + out;
          }
          return out;
        }
        assert(false, "Base should be between 2 and 36");
      };
      BN2.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) {
          ret += this.words[1] * 67108864;
        } else if (this.length === 3 && this.words[2] === 1) {
          ret += 4503599627370496 + this.words[1] * 67108864;
        } else if (this.length > 2) {
          assert(false, "Number can only safely store up to 53 bits");
        }
        return this.negative !== 0 ? -ret : ret;
      };
      BN2.prototype.toJSON = function toJSON() {
        return this.toString(16, 2);
      };
      if (Buffer2) {
        BN2.prototype.toBuffer = function toBuffer(endian, length) {
          return this.toArrayLike(Buffer2, endian, length);
        };
      }
      BN2.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
      };
      var allocate = function allocate2(ArrayType, size) {
        if (ArrayType.allocUnsafe) {
          return ArrayType.allocUnsafe(size);
        }
        return new ArrayType(size);
      };
      BN2.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        this._strip();
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        var res = allocate(ArrayType, reqLength);
        var postfix = endian === "le" ? "LE" : "BE";
        this["_toArrayLike" + postfix](res, byteLength);
        return res;
      };
      BN2.prototype._toArrayLikeLE = function _toArrayLikeLE(res, byteLength) {
        var position = 0;
        var carry = 0;
        for (var i = 0, shift = 0; i < this.length; i++) {
          var word = this.words[i] << shift | carry;
          res[position++] = word & 255;
          if (position < res.length) {
            res[position++] = word >> 8 & 255;
          }
          if (position < res.length) {
            res[position++] = word >> 16 & 255;
          }
          if (shift === 6) {
            if (position < res.length) {
              res[position++] = word >> 24 & 255;
            }
            carry = 0;
            shift = 0;
          } else {
            carry = word >>> 24;
            shift += 2;
          }
        }
        if (position < res.length) {
          res[position++] = carry;
          while (position < res.length) {
            res[position++] = 0;
          }
        }
      };
      BN2.prototype._toArrayLikeBE = function _toArrayLikeBE(res, byteLength) {
        var position = res.length - 1;
        var carry = 0;
        for (var i = 0, shift = 0; i < this.length; i++) {
          var word = this.words[i] << shift | carry;
          res[position--] = word & 255;
          if (position >= 0) {
            res[position--] = word >> 8 & 255;
          }
          if (position >= 0) {
            res[position--] = word >> 16 & 255;
          }
          if (shift === 6) {
            if (position >= 0) {
              res[position--] = word >> 24 & 255;
            }
            carry = 0;
            shift = 0;
          } else {
            carry = word >>> 24;
            shift += 2;
          }
        }
        if (position >= 0) {
          res[position--] = carry;
          while (position >= 0) {
            res[position--] = 0;
          }
        }
      };
      if (Math.clz32) {
        BN2.prototype._countBits = function _countBits(w) {
          return 32 - Math.clz32(w);
        };
      } else {
        BN2.prototype._countBits = function _countBits(w) {
          var t = w;
          var r = 0;
          if (t >= 4096) {
            r += 13;
            t >>>= 13;
          }
          if (t >= 64) {
            r += 7;
            t >>>= 7;
          }
          if (t >= 8) {
            r += 4;
            t >>>= 4;
          }
          if (t >= 2) {
            r += 2;
            t >>>= 2;
          }
          return r + t;
        };
      }
      BN2.prototype._zeroBits = function _zeroBits(w) {
        if (w === 0)
          return 26;
        var t = w;
        var r = 0;
        if ((t & 8191) === 0) {
          r += 13;
          t >>>= 13;
        }
        if ((t & 127) === 0) {
          r += 7;
          t >>>= 7;
        }
        if ((t & 15) === 0) {
          r += 4;
          t >>>= 4;
        }
        if ((t & 3) === 0) {
          r += 2;
          t >>>= 2;
        }
        if ((t & 1) === 0) {
          r++;
        }
        return r;
      };
      BN2.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
      };
      function toBitArray(num) {
        var w = new Array(num.bitLength());
        for (var bit = 0; bit < w.length; bit++) {
          var off = bit / 26 | 0;
          var wbit = bit % 26;
          w[bit] = num.words[off] >>> wbit & 1;
        }
        return w;
      }
      BN2.prototype.zeroBits = function zeroBits() {
        if (this.isZero())
          return 0;
        var r = 0;
        for (var i = 0; i < this.length; i++) {
          var b = this._zeroBits(this.words[i]);
          r += b;
          if (b !== 26)
            break;
        }
        return r;
      };
      BN2.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
      };
      BN2.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) {
          return this.abs().inotn(width).iaddn(1);
        }
        return this.clone();
      };
      BN2.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) {
          return this.notn(width).iaddn(1).ineg();
        }
        return this.clone();
      };
      BN2.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
      };
      BN2.prototype.neg = function neg() {
        return this.clone().ineg();
      };
      BN2.prototype.ineg = function ineg() {
        if (!this.isZero()) {
          this.negative ^= 1;
        }
        return this;
      };
      BN2.prototype.iuor = function iuor(num) {
        while (this.length < num.length) {
          this.words[this.length++] = 0;
        }
        for (var i = 0; i < num.length; i++) {
          this.words[i] = this.words[i] | num.words[i];
        }
        return this._strip();
      };
      BN2.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
      };
      BN2.prototype.or = function or(num) {
        if (this.length > num.length)
          return this.clone().ior(num);
        return num.clone().ior(this);
      };
      BN2.prototype.uor = function uor(num) {
        if (this.length > num.length)
          return this.clone().iuor(num);
        return num.clone().iuor(this);
      };
      BN2.prototype.iuand = function iuand(num) {
        var b;
        if (this.length > num.length) {
          b = num;
        } else {
          b = this;
        }
        for (var i = 0; i < b.length; i++) {
          this.words[i] = this.words[i] & num.words[i];
        }
        this.length = b.length;
        return this._strip();
      };
      BN2.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
      };
      BN2.prototype.and = function and(num) {
        if (this.length > num.length)
          return this.clone().iand(num);
        return num.clone().iand(this);
      };
      BN2.prototype.uand = function uand(num) {
        if (this.length > num.length)
          return this.clone().iuand(num);
        return num.clone().iuand(this);
      };
      BN2.prototype.iuxor = function iuxor(num) {
        var a;
        var b;
        if (this.length > num.length) {
          a = this;
          b = num;
        } else {
          a = num;
          b = this;
        }
        for (var i = 0; i < b.length; i++) {
          this.words[i] = a.words[i] ^ b.words[i];
        }
        if (this !== a) {
          for (; i < a.length; i++) {
            this.words[i] = a.words[i];
          }
        }
        this.length = a.length;
        return this._strip();
      };
      BN2.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
      };
      BN2.prototype.xor = function xor(num) {
        if (this.length > num.length)
          return this.clone().ixor(num);
        return num.clone().ixor(this);
      };
      BN2.prototype.uxor = function uxor(num) {
        if (this.length > num.length)
          return this.clone().iuxor(num);
        return num.clone().iuxor(this);
      };
      BN2.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        this._expand(bytesNeeded);
        if (bitsLeft > 0) {
          bytesNeeded--;
        }
        for (var i = 0; i < bytesNeeded; i++) {
          this.words[i] = ~this.words[i] & 67108863;
        }
        if (bitsLeft > 0) {
          this.words[i] = ~this.words[i] & 67108863 >> 26 - bitsLeft;
        }
        return this._strip();
      };
      BN2.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
      };
      BN2.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) {
          this.words[off] = this.words[off] | 1 << wbit;
        } else {
          this.words[off] = this.words[off] & ~(1 << wbit);
        }
        return this._strip();
      };
      BN2.prototype.iadd = function iadd(num) {
        var r;
        if (this.negative !== 0 && num.negative === 0) {
          this.negative = 0;
          r = this.isub(num);
          this.negative ^= 1;
          return this._normSign();
        } else if (this.negative === 0 && num.negative !== 0) {
          num.negative = 0;
          r = this.isub(num);
          num.negative = 1;
          return r._normSign();
        }
        var a, b;
        if (this.length > num.length) {
          a = this;
          b = num;
        } else {
          a = num;
          b = this;
        }
        var carry = 0;
        for (var i = 0; i < b.length; i++) {
          r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
          this.words[i] = r & 67108863;
          carry = r >>> 26;
        }
        for (; carry !== 0 && i < a.length; i++) {
          r = (a.words[i] | 0) + carry;
          this.words[i] = r & 67108863;
          carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
          this.words[this.length] = carry;
          this.length++;
        } else if (a !== this) {
          for (; i < a.length; i++) {
            this.words[i] = a.words[i];
          }
        }
        return this;
      };
      BN2.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
          num.negative = 0;
          res = this.sub(num);
          num.negative ^= 1;
          return res;
        } else if (num.negative === 0 && this.negative !== 0) {
          this.negative = 0;
          res = num.sub(this);
          this.negative = 1;
          return res;
        }
        if (this.length > num.length)
          return this.clone().iadd(num);
        return num.clone().iadd(this);
      };
      BN2.prototype.isub = function isub(num) {
        if (num.negative !== 0) {
          num.negative = 0;
          var r = this.iadd(num);
          num.negative = 1;
          return r._normSign();
        } else if (this.negative !== 0) {
          this.negative = 0;
          this.iadd(num);
          this.negative = 1;
          return this._normSign();
        }
        var cmp = this.cmp(num);
        if (cmp === 0) {
          this.negative = 0;
          this.length = 1;
          this.words[0] = 0;
          return this;
        }
        var a, b;
        if (cmp > 0) {
          a = this;
          b = num;
        } else {
          a = num;
          b = this;
        }
        var carry = 0;
        for (var i = 0; i < b.length; i++) {
          r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
          carry = r >> 26;
          this.words[i] = r & 67108863;
        }
        for (; carry !== 0 && i < a.length; i++) {
          r = (a.words[i] | 0) + carry;
          carry = r >> 26;
          this.words[i] = r & 67108863;
        }
        if (carry === 0 && i < a.length && a !== this) {
          for (; i < a.length; i++) {
            this.words[i] = a.words[i];
          }
        }
        this.length = Math.max(this.length, i);
        if (a !== this) {
          this.negative = 1;
        }
        return this._strip();
      };
      BN2.prototype.sub = function sub(num) {
        return this.clone().isub(num);
      };
      function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 67108863;
        var carry = r / 67108864 | 0;
        out.words[0] = lo;
        for (var k = 1; k < len; k++) {
          var ncarry = carry >>> 26;
          var rword = carry & 67108863;
          var maxJ = Math.min(k, num.length - 1);
          for (var j = Math.max(0, k - self.length + 1); j <= maxJ; j++) {
            var i = k - j | 0;
            a = self.words[i] | 0;
            b = num.words[j] | 0;
            r = a * b + rword;
            ncarry += r / 67108864 | 0;
            rword = r & 67108863;
          }
          out.words[k] = rword | 0;
          carry = ncarry | 0;
        }
        if (carry !== 0) {
          out.words[k] = carry | 0;
        } else {
          out.length--;
        }
        return out._strip();
      }
      var comb10MulTo = function comb10MulTo2(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 8191;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 8191;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 8191;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 8191;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 8191;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 8191;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 8191;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 8191;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 8191;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 8191;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 8191;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 8191;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 8191;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 8191;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 8191;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 8191;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 8191;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 8191;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 8191;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 8191;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 8191) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 67108863;
        lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 8191) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 67108863;
        lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 8191) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 67108863;
        lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 8191) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 67108863;
        lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 8191) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 67108863;
        lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 8191) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 67108863;
        lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 8191) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 67108863;
        lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 8191) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 67108863;
        lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 8191) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 67108863;
        lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 8191) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 67108863;
        lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 8191) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 67108863;
        lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 8191) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 67108863;
        lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 8191) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 67108863;
        lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 8191) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 67108863;
        lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 8191) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 67108863;
        lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 8191) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 67108863;
        lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 8191) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 67108863;
        lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 8191) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 67108863;
        lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 8191) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 67108863;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
          o[19] = c;
          out.length++;
        }
        return out;
      };
      if (!Math.imul) {
        comb10MulTo = smallMulTo;
      }
      function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for (var k = 0; k < out.length - 1; k++) {
          var ncarry = hncarry;
          hncarry = 0;
          var rword = carry & 67108863;
          var maxJ = Math.min(k, num.length - 1);
          for (var j = Math.max(0, k - self.length + 1); j <= maxJ; j++) {
            var i = k - j;
            var a = self.words[i] | 0;
            var b = num.words[j] | 0;
            var r = a * b;
            var lo = r & 67108863;
            ncarry = ncarry + (r / 67108864 | 0) | 0;
            lo = lo + rword | 0;
            rword = lo & 67108863;
            ncarry = ncarry + (lo >>> 26) | 0;
            hncarry += ncarry >>> 26;
            ncarry &= 67108863;
          }
          out.words[k] = rword;
          carry = ncarry;
          ncarry = hncarry;
        }
        if (carry !== 0) {
          out.words[k] = carry;
        } else {
          out.length--;
        }
        return out._strip();
      }
      function jumboMulTo(self, num, out) {
        return bigMulTo(self, num, out);
      }
      BN2.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) {
          res = comb10MulTo(this, num, out);
        } else if (len < 63) {
          res = smallMulTo(this, num, out);
        } else if (len < 1024) {
          res = bigMulTo(this, num, out);
        } else {
          res = jumboMulTo(this, num, out);
        }
        return res;
      };
      function FFTM(x, y) {
        this.x = x;
        this.y = y;
      }
      FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN2.prototype._countBits(N) - 1;
        for (var i = 0; i < N; i++) {
          t[i] = this.revBin(i, l, N);
        }
        return t;
      };
      FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1)
          return x;
        var rb = 0;
        for (var i = 0; i < l; i++) {
          rb |= (x & 1) << l - i - 1;
          x >>= 1;
        }
        return rb;
      };
      FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for (var i = 0; i < N; i++) {
          rtws[i] = rws[rbt[i]];
          itws[i] = iws[rbt[i]];
        }
      };
      FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for (var s = 1; s < N; s <<= 1) {
          var l = s << 1;
          var rtwdf = Math.cos(2 * Math.PI / l);
          var itwdf = Math.sin(2 * Math.PI / l);
          for (var p = 0; p < N; p += l) {
            var rtwdf_ = rtwdf;
            var itwdf_ = itwdf;
            for (var j = 0; j < s; j++) {
              var re = rtws[p + j];
              var ie = itws[p + j];
              var ro = rtws[p + j + s];
              var io = itws[p + j + s];
              var rx = rtwdf_ * ro - itwdf_ * io;
              io = rtwdf_ * io + itwdf_ * ro;
              ro = rx;
              rtws[p + j] = re + ro;
              itws[p + j] = ie + io;
              rtws[p + j + s] = re - ro;
              itws[p + j + s] = ie - io;
              if (j !== l) {
                rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                rtwdf_ = rx;
              }
            }
          }
        }
      };
      FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for (N = N / 2 | 0; N; N = N >>> 1) {
          i++;
        }
        return 1 << i + 1 + odd;
      };
      FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1)
          return;
        for (var i = 0; i < N / 2; i++) {
          var t = rws[i];
          rws[i] = rws[N - i - 1];
          rws[N - i - 1] = t;
          t = iws[i];
          iws[i] = -iws[N - i - 1];
          iws[N - i - 1] = -t;
        }
      };
      FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for (var i = 0; i < N / 2; i++) {
          var w = Math.round(ws[2 * i + 1] / N) * 8192 + Math.round(ws[2 * i] / N) + carry;
          ws[i] = w & 67108863;
          if (w < 67108864) {
            carry = 0;
          } else {
            carry = w / 67108864 | 0;
          }
        }
        return ws;
      };
      FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for (var i = 0; i < len; i++) {
          carry = carry + (ws[i] | 0);
          rws[2 * i] = carry & 8191;
          carry = carry >>> 13;
          rws[2 * i + 1] = carry & 8191;
          carry = carry >>> 13;
        }
        for (i = 2 * len; i < N; ++i) {
          rws[i] = 0;
        }
        assert(carry === 0);
        assert((carry & ~8191) === 0);
      };
      FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for (var i = 0; i < N; i++) {
          ph[i] = 0;
        }
        return ph;
      };
      FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for (var i = 0; i < N; i++) {
          var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
          iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
          rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out._strip();
      };
      BN2.prototype.mul = function mul(num) {
        var out = new BN2(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
      };
      BN2.prototype.mulf = function mulf(num) {
        var out = new BN2(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
      };
      BN2.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
      };
      BN2.prototype.imuln = function imuln(num) {
        var isNegNum = num < 0;
        if (isNegNum)
          num = -num;
        assert(typeof num === "number");
        assert(num < 67108864);
        var carry = 0;
        for (var i = 0; i < this.length; i++) {
          var w = (this.words[i] | 0) * num;
          var lo = (w & 67108863) + (carry & 67108863);
          carry >>= 26;
          carry += w / 67108864 | 0;
          carry += lo >>> 26;
          this.words[i] = lo & 67108863;
        }
        if (carry !== 0) {
          this.words[i] = carry;
          this.length++;
        }
        return isNegNum ? this.ineg() : this;
      };
      BN2.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
      };
      BN2.prototype.sqr = function sqr() {
        return this.mul(this);
      };
      BN2.prototype.isqr = function isqr() {
        return this.imul(this.clone());
      };
      BN2.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0)
          return new BN2(1);
        var res = this;
        for (var i = 0; i < w.length; i++, res = res.sqr()) {
          if (w[i] !== 0)
            break;
        }
        if (++i < w.length) {
          for (var q = res.sqr(); i < w.length; i++, q = q.sqr()) {
            if (w[i] === 0)
              continue;
            res = res.mul(q);
          }
        }
        return res;
      };
      BN2.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 67108863 >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
          var carry = 0;
          for (i = 0; i < this.length; i++) {
            var newCarry = this.words[i] & carryMask;
            var c = (this.words[i] | 0) - newCarry << r;
            this.words[i] = c | carry;
            carry = newCarry >>> 26 - r;
          }
          if (carry) {
            this.words[i] = carry;
            this.length++;
          }
        }
        if (s !== 0) {
          for (i = this.length - 1; i >= 0; i--) {
            this.words[i + s] = this.words[i];
          }
          for (i = 0; i < s; i++) {
            this.words[i] = 0;
          }
          this.length += s;
        }
        return this._strip();
      };
      BN2.prototype.ishln = function ishln(bits) {
        assert(this.negative === 0);
        return this.iushln(bits);
      };
      BN2.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) {
          h = (hint - hint % 26) / 26;
        } else {
          h = 0;
        }
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 67108863 ^ 67108863 >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        if (maskedWords) {
          for (var i = 0; i < s; i++) {
            maskedWords.words[i] = this.words[i];
          }
          maskedWords.length = s;
        }
        if (s === 0) {
        } else if (this.length > s) {
          this.length -= s;
          for (i = 0; i < this.length; i++) {
            this.words[i] = this.words[i + s];
          }
        } else {
          this.words[0] = 0;
          this.length = 1;
        }
        var carry = 0;
        for (i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--) {
          var word = this.words[i] | 0;
          this.words[i] = carry << 26 - r | word >>> r;
          carry = word & mask;
        }
        if (maskedWords && carry !== 0) {
          maskedWords.words[maskedWords.length++] = carry;
        }
        if (this.length === 0) {
          this.words[0] = 0;
          this.length = 1;
        }
        return this._strip();
      };
      BN2.prototype.ishrn = function ishrn(bits, hint, extended) {
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
      };
      BN2.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
      };
      BN2.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
      };
      BN2.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
      };
      BN2.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
      };
      BN2.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        if (this.length <= s)
          return false;
        var w = this.words[s];
        return !!(w & q);
      };
      BN2.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) {
          return this;
        }
        if (r !== 0) {
          s++;
        }
        this.length = Math.min(s, this.length);
        if (r !== 0) {
          var mask = 67108863 ^ 67108863 >>> r << r;
          this.words[this.length - 1] &= mask;
        }
        return this._strip();
      };
      BN2.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
      };
      BN2.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 67108864);
        if (num < 0)
          return this.isubn(-num);
        if (this.negative !== 0) {
          if (this.length === 1 && (this.words[0] | 0) <= num) {
            this.words[0] = num - (this.words[0] | 0);
            this.negative = 0;
            return this;
          }
          this.negative = 0;
          this.isubn(num);
          this.negative = 1;
          return this;
        }
        return this._iaddn(num);
      };
      BN2.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        for (var i = 0; i < this.length && this.words[i] >= 67108864; i++) {
          this.words[i] -= 67108864;
          if (i === this.length - 1) {
            this.words[i + 1] = 1;
          } else {
            this.words[i + 1]++;
          }
        }
        this.length = Math.max(this.length, i + 1);
        return this;
      };
      BN2.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 67108864);
        if (num < 0)
          return this.iaddn(-num);
        if (this.negative !== 0) {
          this.negative = 0;
          this.iaddn(num);
          this.negative = 1;
          return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
          this.words[0] = -this.words[0];
          this.negative = 1;
        } else {
          for (var i = 0; i < this.length && this.words[i] < 0; i++) {
            this.words[i] += 67108864;
            this.words[i + 1] -= 1;
          }
        }
        return this._strip();
      };
      BN2.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
      };
      BN2.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
      };
      BN2.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
      };
      BN2.prototype.abs = function abs() {
        return this.clone().iabs();
      };
      BN2.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for (i = 0; i < num.length; i++) {
          w = (this.words[i + shift] | 0) + carry;
          var right = (num.words[i] | 0) * mul;
          w -= right & 67108863;
          carry = (w >> 26) - (right / 67108864 | 0);
          this.words[i + shift] = w & 67108863;
        }
        for (; i < this.length - shift; i++) {
          w = (this.words[i + shift] | 0) + carry;
          carry = w >> 26;
          this.words[i + shift] = w & 67108863;
        }
        if (carry === 0)
          return this._strip();
        assert(carry === -1);
        carry = 0;
        for (i = 0; i < this.length; i++) {
          w = -(this.words[i] | 0) + carry;
          carry = w >> 26;
          this.words[i] = w & 67108863;
        }
        this.negative = 1;
        return this._strip();
      };
      BN2.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
          b = b.ushln(shift);
          a.iushln(shift);
          bhi = b.words[b.length - 1] | 0;
        }
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
          q = new BN2(null);
          q.length = m + 1;
          q.words = new Array(q.length);
          for (var i = 0; i < q.length; i++) {
            q.words[i] = 0;
          }
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
          a = diff;
          if (q) {
            q.words[m] = 1;
          }
        }
        for (var j = m - 1; j >= 0; j--) {
          var qj = (a.words[b.length + j] | 0) * 67108864 + (a.words[b.length + j - 1] | 0);
          qj = Math.min(qj / bhi | 0, 67108863);
          a._ishlnsubmul(b, qj, j);
          while (a.negative !== 0) {
            qj--;
            a.negative = 0;
            a._ishlnsubmul(b, 1, j);
            if (!a.isZero()) {
              a.negative ^= 1;
            }
          }
          if (q) {
            q.words[j] = qj;
          }
        }
        if (q) {
          q._strip();
        }
        a._strip();
        if (mode !== "div" && shift !== 0) {
          a.iushrn(shift);
        }
        return {
          div: q || null,
          mod: a
        };
      };
      BN2.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) {
          return {
            div: new BN2(0),
            mod: new BN2(0)
          };
        }
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
          res = this.neg().divmod(num, mode);
          if (mode !== "mod") {
            div = res.div.neg();
          }
          if (mode !== "div") {
            mod = res.mod.neg();
            if (positive && mod.negative !== 0) {
              mod.iadd(num);
            }
          }
          return {
            div,
            mod
          };
        }
        if (this.negative === 0 && num.negative !== 0) {
          res = this.divmod(num.neg(), mode);
          if (mode !== "mod") {
            div = res.div.neg();
          }
          return {
            div,
            mod: res.mod
          };
        }
        if ((this.negative & num.negative) !== 0) {
          res = this.neg().divmod(num.neg(), mode);
          if (mode !== "div") {
            mod = res.mod.neg();
            if (positive && mod.negative !== 0) {
              mod.isub(num);
            }
          }
          return {
            div: res.div,
            mod
          };
        }
        if (num.length > this.length || this.cmp(num) < 0) {
          return {
            div: new BN2(0),
            mod: this
          };
        }
        if (num.length === 1) {
          if (mode === "div") {
            return {
              div: this.divn(num.words[0]),
              mod: null
            };
          }
          if (mode === "mod") {
            return {
              div: null,
              mod: new BN2(this.modrn(num.words[0]))
            };
          }
          return {
            div: this.divn(num.words[0]),
            mod: new BN2(this.modrn(num.words[0]))
          };
        }
        return this._wordDiv(num, mode);
      };
      BN2.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
      };
      BN2.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
      };
      BN2.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
      };
      BN2.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        if (dm.mod.isZero())
          return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        if (cmp < 0 || r2 === 1 && cmp === 0)
          return dm.div;
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
      };
      BN2.prototype.modrn = function modrn(num) {
        var isNegNum = num < 0;
        if (isNegNum)
          num = -num;
        assert(num <= 67108863);
        var p = (1 << 26) % num;
        var acc = 0;
        for (var i = this.length - 1; i >= 0; i--) {
          acc = (p * acc + (this.words[i] | 0)) % num;
        }
        return isNegNum ? -acc : acc;
      };
      BN2.prototype.modn = function modn(num) {
        return this.modrn(num);
      };
      BN2.prototype.idivn = function idivn(num) {
        var isNegNum = num < 0;
        if (isNegNum)
          num = -num;
        assert(num <= 67108863);
        var carry = 0;
        for (var i = this.length - 1; i >= 0; i--) {
          var w = (this.words[i] | 0) + carry * 67108864;
          this.words[i] = w / num | 0;
          carry = w % num;
        }
        this._strip();
        return isNegNum ? this.ineg() : this;
      };
      BN2.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
      };
      BN2.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) {
          x = x.umod(p);
        } else {
          x = x.clone();
        }
        var A = new BN2(1);
        var B = new BN2(0);
        var C = new BN2(0);
        var D = new BN2(1);
        var g = 0;
        while (x.isEven() && y.isEven()) {
          x.iushrn(1);
          y.iushrn(1);
          ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while (!x.isZero()) {
          for (var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1)
            ;
          if (i > 0) {
            x.iushrn(i);
            while (i-- > 0) {
              if (A.isOdd() || B.isOdd()) {
                A.iadd(yp);
                B.isub(xp);
              }
              A.iushrn(1);
              B.iushrn(1);
            }
          }
          for (var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1)
            ;
          if (j > 0) {
            y.iushrn(j);
            while (j-- > 0) {
              if (C.isOdd() || D.isOdd()) {
                C.iadd(yp);
                D.isub(xp);
              }
              C.iushrn(1);
              D.iushrn(1);
            }
          }
          if (x.cmp(y) >= 0) {
            x.isub(y);
            A.isub(C);
            B.isub(D);
          } else {
            y.isub(x);
            C.isub(A);
            D.isub(B);
          }
        }
        return {
          a: C,
          b: D,
          gcd: y.iushln(g)
        };
      };
      BN2.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) {
          a = a.umod(p);
        } else {
          a = a.clone();
        }
        var x1 = new BN2(1);
        var x2 = new BN2(0);
        var delta = b.clone();
        while (a.cmpn(1) > 0 && b.cmpn(1) > 0) {
          for (var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1)
            ;
          if (i > 0) {
            a.iushrn(i);
            while (i-- > 0) {
              if (x1.isOdd()) {
                x1.iadd(delta);
              }
              x1.iushrn(1);
            }
          }
          for (var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1)
            ;
          if (j > 0) {
            b.iushrn(j);
            while (j-- > 0) {
              if (x2.isOdd()) {
                x2.iadd(delta);
              }
              x2.iushrn(1);
            }
          }
          if (a.cmp(b) >= 0) {
            a.isub(b);
            x1.isub(x2);
          } else {
            b.isub(a);
            x2.isub(x1);
          }
        }
        var res;
        if (a.cmpn(1) === 0) {
          res = x1;
        } else {
          res = x2;
        }
        if (res.cmpn(0) < 0) {
          res.iadd(p);
        }
        return res;
      };
      BN2.prototype.gcd = function gcd(num) {
        if (this.isZero())
          return num.abs();
        if (num.isZero())
          return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        for (var shift = 0; a.isEven() && b.isEven(); shift++) {
          a.iushrn(1);
          b.iushrn(1);
        }
        do {
          while (a.isEven()) {
            a.iushrn(1);
          }
          while (b.isEven()) {
            b.iushrn(1);
          }
          var r = a.cmp(b);
          if (r < 0) {
            var t = a;
            a = b;
            b = t;
          } else if (r === 0 || b.cmpn(1) === 0) {
            break;
          }
          a.isub(b);
        } while (true);
        return b.iushln(shift);
      };
      BN2.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
      };
      BN2.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
      };
      BN2.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
      };
      BN2.prototype.andln = function andln(num) {
        return this.words[0] & num;
      };
      BN2.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        if (this.length <= s) {
          this._expand(s + 1);
          this.words[s] |= q;
          return this;
        }
        var carry = q;
        for (var i = s; carry !== 0 && i < this.length; i++) {
          var w = this.words[i] | 0;
          w += carry;
          carry = w >>> 26;
          w &= 67108863;
          this.words[i] = w;
        }
        if (carry !== 0) {
          this.words[i] = carry;
          this.length++;
        }
        return this;
      };
      BN2.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
      };
      BN2.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative)
          return -1;
        if (this.negative === 0 && negative)
          return 1;
        this._strip();
        var res;
        if (this.length > 1) {
          res = 1;
        } else {
          if (negative) {
            num = -num;
          }
          assert(num <= 67108863, "Number is too big");
          var w = this.words[0] | 0;
          res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0)
          return -res | 0;
        return res;
      };
      BN2.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0)
          return -1;
        if (this.negative === 0 && num.negative !== 0)
          return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0)
          return -res | 0;
        return res;
      };
      BN2.prototype.ucmp = function ucmp(num) {
        if (this.length > num.length)
          return 1;
        if (this.length < num.length)
          return -1;
        var res = 0;
        for (var i = this.length - 1; i >= 0; i--) {
          var a = this.words[i] | 0;
          var b = num.words[i] | 0;
          if (a === b)
            continue;
          if (a < b) {
            res = -1;
          } else if (a > b) {
            res = 1;
          }
          break;
        }
        return res;
      };
      BN2.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
      };
      BN2.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
      };
      BN2.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
      };
      BN2.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
      };
      BN2.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
      };
      BN2.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
      };
      BN2.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
      };
      BN2.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
      };
      BN2.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
      };
      BN2.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
      };
      BN2.red = function red(num) {
        return new Red(num);
      };
      BN2.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
      };
      BN2.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
      };
      BN2.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
      };
      BN2.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
      };
      BN2.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
      };
      BN2.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
      };
      BN2.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
      };
      BN2.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
      };
      BN2.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
      };
      BN2.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
      };
      BN2.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
      };
      BN2.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
      };
      BN2.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
      };
      BN2.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
      };
      BN2.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
      };
      BN2.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
      };
      BN2.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
      };
      var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
      };
      function MPrime(name, p) {
        this.name = name;
        this.p = new BN2(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN2(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
      }
      MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN2(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
      };
      MPrime.prototype.ireduce = function ireduce(num) {
        var r = num;
        var rlen;
        do {
          this.split(r, this.tmp);
          r = this.imulK(r);
          r = r.iadd(this.tmp);
          rlen = r.bitLength();
        } while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
          r.words[0] = 0;
          r.length = 1;
        } else if (cmp > 0) {
          r.isub(this.p);
        } else {
          if (r.strip !== void 0) {
            r.strip();
          } else {
            r._strip();
          }
        }
        return r;
      };
      MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
      };
      MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
      };
      function K256() {
        MPrime.call(
          this,
          "k256",
          "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f"
        );
      }
      inherits(K256, MPrime);
      K256.prototype.split = function split(input, output) {
        var mask = 4194303;
        var outLen = Math.min(input.length, 9);
        for (var i = 0; i < outLen; i++) {
          output.words[i] = input.words[i];
        }
        output.length = outLen;
        if (input.length <= 9) {
          input.words[0] = 0;
          input.length = 1;
          return;
        }
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for (i = 10; i < input.length; i++) {
          var next = input.words[i] | 0;
          input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
          prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) {
          input.length -= 10;
        } else {
          input.length -= 9;
        }
      };
      K256.prototype.imulK = function imulK(num) {
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        var lo = 0;
        for (var i = 0; i < num.length; i++) {
          var w = num.words[i] | 0;
          lo += w * 977;
          num.words[i] = lo & 67108863;
          lo = w * 64 + (lo / 67108864 | 0);
        }
        if (num.words[num.length - 1] === 0) {
          num.length--;
          if (num.words[num.length - 1] === 0) {
            num.length--;
          }
        }
        return num;
      };
      function P224() {
        MPrime.call(
          this,
          "p224",
          "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001"
        );
      }
      inherits(P224, MPrime);
      function P192() {
        MPrime.call(
          this,
          "p192",
          "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff"
        );
      }
      inherits(P192, MPrime);
      function P25519() {
        MPrime.call(
          this,
          "25519",
          "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed"
        );
      }
      inherits(P25519, MPrime);
      P25519.prototype.imulK = function imulK(num) {
        var carry = 0;
        for (var i = 0; i < num.length; i++) {
          var hi = (num.words[i] | 0) * 19 + carry;
          var lo = hi & 67108863;
          hi >>>= 26;
          num.words[i] = lo;
          carry = hi;
        }
        if (carry !== 0) {
          num.words[num.length++] = carry;
        }
        return num;
      };
      BN2._prime = function prime(name) {
        if (primes[name])
          return primes[name];
        var prime2;
        if (name === "k256") {
          prime2 = new K256();
        } else if (name === "p224") {
          prime2 = new P224();
        } else if (name === "p192") {
          prime2 = new P192();
        } else if (name === "p25519") {
          prime2 = new P25519();
        } else {
          throw new Error("Unknown prime " + name);
        }
        primes[name] = prime2;
        return prime2;
      };
      function Red(m) {
        if (typeof m === "string") {
          var prime = BN2._prime(m);
          this.m = prime.p;
          this.prime = prime;
        } else {
          assert(m.gtn(1), "modulus must be greater than 1");
          this.m = m;
          this.prime = null;
        }
      }
      Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
      };
      Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(
          a.red && a.red === b.red,
          "red works only with red numbers"
        );
      };
      Red.prototype.imod = function imod(a) {
        if (this.prime)
          return this.prime.ireduce(a)._forceRed(this);
        move(a, a.umod(this.m)._forceRed(this));
        return a;
      };
      Red.prototype.neg = function neg(a) {
        if (a.isZero()) {
          return a.clone();
        }
        return this.m.sub(a)._forceRed(this);
      };
      Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) {
          res.isub(this.m);
        }
        return res._forceRed(this);
      };
      Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) {
          res.isub(this.m);
        }
        return res;
      };
      Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) {
          res.iadd(this.m);
        }
        return res._forceRed(this);
      };
      Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) {
          res.iadd(this.m);
        }
        return res;
      };
      Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
      };
      Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
      };
      Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
      };
      Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
      };
      Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
      };
      Red.prototype.sqrt = function sqrt2(a) {
        if (a.isZero())
          return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        if (mod3 === 3) {
          var pow = this.m.add(new BN2(1)).iushrn(2);
          return this.pow(a, pow);
        }
        var q = this.m.subn(1);
        var s = 0;
        while (!q.isZero() && q.andln(1) === 0) {
          s++;
          q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN2(1).toRed(this);
        var nOne = one.redNeg();
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN2(2 * z * z).toRed(this);
        while (this.pow(z, lpow).cmp(nOne) !== 0) {
          z.redIAdd(nOne);
        }
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while (t.cmp(one) !== 0) {
          var tmp = t;
          for (var i = 0; tmp.cmp(one) !== 0; i++) {
            tmp = tmp.redSqr();
          }
          assert(i < m);
          var b = this.pow(c, new BN2(1).iushln(m - i - 1));
          r = r.redMul(b);
          c = b.redSqr();
          t = t.redMul(c);
          m = i;
        }
        return r;
      };
      Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
          inv.negative = 0;
          return this.imod(inv).redNeg();
        } else {
          return this.imod(inv);
        }
      };
      Red.prototype.pow = function pow(a, num) {
        if (num.isZero())
          return new BN2(1).toRed(this);
        if (num.cmpn(1) === 0)
          return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN2(1).toRed(this);
        wnd[1] = a;
        for (var i = 2; i < wnd.length; i++) {
          wnd[i] = this.mul(wnd[i - 1], a);
        }
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) {
          start = 26;
        }
        for (i = num.length - 1; i >= 0; i--) {
          var word = num.words[i];
          for (var j = start - 1; j >= 0; j--) {
            var bit = word >> j & 1;
            if (res !== wnd[0]) {
              res = this.sqr(res);
            }
            if (bit === 0 && current === 0) {
              currentLen = 0;
              continue;
            }
            current <<= 1;
            current |= bit;
            currentLen++;
            if (currentLen !== windowSize && (i !== 0 || j !== 0))
              continue;
            res = this.mul(res, wnd[current]);
            currentLen = 0;
            current = 0;
          }
          start = 26;
        }
        return res;
      };
      Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
      };
      Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
      };
      BN2.mont = function mont(num) {
        return new Mont(num);
      };
      function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) {
          this.shift += 26 - this.shift % 26;
        }
        this.r = new BN2(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
      }
      inherits(Mont, Red);
      Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
      };
      Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
      };
      Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
          a.words[0] = 0;
          a.length = 1;
          return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) {
          res = u.isub(this.m);
        } else if (u.cmpn(0) < 0) {
          res = u.iadd(this.m);
        }
        return res._forceRed(this);
      };
      Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero())
          return new BN2(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) {
          res = u.isub(this.m);
        } else if (u.cmpn(0) < 0) {
          res = u.iadd(this.m);
        }
        return res._forceRed(this);
      };
      Mont.prototype.invm = function invm(a) {
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
      };
    })(typeof module === "undefined" || module, exports);
  }
});

// src/entities/Amount.ts
import invariant3 from "tiny-invariant";

// src/utils/Big.ts
import Big from "big.js";
import toFormat from "toformat";
Big.strict = true;
var Big_default = toFormat(Big);

// src/utils/Decimal.ts
import Decimal from "decimal.js-light";
import toFormat2 from "toformat";
var Decimal_default = toFormat2(Decimal);

// src/utils/index.ts
import { default as default2 } from "jsbi";

// src/constants/numbers.ts
import JSBI3 from "jsbi";

// src/functions/percent.ts
import numeral from "numeral";
var formatPercent = (value) => {
  if (value < 1e-3) {
    return "0.00%";
  }
  return numeral(value).format("0.00%");
};

// src/entities/Percent.ts
import JSBI2 from "jsbi";

// src/entities/Fraction.ts
import JSBI from "jsbi";
import invariant from "tiny-invariant";

// src/enums/Rounding.ts
var Rounding = /* @__PURE__ */ ((Rounding2) => {
  Rounding2[Rounding2["ROUND_DOWN"] = 0] = "ROUND_DOWN";
  Rounding2[Rounding2["ROUND_HALF_UP"] = 1] = "ROUND_HALF_UP";
  Rounding2[Rounding2["ROUND_UP"] = 3] = "ROUND_UP";
  return Rounding2;
})(Rounding || {});
var Rounding_default = Rounding;

// src/entities/Fraction.ts
var toSignificantRounding = {
  [Rounding_default.ROUND_DOWN]: Decimal_default.ROUND_DOWN,
  [Rounding_default.ROUND_HALF_UP]: Decimal_default.ROUND_HALF_UP,
  [Rounding_default.ROUND_UP]: Decimal_default.ROUND_UP
};
var toFixedRounding = {
  [Rounding_default.ROUND_DOWN]: Big_default.roundDown,
  [Rounding_default.ROUND_HALF_UP]: Big_default.roundHalfUp,
  [Rounding_default.ROUND_UP]: Big_default.roundUp
};
var Fraction = class {
  /**
   * @param {BigintIsh}numerator
   * @param {BigintIsh}denominator
   */
  constructor(numerator, denominator = JSBI.BigInt(1)) {
    this.numerator = JSBI.BigInt(numerator);
    this.denominator = JSBI.BigInt(denominator);
  }
  /**
   * @param {BigintIsh | Fraction}fractionish
   * @return {Fraction}
   */
  static tryParseFraction(fractionish) {
    if (fractionish instanceof JSBI || typeof fractionish === "number" || typeof fractionish === "string")
      return new Fraction(fractionish);
    if ("numerator" in fractionish && "denominator" in fractionish)
      return fractionish;
    throw new Error("Could not parse fraction");
  }
  /** performs floor division */
  get quotient() {
    return JSBI.divide(this.numerator, this.denominator);
  }
  /** remainder after floor division*/
  get remainder() {
    return new Fraction(JSBI.remainder(this.numerator, this.denominator), this.denominator);
  }
  /**
   * @return{Fraction}
   */
  invert() {
    return new Fraction(this.denominator, this.numerator);
  }
  /**
   * @param {Fraction | BigintIsh}other
   * @return {Fraction}
   */
  add(other) {
    const otherParsed = Fraction.tryParseFraction(other);
    if (JSBI.equal(this.denominator, otherParsed.denominator)) {
      return new Fraction(JSBI.add(this.numerator, otherParsed.numerator), this.denominator);
    }
    return new Fraction(
      JSBI.add(
        JSBI.multiply(this.numerator, otherParsed.denominator),
        JSBI.multiply(otherParsed.numerator, this.denominator)
      ),
      JSBI.multiply(this.denominator, otherParsed.denominator)
    );
  }
  /**
   * @param {Fraction | BigintIsh}other
   * @return {Fraction}
   */
  subtract(other) {
    const otherParsed = Fraction.tryParseFraction(other);
    if (JSBI.equal(this.denominator, otherParsed.denominator)) {
      return new Fraction(JSBI.subtract(this.numerator, otherParsed.numerator), this.denominator);
    }
    return new Fraction(
      JSBI.subtract(
        JSBI.multiply(this.numerator, otherParsed.denominator),
        JSBI.multiply(otherParsed.numerator, this.denominator)
      ),
      JSBI.multiply(this.denominator, otherParsed.denominator)
    );
  }
  /**
   * @param {Fraction | BigintIsh}other
   * @return {boolean}
   */
  lessThan(other) {
    const otherParsed = Fraction.tryParseFraction(other);
    return JSBI.lessThan(
      JSBI.multiply(this.numerator, otherParsed.denominator),
      JSBI.multiply(otherParsed.numerator, this.denominator)
    );
  }
  /**
   * @param {Fraction | BigintIsh}other
   * @return {boolean}
   */
  equalTo(other) {
    const otherParsed = Fraction.tryParseFraction(other);
    return JSBI.equal(
      JSBI.multiply(this.numerator, otherParsed.denominator),
      JSBI.multiply(otherParsed.numerator, this.denominator)
    );
  }
  /**
   * @param {Fraction | BigintIsh}other
   * @return {boolean}
   */
  greaterThan(other) {
    const otherParsed = Fraction.tryParseFraction(other);
    return JSBI.greaterThan(
      JSBI.multiply(this.numerator, otherParsed.denominator),
      JSBI.multiply(otherParsed.numerator, this.denominator)
    );
  }
  /**
   * @param {Fraction | BigintIsh}other
   * @return {Fraction}
   */
  multiply(other) {
    const otherParsed = Fraction.tryParseFraction(other);
    return new Fraction(
      JSBI.multiply(this.numerator, otherParsed.numerator),
      JSBI.multiply(this.denominator, otherParsed.denominator)
    );
  }
  /**
   * @param {Fraction | BigintIsh}other
   * @return {Fraction}
   */
  divide(other) {
    const otherParsed = Fraction.tryParseFraction(other);
    return new Fraction(
      JSBI.multiply(this.numerator, otherParsed.denominator),
      JSBI.multiply(this.denominator, otherParsed.numerator)
    );
  }
  /**
   * @param {number}significantDigits
   * @param {object} format
   * @param {Rounding}rounding
   * @return {string}
   */
  toSignificant(significantDigits, format = { groupSeparator: "" }, rounding = Rounding_default.ROUND_HALF_UP) {
    invariant(Number.isInteger(significantDigits), `${significantDigits} is not an integer.`);
    invariant(significantDigits > 0, `${significantDigits} is not positive.`);
    Decimal_default.set({
      precision: significantDigits + 1,
      rounding: toSignificantRounding[rounding]
    });
    const quotient = new Decimal_default(this.numerator.toString()).div(this.denominator.toString()).toSignificantDigits(significantDigits);
    return quotient.toFormat(quotient.decimalPlaces(), format);
  }
  /**
   * @param {number}decimalPlaces
   * @param {object} format
   * @param {Rounding}rounding
   * @return {string}
   */
  toFixed(decimalPlaces, format = { groupSeparator: "" }, rounding = Rounding_default.ROUND_HALF_UP) {
    invariant(Number.isInteger(decimalPlaces), `${decimalPlaces} is not an integer.`);
    invariant(decimalPlaces >= 0, `${decimalPlaces} is negative.`);
    Big_default.DP = decimalPlaces;
    Big_default.RM = toFixedRounding[rounding];
    return new Big_default(this.numerator.toString()).div(this.denominator.toString()).toFormat(decimalPlaces, format);
  }
  /**
   * Helper method for converting any super class back to a fraction
   */
  get asFraction() {
    return new Fraction(this.numerator, this.denominator);
  }
};
var Fraction_default = Fraction;

// src/entities/Percent.ts
var ONE_HUNDRED = new Fraction_default(JSBI2.BigInt(100));
function toPercent(fraction) {
  return new Percent(fraction.numerator, fraction.denominator);
}
var Percent = class extends Fraction_default {
  constructor() {
    super(...arguments);
    /**
     * This boolean prevents a fraction from being interpreted as a Percent
     */
    this.isPercent = true;
  }
  /**
   * @param {Fraction | BigintIsh}other
   * @return {Percent}
   */
  add(other) {
    return toPercent(super.add(other));
  }
  /**
   * @param {Fraction | BigintIsh}other
   * @return {Percent}
   */
  subtract(other) {
    return toPercent(super.subtract(other));
  }
  /**
   * @param {Fraction | BigintIsh}other
   * @return {Percent}
   */
  multiply(other) {
    return toPercent(super.multiply(other));
  }
  /**
   * @param {Fraction | BigintIsh}other
   * @return {Percent}
   */
  divide(other) {
    return toPercent(super.divide(other));
  }
  /**
   * @param {number}significantDigits
   * @param {object}format
   * @param {Rounding}rounding
   * @return {string}
   */
  toSignificant(significantDigits = 5, format, rounding) {
    return super.multiply(ONE_HUNDRED).toSignificant(significantDigits, format, rounding);
  }
  /**
   * @param {number}decimalPlaces
   * @param {object}format
   * @param {Rounding}rounding
   * @return {string}
   */
  toFixed(decimalPlaces = 2, format, rounding) {
    return super.multiply(ONE_HUNDRED).toFixed(decimalPlaces, format, rounding);
  }
  /**
   * @param {number} decimalPlaces
   * @return {string}
   */
  toPercentageString(decimalPlaces = 2) {
    return formatPercent(super.toFixed(decimalPlaces + 2));
  }
};
var Percent_default = Percent;

// src/constants/numbers.ts
var ZERO = JSBI3.BigInt(0);
var ONE = JSBI3.BigInt(1);
var TWO = JSBI3.BigInt(2);
var THREE = JSBI3.BigInt(3);
var FIVE = JSBI3.BigInt(5);
var TEN = JSBI3.BigInt(10);
var _100 = JSBI3.BigInt(100);
var _997 = JSBI3.BigInt(997);
var _1000 = JSBI3.BigInt(1e3);
var _9994 = JSBI3.BigInt(9994);
var _9995 = JSBI3.BigInt(9995);
var _10000 = JSBI3.BigInt(1e4);
var _1e18 = JSBI3.BigInt(1e18);
var _1e12 = JSBI3.BigInt(1e12);
var _1e9 = JSBI3.BigInt(1e9);
var _1e6 = JSBI3.BigInt(1e6);
var MAX_SAFE_INTEGER = JSBI3.BigInt(Number.MAX_SAFE_INTEGER);
var MAX_UINT256 = JSBI3.BigInt(
  "0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff"
);
var MAX_UINT128 = JSBI3.subtract(
  JSBI3.exponentiate(JSBI3.BigInt("2"), JSBI3.BigInt(128)),
  JSBI3.BigInt(1)
);
var ZERO_PERCENT = new Percent_default(0);

// src/entities/Share.ts
import invariant2 from "tiny-invariant";
var Share = class extends Fraction_default {
  /**
   * @param {T}currency
   * @param {BigintIsh}numerator
   * @param {BigintIsh}denominator
   */
  constructor(currency, numerator, denominator) {
    super(numerator, denominator);
    invariant2(default2.lessThanOrEqual(this.quotient, MAX_UINT128), "SHARE");
    this.currency = currency;
    this.scale = default2.exponentiate(default2.BigInt(10), default2.BigInt(currency.decimals));
  }
  /**
   * @param {T}currency
   * @param {BigintIsh}rawShare
   * @return {Share<T>}
   */
  static fromRawShare(currency, rawShare = 0) {
    return new Share(currency, rawShare);
  }
  /**
   * @param {JSBI}rebase
   * @param {noolean}roundUp
   * @return {Amount<T>}
   */
  toAmount(rebase, roundUp = false) {
    if (default2.EQ(rebase.base, ZERO))
      return Amount.fromRawAmount(this.currency, this.quotient);
    const elastic = default2.divide(default2.multiply(this.quotient, rebase.elastic), rebase.base);
    if (roundUp && default2.LT(default2.divide(default2.multiply(elastic, rebase.base), rebase.elastic), this.quotient)) {
      return Amount.fromRawAmount(this.currency, default2.add(elastic, default2.BigInt(1)));
    }
    return Amount.fromRawAmount(this.currency, elastic);
  }
  /**
   * Construct a currency share with a denominator that is not equal to 1
   * @param {T}currency the currency
   * @param {BigintIsh}numerator the numerator of the fractional token share
   * @param {BigintIsh}denominator the denominator of the fractional token share
   * @return {Share<T>}
   */
  static fromFractionalShare(currency, numerator, denominator) {
    return new Share(currency, numerator, denominator);
  }
  /**
   * @param {Share<T>}other
   * @return {Share<T>}
   */
  add(other) {
    invariant2(this.currency.equals(other.currency), "CURRENCY");
    const added = super.add(other);
    return Share.fromFractionalShare(this.currency, added.numerator, added.denominator);
  }
  /**
   * @param {Share<T>}other
   * @return {Share<T>}
   */
  subtract(other) {
    invariant2(this.currency.equals(other.currency), "CURRENCY");
    const subtracted = super.subtract(other);
    return Share.fromFractionalShare(this.currency, subtracted.numerator, subtracted.denominator);
  }
  /**
   * @param {Fraction | BigintIsh}other
   * @return {Share<T>}
   */
  multiply(other) {
    const multiplied = super.multiply(other);
    return Share.fromFractionalShare(this.currency, multiplied.numerator, multiplied.denominator);
  }
  /**
   * @param {Fraction | BigintIsh}other
   * @return {Share<T>}
   */
  divide(other) {
    const divided = super.divide(other);
    return Share.fromFractionalShare(this.currency, divided.numerator, divided.denominator);
  }
  /**
   * @param {number}significantDigits
   * @param {object}format
   * @param {Rounding}rounding
   * @return {string}
   */
  toSignificant(significantDigits = 6, format, rounding = Rounding_default.ROUND_DOWN) {
    return super.divide(this.scale).toSignificant(significantDigits, format, rounding);
  }
  /**
   * @param {number}decimalPlaces
   * @param {object}format
   * @param {Rounding}rounding
   * @return {string}
   */
  toFixed(decimalPlaces = this.currency.decimals, format, rounding = Rounding_default.ROUND_DOWN) {
    invariant2(decimalPlaces <= this.currency.decimals, "DECIMALS");
    return super.divide(this.scale).toFixed(decimalPlaces, format, rounding);
  }
  /**
   * @param {object}format
   * @return {string}
   */
  toExact(format = { groupSeparator: "" }) {
    Big_default.DP = this.currency.decimals;
    return new Big_default(this.quotient.toString()).div(this.scale.toString()).toFormat(format);
  }
};

// src/entities/Amount.ts
var Amount = class extends Fraction_default {
  /**
   * @param {T}currency
   * @param {BigintIsh}numerator
   * @param {BigintIsh}denominator
   */
  constructor(currency, numerator, denominator) {
    super(numerator, denominator);
    invariant3(default2.lessThanOrEqual(this.quotient, MAX_UINT256), "AMOUNT");
    this.currency = currency;
    this.scale = default2.exponentiate(default2.BigInt(10), default2.BigInt(currency.decimals));
  }
  /**
   * Returns a new currency amount instance from the unitless amount of token, i.e. the raw amount
   * @param {T}currency the currency in the amount
   * @param {BigintIsh}rawAmount the raw token or ether amount
   * @return {Amount<T>}
   */
  static fromRawAmount(currency, rawAmount) {
    return new Amount(currency, rawAmount);
  }
  /**
   * @param {T} currency
   * @param {BigintIsh} shares
   * @param {object} rebase
   * @param {boolean} roundUp
   * @return {Amount<T>}
   */
  static fromShare(currency, shares, rebase, roundUp = false) {
    if (default2.EQ(rebase.base, ZERO))
      return new Amount(currency, shares);
    const elastic = default2.divide(default2.multiply(default2.BigInt(shares), rebase.elastic), rebase.base);
    if (roundUp && default2.LT(default2.divide(default2.multiply(elastic, rebase.base), rebase.elastic), default2.BigInt(shares))) {
      return new Amount(currency, default2.add(elastic, default2.BigInt(1)));
    }
    return new Amount(currency, elastic);
  }
  /**
   * @param {object}rebase
   * @param {boolean}roundUp
   * @return {Share<T>}
   */
  toShare(rebase, roundUp = false) {
    if (default2.EQ(rebase.elastic, ZERO))
      return Share.fromRawShare(this.currency, this.quotient);
    const base = default2.divide(default2.multiply(this.quotient, rebase.base), rebase.elastic);
    if (roundUp && default2.LT(default2.divide(default2.multiply(base, rebase.elastic), rebase.base), this.quotient)) {
      return Share.fromRawShare(this.currency, default2.add(base, default2.BigInt(1)));
    }
    return Share.fromRawShare(this.currency, base);
  }
  /**
   * Construct a currency amount with a denominator that is not equal to 1
   * @param {T}currency the currency
   * @param {BigintIsh}numerator the numerator of the fractional token amount
   * @param {BigintIsh}denominator the denominator of the fractional token amount
   * @return {Amount<T>}
   */
  static fromFractionalAmount(currency, numerator, denominator) {
    return new Amount(currency, numerator, denominator);
  }
  /**
   * @param {Amount<T>} other
   * @return {Amount<T>}
   */
  add(other) {
    invariant3(this.currency.equals(other.currency), "CURRENCY");
    const added = super.add(other);
    return Amount.fromFractionalAmount(this.currency, added.numerator, added.denominator);
  }
  /**
   * @param {Amount<T>} other
   * @return {Amount<T>}
   */
  subtract(other) {
    invariant3(this.currency.equals(other.currency), "CURRENCY");
    const subtracted = super.subtract(other);
    return Amount.fromFractionalAmount(this.currency, subtracted.numerator, subtracted.denominator);
  }
  /**
   * @param {Fraction | BigintIsh} other
   * @return {Amount<T>}
   */
  multiply(other) {
    const multiplied = super.multiply(other);
    return Amount.fromFractionalAmount(this.currency, multiplied.numerator, multiplied.denominator);
  }
  /**
   * @param {Fraction | BigintIsh} other
   * @return {Amount<T>}
   */
  divide(other) {
    const divided = super.divide(other);
    return Amount.fromFractionalAmount(this.currency, divided.numerator, divided.denominator);
  }
  /**
   * @param {number}significantDigits
   * @param {object}format
   * @param {Rounding}rounding
   * @return {string}
   */
  toSignificant(significantDigits = 6, format, rounding = Rounding_default.ROUND_DOWN) {
    return super.divide(this.scale).toSignificant(significantDigits, format, rounding);
  }
  /**
   * @param {number}decimalPlaces
   * @param {object}format
   * @param {Rounding}rounding
   * @return {string}
   */
  toFixed(decimalPlaces = this.currency.decimals, format, rounding = Rounding_default.ROUND_DOWN) {
    invariant3(decimalPlaces <= this.currency.decimals, "DECIMALS");
    return super.divide(this.scale).toFixed(decimalPlaces, format, rounding);
  }
  /**
   * @return {string}
   */
  toHex() {
    return `0x${this.quotient.toString(16)}`;
  }
  /**
   * @param {object}format
   * @return {string}
   */
  toExact(format = { groupSeparator: "" }) {
    Big_default.DP = this.currency.decimals;
    return new Big_default(this.quotient.toString()).div(this.scale.toString()).toFormat(format);
  }
  /**
   */
  get wrapped() {
    if (this.currency.isToken)
      return this;
    return Amount.fromFractionalAmount(this.currency.wrapped, this.numerator, this.denominator);
  }
};

// src/enums/ChainId.ts
var ChainId = /* @__PURE__ */ ((ChainId2) => {
  ChainId2[ChainId2["SMARTBCH"] = 1e4] = "SMARTBCH";
  ChainId2[ChainId2["SMARTBCH_TESTNET"] = 10001] = "SMARTBCH_TESTNET";
  ChainId2[ChainId2["BSC"] = 56] = "BSC";
  ChainId2[ChainId2["BSC_TESTNET"] = 97] = "BSC_TESTNET";
  return ChainId2;
})(ChainId || {});
var ChainId_default = ChainId;

// src/entities/Chain.ts
var Chain = class {
  /**
   * @param {number}chainId
   * @return {object}
   */
  static from(chainId) {
    return chains[chainId];
  }
  /**
   * @param {string}shortName
   * @return {object} Shortname
   */
  static fromShortName(shortName) {
    return chains[chainShortName[shortName]];
  }
  /**
   * @param {number}chainId
   * @return {object}
   */
  static fromChainId(chainId) {
    return chains[chainId];
  }
  /**
   * @param {Chain}data
   */
  constructor(data) {
    Object.assign(this, data);
  }
  /**
   * @param {string}txHash
   * @return {string} Explorer URL
   */
  getTxUrl(txHash) {
    if (!this.blockExplorers)
      return "";
    for (const explorer of this.blockExplorers.default.url) {
      return `${explorer}/tx/${txHash}`;
    }
    return "";
  }
  /**
   * @param {string}blockHashOrHeight
   * @return {string} Explorer URL
   */
  getBlockUrl(blockHashOrHeight) {
    if (!this.blockExplorers)
      return "";
    for (const explorer of this.blockExplorers.default.url) {
      return `${explorer}/block/${blockHashOrHeight}`;
    }
    return "";
  }
  /**
   * @param {string}tokenAddress
   * @return {string} Explorer URL
   */
  getTokenUrl(tokenAddress) {
    if (!this.blockExplorers)
      return "";
    for (const explorer of this.blockExplorers.default.url) {
      return `${explorer}/token/${tokenAddress}`;
    }
    return "";
  }
  /**
   * @param {string} accountAddress
   * @return {string} Explorer URL
   */
  getAccountUrl(accountAddress) {
    if (!this.blockExplorers)
      return "";
    for (const explorer of this.blockExplorers.default.url) {
      return `${explorer}/address/${accountAddress}`;
    }
    return "";
  }
};

// src/constants/chains.json
var chains_default = [
  {
    id: 56,
    name: "Binance Smart Chain Mainnet",
    network: "BSC",
    rpcUrls: {
      default: {
        http: [
          "https://bsc-dataseed1.binance.org",
          "https://bsc-dataseed2.binance.org",
          "https://bsc-dataseed3.binance.org",
          "https://bsc-dataseed4.binance.org",
          "https://bsc-dataseed1.defibit.io",
          "https://bsc-dataseed2.defibit.io",
          "https://bsc-dataseed3.defibit.io",
          "https://bsc-dataseed4.defibit.io",
          "https://bsc-dataseed1.ninicoin.io",
          "https://bsc-dataseed2.ninicoin.io",
          "https://bsc-dataseed3.ninicoin.io",
          "https://bsc-dataseed4.ninicoin.io"
        ],
        wss: ["wss://bsc-ws-node.nariox.org"]
      },
      public: {
        http: [
          "https://bsc-dataseed1.binance.org",
          "https://bsc-dataseed2.binance.org",
          "https://bsc-dataseed3.binance.org",
          "https://bsc-dataseed4.binance.org",
          "https://bsc-dataseed1.defibit.io",
          "https://bsc-dataseed2.defibit.io",
          "https://bsc-dataseed3.defibit.io",
          "https://bsc-dataseed4.defibit.io",
          "https://bsc-dataseed1.ninicoin.io",
          "https://bsc-dataseed2.ninicoin.io",
          "https://bsc-dataseed3.ninicoin.io",
          "https://bsc-dataseed4.ninicoin.io"
        ],
        wss: ["wss://bsc-ws-node.nariox.org"]
      }
    },
    nativeCurrency: { name: "Binance Chain Native Token", symbol: "BNB", decimals: 18 },
    faucets: ["https://free-online-app.com/faucet-for-eth-evm-chains/"],
    infoURL: "https://www.binance.org",
    shortName: "BSC",
    blockExplorers: {
      default: {
        name: "bscscan",
        url: "https://bscscan.com"
      }
    }
  },
  {
    id: 97,
    name: "Binance Smart Chain Testnet",
    network: "BSC",
    rpcUrls: {
      default: {
        http: [
          "https://data-seed-prebsc-1-s1.binance.org:8545",
          "https://data-seed-prebsc-2-s1.binance.org:8545",
          "https://data-seed-prebsc-1-s2.binance.org:8545",
          "https://data-seed-prebsc-2-s2.binance.org:8545",
          "https://data-seed-prebsc-1-s3.binance.org:8545",
          "https://data-seed-prebsc-2-s3.binance.org:8545"
        ]
      },
      public: {
        http: [
          "https://data-seed-prebsc-1-s1.binance.org:8545",
          "https://data-seed-prebsc-2-s1.binance.org:8545",
          "https://data-seed-prebsc-1-s2.binance.org:8545",
          "https://data-seed-prebsc-2-s2.binance.org:8545",
          "https://data-seed-prebsc-1-s3.binance.org:8545",
          "https://data-seed-prebsc-2-s3.binance.org:8545"
        ]
      }
    },
    nativeCurrency: { name: "Binance Chain Native Token", symbol: "tBNB", decimals: 18 },
    shortName: "BSC Testnet",
    blockExplorers: {
      default: {
        name: "bscscan",
        url: "https://testnet.bscscan.com"
      }
    },
    faucets: ["https://testnet.binance.org/faucet-smart"],
    infoURL: "https://testnet.binance.org/"
  },
  {
    id: 568,
    name: "Dogechain Testnet",
    network: "DC",
    rpcUrls: {
      default: {
        http: ["https://rpc-testnet.dogechain.dog"]
      },
      public: {
        http: ["https://rpc-testnet.dogechain.dog"]
      }
    },
    nativeCurrency: { name: "Dogecoin", symbol: "DOGE", decimals: 18 },
    faucets: ["https://faucet.dogechain.dog"],
    infoURL: "https://dogechain.dog",
    shortName: "dct",
    blockExplorers: {
      default: {
        name: "Doge Explorer",
        url: "https://explorer-testnet.dogechain.dog"
      }
    }
  },
  {
    id: 2e3,
    name: "Dogechain Mainnet",
    network: "DC",
    icon: "dogechain",
    rpcUrls: {
      default: {
        http: [
          "https://rpc-sg.dogechain.dog",
          "https://rpc-us.dogechain.dog",
          "https://rpc.dogechain.dog",
          "https://rpc01-sg.dogechain.dog",
          "https://rpc02-sg.dogechain.dog",
          "https://rpc03-sg.dogechain.dog"
        ]
      },
      public: {
        http: [
          "https://rpc-sg.dogechain.dog",
          "https://rpc-us.dogechain.dog",
          "https://rpc.dogechain.dog",
          "https://rpc01-sg.dogechain.dog",
          "https://rpc02-sg.dogechain.dog",
          "https://rpc03-sg.dogechain.dog"
        ]
      }
    },
    nativeCurrency: { name: "Dogecoin", symbol: "DOGE", decimals: 18 },
    faucets: [],
    infoURL: "https://dogechain.dog",
    shortName: "dc",
    blockExplorers: {
      default: {
        name: "Doge Explorer",
        url: "https://explorer.dogechain.dog"
      }
    }
  },
  {
    id: 1e4,
    chainId: 1e4,
    name: "smartBCH",
    network: "smartBCH",
    rpcUrls: {
      default: {
        http: [
          "https://smartbch.greyh.at",
          "https://global.uat.cash",
          "https://rpc-mainnet.smartbch.org",
          "https://smartbch.fountainhead.cash/mainnet",
          "https://smartbch.devops.cash/mainnet",
          "https://rpc.uatvo.com"
        ]
      },
      public: {
        http: [
          "https://smartbch.fountainhead.cash/mainnet",
          "https://smartbch.devops.cash/mainnet",
          "https://rpc.uatvo.com",
          "https://smartbch.greyh.at",
          "https://global.uat.cash",
          "https://rpc-mainnet.smartbch.org"
        ]
      }
    },
    contracts: {
      multicall3: {
        address: "0x531fCcA0aE03f8fA31475920556d59392e9ea000",
        blockCreated: 10751405
      }
    },
    nativeCurrency: { name: "Bitcoin Cash", symbol: "BCH", decimals: 18 },
    faucets: [],
    infoURL: "https://smartbch.org/",
    shortName: "smartBCH",
    blockExplorers: {
      default: {
        name: "sonar",
        url: "https://sonar.cash"
      }
    }
  },
  {
    id: 10001,
    chainId: 10001,
    name: "smartBCH Amber",
    network: "smartBCHTest",
    rpcUrls: {
      default: {
        http: ["https://rpc-testnet.smartbch.org", "https://smartbch.devops.cash/testnet"]
      },
      public: {
        http: ["https://rpc-testnet.smartbch.org", "https://smartbch.devops.cash/testnet"]
      }
    },
    contracts: {
      multicall3: {
        address: "0x1b0Ff51BD7B3461E9A960a45318b5E063c4A22cb",
        blockCreated: 11145844
      }
    },
    nativeCurrency: { name: "Bitcoin Cash Test Token", symbol: "BCHT", decimals: 18 },
    faucets: [],
    infoURL: "http://smartbch.org/",
    shortName: "smartBCH Amber",
    blockExplorers: {
      default: {
        name: "sonar",
        url: "https://testnet.sonar.cash"
      }
    }
  }
];

// src/constants/chain.ts
var SUPPORTED_CHAIN_IDS = [
  ChainId_default.SMARTBCH,
  ChainId_default.SMARTBCH_TESTNET,
  ChainId_default.BSC,
  ChainId_default.BSC_TESTNET
];
var BLOCK_DELAY = {
  [ChainId_default.BSC]: 7500,
  [ChainId_default.BSC_TESTNET]: 7500,
  [ChainId_default.SMARTBCH]: 0,
  [ChainId_default.SMARTBCH_TESTNET]: 0
};
var CHAINS = chains_default;
var chainIds = CHAINS.map((chain) => chain.id);
var chainShortNameToChainId = Object.fromEntries(
  CHAINS.map((data) => [data.shortName, data.id])
);
var chainShortName = Object.fromEntries(
  CHAINS.map((data) => [data.id, data.shortName])
);
var chainName = Object.fromEntries(
  CHAINS.map((data) => [data.id, data.name])
);
var chains = Object.fromEntries(
  CHAINS.map((data) => [data.id, new Chain(data)])
);

// src/entities/Native.ts
import invariant7 from "tiny-invariant";

// src/functions/sqrt.ts
import invariant4 from "tiny-invariant";
function sqrt(value) {
  invariant4(default2.greaterThanOrEqual(value, ZERO), "NEGATIVE");
  if (default2.lessThan(value, MAX_SAFE_INTEGER)) {
    return default2.BigInt(Math.floor(Math.sqrt(default2.toNumber(value))));
  }
  let z;
  let x;
  z = value;
  x = default2.add(default2.divide(value, TWO), ONE);
  while (default2.lessThan(x, z)) {
    z = x;
    x = default2.divide(default2.add(default2.divide(value, x), x), TWO);
  }
  return z;
}

// src/entities/Token.ts
import { getAddress } from "@ethersproject/address";
import invariant6 from "tiny-invariant";

// src/entities/Currency.ts
import invariant5 from "tiny-invariant";
var Currency = class {
  /**
   * Constructs an instance of the abstract class `Currency`.
   * @param {number | string}chainId the chain ID on which this currency resides
   * @param {number | string}decimals decimals of the currency
   * @param {string}symbol symbol of the currency
   * @param {string}name of the currency
   * @param {object}rebase of the currency
   */
  constructor({
    chainId,
    decimals,
    symbol,
    name,
    rebase = { base: default2.BigInt(1), elastic: default2.BigInt(1) }
  }) {
    invariant5(Number.isSafeInteger(Number(chainId)), "CHAIN_ID");
    invariant5(
      Number(decimals) >= 0 && Number(decimals) < 255 && Number.isInteger(Number(decimals)),
      "DECIMALS"
    );
    this.chainId = Number(chainId);
    this.decimals = Number(decimals);
    this.symbol = symbol;
    this.name = name;
    this.rebase = rebase;
  }
};

// src/entities/Token.ts
var Token = class extends Currency {
  /***/
  constructor({
    // TODO:
    // id,
    chainId,
    address,
    decimals,
    symbol,
    name,
    rebase = { base: default2.BigInt(1), elastic: default2.BigInt(1) }
  }) {
    super({
      chainId,
      decimals,
      symbol,
      name
    });
    this.isNative = false;
    this.isToken = true;
    try {
      this.address = getAddress(address);
      this.id = `${chainId}:${address}`;
    } catch (e) {
      console.log`${address} is not a valid address`;
    }
    try {
      this.rebase = rebase;
    } catch (e) {
      console.log`${rebase} is not a valid rebase`;
    }
  }
  /**
   * Returns true if the two tokens are equivalent, i.e. have the same chainId and address.
   * @param {Type}other other token to compare
   * @return {boolean}
   */
  equals(other) {
    return other.isToken && this.chainId === other.chainId && this.address === other.address;
  }
  /**
   * Returns true if the address of this token sorts before the address of the other token
   * @param {Token}other other token to compare
   * @throws if the tokens have the same address
   * @throws if the tokens are on different chains
   * @return {boolean}
   */
  sortsBefore(other) {
    invariant6(this.chainId === other.chainId, "CHAIN_IDS");
    invariant6(this.address !== other.address, "ADDRESSES");
    return this.address.toLowerCase() < other.address.toLowerCase();
  }
  /**
   * Return this token, which does not need to be wrapped
   */
  get wrapped() {
    return this;
  }
};

// src/functions/addressMapToTokenMap.ts
function addressMapToTokenMap({ decimals, symbol, name }, map) {
  return Object.fromEntries(
    Object.entries(map).map(([chainId, address]) => [
      chainId,
      new Token({
        chainId,
        address,
        decimals,
        symbol,
        name
      })
    ])
  );
}

// src/functions/tryParseAmount.ts
import { parseUnits } from "@ethersproject/units";

// src/functions/isChainSupported.ts
import memoize from "lodash.memoize";
var isChainSupported = memoize((chainId) => chainIds.includes(chainId));

// src/functions/computePairAddress.ts
import { getCreate2Address } from "@ethersproject/address";
import { keccak256, pack } from "@ethersproject/solidity";
var computePairAddress = ({
  tokenA,
  tokenB,
  factoryAddress,
  initCodeHashManualOverride
}) => {
  const [token0, token1] = tokenA.sortsBefore(tokenB) ? [tokenA, tokenB] : [tokenB, tokenA];
  return getCreate2Address(
    factoryAddress != null ? factoryAddress : FACTORY_ADDRESS[token0.chainId],
    keccak256(["bytes"], [pack(["address", "address"], [token0.address, token1.address])]),
    initCodeHashManualOverride != null ? initCodeHashManualOverride : INIT_CODE_HASH[token0.chainId]
  );
};

// src/functions/useNativeCurrency.ts
import { useMemo } from "react";

// node_modules/@ethersproject/bignumber/lib.esm/bignumber.js
var import_bn = __toESM(require_bn());

// node_modules/@ethersproject/logger/lib.esm/_version.js
var version = "logger/5.7.0";

// node_modules/@ethersproject/logger/lib.esm/index.js
var _permanentCensorErrors = false;
var _censorErrors = false;
var LogLevels = { debug: 1, "default": 2, info: 2, warning: 3, error: 4, off: 5 };
var _logLevel = LogLevels["default"];
var _globalLogger = null;
function _checkNormalize() {
  try {
    const missing = [];
    ["NFD", "NFC", "NFKD", "NFKC"].forEach((form) => {
      try {
        if ("test".normalize(form) !== "test") {
          throw new Error("bad normalize");
        }
        ;
      } catch (error) {
        missing.push(form);
      }
    });
    if (missing.length) {
      throw new Error("missing " + missing.join(", "));
    }
    if (String.fromCharCode(233).normalize("NFD") !== String.fromCharCode(101, 769)) {
      throw new Error("broken implementation");
    }
  } catch (error) {
    return error.message;
  }
  return null;
}
var _normalizeError = _checkNormalize();
var LogLevel;
(function(LogLevel2) {
  LogLevel2["DEBUG"] = "DEBUG";
  LogLevel2["INFO"] = "INFO";
  LogLevel2["WARNING"] = "WARNING";
  LogLevel2["ERROR"] = "ERROR";
  LogLevel2["OFF"] = "OFF";
})(LogLevel || (LogLevel = {}));
var ErrorCode;
(function(ErrorCode2) {
  ErrorCode2["UNKNOWN_ERROR"] = "UNKNOWN_ERROR";
  ErrorCode2["NOT_IMPLEMENTED"] = "NOT_IMPLEMENTED";
  ErrorCode2["UNSUPPORTED_OPERATION"] = "UNSUPPORTED_OPERATION";
  ErrorCode2["NETWORK_ERROR"] = "NETWORK_ERROR";
  ErrorCode2["SERVER_ERROR"] = "SERVER_ERROR";
  ErrorCode2["TIMEOUT"] = "TIMEOUT";
  ErrorCode2["BUFFER_OVERRUN"] = "BUFFER_OVERRUN";
  ErrorCode2["NUMERIC_FAULT"] = "NUMERIC_FAULT";
  ErrorCode2["MISSING_NEW"] = "MISSING_NEW";
  ErrorCode2["INVALID_ARGUMENT"] = "INVALID_ARGUMENT";
  ErrorCode2["MISSING_ARGUMENT"] = "MISSING_ARGUMENT";
  ErrorCode2["UNEXPECTED_ARGUMENT"] = "UNEXPECTED_ARGUMENT";
  ErrorCode2["CALL_EXCEPTION"] = "CALL_EXCEPTION";
  ErrorCode2["INSUFFICIENT_FUNDS"] = "INSUFFICIENT_FUNDS";
  ErrorCode2["NONCE_EXPIRED"] = "NONCE_EXPIRED";
  ErrorCode2["REPLACEMENT_UNDERPRICED"] = "REPLACEMENT_UNDERPRICED";
  ErrorCode2["UNPREDICTABLE_GAS_LIMIT"] = "UNPREDICTABLE_GAS_LIMIT";
  ErrorCode2["TRANSACTION_REPLACED"] = "TRANSACTION_REPLACED";
  ErrorCode2["ACTION_REJECTED"] = "ACTION_REJECTED";
})(ErrorCode || (ErrorCode = {}));
var HEX = "0123456789abcdef";
var Logger = class {
  constructor(version4) {
    Object.defineProperty(this, "version", {
      enumerable: true,
      value: version4,
      writable: false
    });
  }
  _log(logLevel, args) {
    const level = logLevel.toLowerCase();
    if (LogLevels[level] == null) {
      this.throwArgumentError("invalid log level name", "logLevel", logLevel);
    }
    if (_logLevel > LogLevels[level]) {
      return;
    }
    console.log.apply(console, args);
  }
  debug(...args) {
    this._log(Logger.levels.DEBUG, args);
  }
  info(...args) {
    this._log(Logger.levels.INFO, args);
  }
  warn(...args) {
    this._log(Logger.levels.WARNING, args);
  }
  makeError(message, code, params) {
    if (_censorErrors) {
      return this.makeError("censored error", code, {});
    }
    if (!code) {
      code = Logger.errors.UNKNOWN_ERROR;
    }
    if (!params) {
      params = {};
    }
    const messageDetails = [];
    Object.keys(params).forEach((key) => {
      const value = params[key];
      try {
        if (value instanceof Uint8Array) {
          let hex = "";
          for (let i = 0; i < value.length; i++) {
            hex += HEX[value[i] >> 4];
            hex += HEX[value[i] & 15];
          }
          messageDetails.push(key + "=Uint8Array(0x" + hex + ")");
        } else {
          messageDetails.push(key + "=" + JSON.stringify(value));
        }
      } catch (error2) {
        messageDetails.push(key + "=" + JSON.stringify(params[key].toString()));
      }
    });
    messageDetails.push(`code=${code}`);
    messageDetails.push(`version=${this.version}`);
    const reason = message;
    let url = "";
    switch (code) {
      case ErrorCode.NUMERIC_FAULT: {
        url = "NUMERIC_FAULT";
        const fault = message;
        switch (fault) {
          case "overflow":
          case "underflow":
          case "division-by-zero":
            url += "-" + fault;
            break;
          case "negative-power":
          case "negative-width":
            url += "-unsupported";
            break;
          case "unbound-bitwise-result":
            url += "-unbound-result";
            break;
        }
        break;
      }
      case ErrorCode.CALL_EXCEPTION:
      case ErrorCode.INSUFFICIENT_FUNDS:
      case ErrorCode.MISSING_NEW:
      case ErrorCode.NONCE_EXPIRED:
      case ErrorCode.REPLACEMENT_UNDERPRICED:
      case ErrorCode.TRANSACTION_REPLACED:
      case ErrorCode.UNPREDICTABLE_GAS_LIMIT:
        url = code;
        break;
    }
    if (url) {
      message += " [ See: https://links.ethers.org/v5-errors-" + url + " ]";
    }
    if (messageDetails.length) {
      message += " (" + messageDetails.join(", ") + ")";
    }
    const error = new Error(message);
    error.reason = reason;
    error.code = code;
    Object.keys(params).forEach(function(key) {
      error[key] = params[key];
    });
    return error;
  }
  throwError(message, code, params) {
    throw this.makeError(message, code, params);
  }
  throwArgumentError(message, name, value) {
    return this.throwError(message, Logger.errors.INVALID_ARGUMENT, {
      argument: name,
      value
    });
  }
  assert(condition, message, code, params) {
    if (!!condition) {
      return;
    }
    this.throwError(message, code, params);
  }
  assertArgument(condition, message, name, value) {
    if (!!condition) {
      return;
    }
    this.throwArgumentError(message, name, value);
  }
  checkNormalize(message) {
    if (message == null) {
      message = "platform missing String.prototype.normalize";
    }
    if (_normalizeError) {
      this.throwError("platform missing String.prototype.normalize", Logger.errors.UNSUPPORTED_OPERATION, {
        operation: "String.prototype.normalize",
        form: _normalizeError
      });
    }
  }
  checkSafeUint53(value, message) {
    if (typeof value !== "number") {
      return;
    }
    if (message == null) {
      message = "value not safe";
    }
    if (value < 0 || value >= 9007199254740991) {
      this.throwError(message, Logger.errors.NUMERIC_FAULT, {
        operation: "checkSafeInteger",
        fault: "out-of-safe-range",
        value
      });
    }
    if (value % 1) {
      this.throwError(message, Logger.errors.NUMERIC_FAULT, {
        operation: "checkSafeInteger",
        fault: "non-integer",
        value
      });
    }
  }
  checkArgumentCount(count, expectedCount, message) {
    if (message) {
      message = ": " + message;
    } else {
      message = "";
    }
    if (count < expectedCount) {
      this.throwError("missing argument" + message, Logger.errors.MISSING_ARGUMENT, {
        count,
        expectedCount
      });
    }
    if (count > expectedCount) {
      this.throwError("too many arguments" + message, Logger.errors.UNEXPECTED_ARGUMENT, {
        count,
        expectedCount
      });
    }
  }
  checkNew(target, kind) {
    if (target === Object || target == null) {
      this.throwError("missing new", Logger.errors.MISSING_NEW, { name: kind.name });
    }
  }
  checkAbstract(target, kind) {
    if (target === kind) {
      this.throwError("cannot instantiate abstract class " + JSON.stringify(kind.name) + " directly; use a sub-class", Logger.errors.UNSUPPORTED_OPERATION, { name: target.name, operation: "new" });
    } else if (target === Object || target == null) {
      this.throwError("missing new", Logger.errors.MISSING_NEW, { name: kind.name });
    }
  }
  static globalLogger() {
    if (!_globalLogger) {
      _globalLogger = new Logger(version);
    }
    return _globalLogger;
  }
  static setCensorship(censorship, permanent) {
    if (!censorship && permanent) {
      this.globalLogger().throwError("cannot permanently disable censorship", Logger.errors.UNSUPPORTED_OPERATION, {
        operation: "setCensorship"
      });
    }
    if (_permanentCensorErrors) {
      if (!censorship) {
        return;
      }
      this.globalLogger().throwError("error censorship permanent", Logger.errors.UNSUPPORTED_OPERATION, {
        operation: "setCensorship"
      });
    }
    _censorErrors = !!censorship;
    _permanentCensorErrors = !!permanent;
  }
  static setLogLevel(logLevel) {
    const level = LogLevels[logLevel.toLowerCase()];
    if (level == null) {
      Logger.globalLogger().warn("invalid log level - " + logLevel);
      return;
    }
    _logLevel = level;
  }
  static from(version4) {
    return new Logger(version4);
  }
};
Logger.errors = ErrorCode;
Logger.levels = LogLevel;

// node_modules/@ethersproject/bytes/lib.esm/_version.js
var version2 = "bytes/5.7.0";

// node_modules/@ethersproject/bytes/lib.esm/index.js
var logger = new Logger(version2);
function isHexable(value) {
  return !!value.toHexString;
}
function isInteger(value) {
  return typeof value === "number" && value == value && value % 1 === 0;
}
function isBytes(value) {
  if (value == null) {
    return false;
  }
  if (value.constructor === Uint8Array) {
    return true;
  }
  if (typeof value === "string") {
    return false;
  }
  if (!isInteger(value.length) || value.length < 0) {
    return false;
  }
  for (let i = 0; i < value.length; i++) {
    const v = value[i];
    if (!isInteger(v) || v < 0 || v >= 256) {
      return false;
    }
  }
  return true;
}
function isHexString(value, length) {
  if (typeof value !== "string" || !value.match(/^0x[0-9A-Fa-f]*$/)) {
    return false;
  }
  if (length && value.length !== 2 + 2 * length) {
    return false;
  }
  return true;
}
var HexCharacters = "0123456789abcdef";
function hexlify(value, options) {
  if (!options) {
    options = {};
  }
  if (typeof value === "number") {
    logger.checkSafeUint53(value, "invalid hexlify value");
    let hex = "";
    while (value) {
      hex = HexCharacters[value & 15] + hex;
      value = Math.floor(value / 16);
    }
    if (hex.length) {
      if (hex.length % 2) {
        hex = "0" + hex;
      }
      return "0x" + hex;
    }
    return "0x00";
  }
  if (typeof value === "bigint") {
    value = value.toString(16);
    if (value.length % 2) {
      return "0x0" + value;
    }
    return "0x" + value;
  }
  if (options.allowMissingPrefix && typeof value === "string" && value.substring(0, 2) !== "0x") {
    value = "0x" + value;
  }
  if (isHexable(value)) {
    return value.toHexString();
  }
  if (isHexString(value)) {
    if (value.length % 2) {
      if (options.hexPad === "left") {
        value = "0x0" + value.substring(2);
      } else if (options.hexPad === "right") {
        value += "0";
      } else {
        logger.throwArgumentError("hex data is odd-length", "value", value);
      }
    }
    return value.toLowerCase();
  }
  if (isBytes(value)) {
    let result = "0x";
    for (let i = 0; i < value.length; i++) {
      let v = value[i];
      result += HexCharacters[(v & 240) >> 4] + HexCharacters[v & 15];
    }
    return result;
  }
  return logger.throwArgumentError("invalid hexlify value", "value", value);
}

// node_modules/@ethersproject/bignumber/lib.esm/_version.js
var version3 = "bignumber/5.7.0";

// node_modules/@ethersproject/bignumber/lib.esm/bignumber.js
var BN = import_bn.default.BN;
var logger2 = new Logger(version3);
var _constructorGuard = {};
var MAX_SAFE = 9007199254740991;
var _warnedToStringRadix = false;
var BigNumber = class {
  constructor(constructorGuard, hex) {
    if (constructorGuard !== _constructorGuard) {
      logger2.throwError("cannot call constructor directly; use BigNumber.from", Logger.errors.UNSUPPORTED_OPERATION, {
        operation: "new (BigNumber)"
      });
    }
    this._hex = hex;
    this._isBigNumber = true;
    Object.freeze(this);
  }
  fromTwos(value) {
    return toBigNumber(toBN(this).fromTwos(value));
  }
  toTwos(value) {
    return toBigNumber(toBN(this).toTwos(value));
  }
  abs() {
    if (this._hex[0] === "-") {
      return BigNumber.from(this._hex.substring(1));
    }
    return this;
  }
  add(other) {
    return toBigNumber(toBN(this).add(toBN(other)));
  }
  sub(other) {
    return toBigNumber(toBN(this).sub(toBN(other)));
  }
  div(other) {
    const o = BigNumber.from(other);
    if (o.isZero()) {
      throwFault("division-by-zero", "div");
    }
    return toBigNumber(toBN(this).div(toBN(other)));
  }
  mul(other) {
    return toBigNumber(toBN(this).mul(toBN(other)));
  }
  mod(other) {
    const value = toBN(other);
    if (value.isNeg()) {
      throwFault("division-by-zero", "mod");
    }
    return toBigNumber(toBN(this).umod(value));
  }
  pow(other) {
    const value = toBN(other);
    if (value.isNeg()) {
      throwFault("negative-power", "pow");
    }
    return toBigNumber(toBN(this).pow(value));
  }
  and(other) {
    const value = toBN(other);
    if (this.isNegative() || value.isNeg()) {
      throwFault("unbound-bitwise-result", "and");
    }
    return toBigNumber(toBN(this).and(value));
  }
  or(other) {
    const value = toBN(other);
    if (this.isNegative() || value.isNeg()) {
      throwFault("unbound-bitwise-result", "or");
    }
    return toBigNumber(toBN(this).or(value));
  }
  xor(other) {
    const value = toBN(other);
    if (this.isNegative() || value.isNeg()) {
      throwFault("unbound-bitwise-result", "xor");
    }
    return toBigNumber(toBN(this).xor(value));
  }
  mask(value) {
    if (this.isNegative() || value < 0) {
      throwFault("negative-width", "mask");
    }
    return toBigNumber(toBN(this).maskn(value));
  }
  shl(value) {
    if (this.isNegative() || value < 0) {
      throwFault("negative-width", "shl");
    }
    return toBigNumber(toBN(this).shln(value));
  }
  shr(value) {
    if (this.isNegative() || value < 0) {
      throwFault("negative-width", "shr");
    }
    return toBigNumber(toBN(this).shrn(value));
  }
  eq(other) {
    return toBN(this).eq(toBN(other));
  }
  lt(other) {
    return toBN(this).lt(toBN(other));
  }
  lte(other) {
    return toBN(this).lte(toBN(other));
  }
  gt(other) {
    return toBN(this).gt(toBN(other));
  }
  gte(other) {
    return toBN(this).gte(toBN(other));
  }
  isNegative() {
    return this._hex[0] === "-";
  }
  isZero() {
    return toBN(this).isZero();
  }
  toNumber() {
    try {
      return toBN(this).toNumber();
    } catch (error) {
      throwFault("overflow", "toNumber", this.toString());
    }
    return null;
  }
  toBigInt() {
    try {
      return BigInt(this.toString());
    } catch (e) {
    }
    return logger2.throwError("this platform does not support BigInt", Logger.errors.UNSUPPORTED_OPERATION, {
      value: this.toString()
    });
  }
  toString() {
    if (arguments.length > 0) {
      if (arguments[0] === 10) {
        if (!_warnedToStringRadix) {
          _warnedToStringRadix = true;
          logger2.warn("BigNumber.toString does not accept any parameters; base-10 is assumed");
        }
      } else if (arguments[0] === 16) {
        logger2.throwError("BigNumber.toString does not accept any parameters; use bigNumber.toHexString()", Logger.errors.UNEXPECTED_ARGUMENT, {});
      } else {
        logger2.throwError("BigNumber.toString does not accept parameters", Logger.errors.UNEXPECTED_ARGUMENT, {});
      }
    }
    return toBN(this).toString(10);
  }
  toHexString() {
    return this._hex;
  }
  toJSON(key) {
    return { type: "BigNumber", hex: this.toHexString() };
  }
  static from(value) {
    if (value instanceof BigNumber) {
      return value;
    }
    if (typeof value === "string") {
      if (value.match(/^-?0x[0-9a-f]+$/i)) {
        return new BigNumber(_constructorGuard, toHex(value));
      }
      if (value.match(/^-?[0-9]+$/)) {
        return new BigNumber(_constructorGuard, toHex(new BN(value)));
      }
      return logger2.throwArgumentError("invalid BigNumber string", "value", value);
    }
    if (typeof value === "number") {
      if (value % 1) {
        throwFault("underflow", "BigNumber.from", value);
      }
      if (value >= MAX_SAFE || value <= -MAX_SAFE) {
        throwFault("overflow", "BigNumber.from", value);
      }
      return BigNumber.from(String(value));
    }
    const anyValue = value;
    if (typeof anyValue === "bigint") {
      return BigNumber.from(anyValue.toString());
    }
    if (isBytes(anyValue)) {
      return BigNumber.from(hexlify(anyValue));
    }
    if (anyValue) {
      if (anyValue.toHexString) {
        const hex = anyValue.toHexString();
        if (typeof hex === "string") {
          return BigNumber.from(hex);
        }
      } else {
        let hex = anyValue._hex;
        if (hex == null && anyValue.type === "BigNumber") {
          hex = anyValue.hex;
        }
        if (typeof hex === "string") {
          if (isHexString(hex) || hex[0] === "-" && isHexString(hex.substring(1))) {
            return BigNumber.from(hex);
          }
        }
      }
    }
    return logger2.throwArgumentError("invalid BigNumber value", "value", value);
  }
  static isBigNumber(value) {
    return !!(value && value._isBigNumber);
  }
};
function toHex(value) {
  if (typeof value !== "string") {
    return toHex(value.toString(16));
  }
  if (value[0] === "-") {
    value = value.substring(1);
    if (value[0] === "-") {
      logger2.throwArgumentError("invalid hex", "value", value);
    }
    value = toHex(value);
    if (value === "0x00") {
      return value;
    }
    return "-" + value;
  }
  if (value.substring(0, 2) !== "0x") {
    value = "0x" + value;
  }
  if (value === "0x") {
    return "0x00";
  }
  if (value.length % 2) {
    value = "0x0" + value.substring(2);
  }
  while (value.length > 4 && value.substring(0, 4) === "0x00") {
    value = "0x" + value.substring(4);
  }
  return value;
}
function toBigNumber(value) {
  return BigNumber.from(toHex(value));
}
function toBN(value) {
  const hex = BigNumber.from(value).toHexString();
  if (hex[0] === "-") {
    return new BN("-" + hex.substring(3), 16);
  }
  return new BN(hex.substring(2), 16);
}
function throwFault(fault, operation, value) {
  const params = { fault, operation };
  if (value != null) {
    params.value = value;
  }
  return logger2.throwError(fault, Logger.errors.NUMERIC_FAULT, params);
}

// src/functions/utils.ts
function ASSERT(f, t) {
  if (process.env.NODE_ENV !== "production") {
    if (!f() && t)
      console.error(t);
  }
}
var DEBUG_MODE = false;
function DEBUG(f) {
  if (DEBUG_MODE)
    f();
}
function closeValues(a, b, accuracy, logInfoIfFalse = "") {
  if (accuracy === 0)
    return a === b;
  if (Math.abs(a) < 1 / accuracy)
    return Math.abs(a - b) <= 10;
  if (Math.abs(b) < 1 / accuracy)
    return Math.abs(a - b) <= 10;
  const res = Math.abs(a / b - 1) < accuracy;
  if (!res) {
    console.log("Expected close: ", a, b, accuracy, logInfoIfFalse);
  }
  return res;
}
function revertPositive(f, out, hint = 1) {
  try {
    if (out <= f(0))
      return 0;
    let min;
    let max;
    if (f(hint) > out) {
      min = hint / 2;
      while (f(min) > out)
        min /= 2;
      max = min * 2;
    } else {
      max = hint * 2;
      while (f(max) < out)
        max *= 2;
      min = max / 2;
    }
    while (max / min - 1 > 1e-4) {
      const x0 = (min + max) / 2;
      const y0 = f(x0);
      if (out === y0)
        return x0;
      if (out < y0)
        max = x0;
      else
        min = x0;
    }
    return (min + max) / 2;
  } catch (e) {
    return 0;
  }
}
function getBigNumber(value) {
  const v = Math.abs(value);
  if (v < Number.MAX_SAFE_INTEGER)
    return BigNumber.from(Math.round(value));
  const exp = Math.floor(Math.log(v) / Math.LN2);
  console.assert(exp >= 51, "Internal Error 314");
  const shift = exp - 51;
  const mant = Math.round(v / Math.pow(2, shift));
  const res = BigNumber.from(mant).mul(BigNumber.from(2).pow(shift));
  return value > 0 ? res : res.mul(-1);
}

// src/functions/MultiRouter.ts
function calcPriceImactWithoutFee(route) {
  if (route.primaryPrice === void 0 || route.swapPrice === void 0) {
    return void 0;
  } else {
    let oneMinusCombinedFee = 1;
    route.legs.forEach((l) => oneMinusCombinedFee *= 1 - l.poolFee);
    return Math.max(0, 1 - route.swapPrice / route.primaryPrice / oneMinusCombinedFee);
  }
}
var defaultFlowNumber = 12;
var maxFlowNumber = 100;
function calcBestFlowNumber(bestSingleRoute, amountIn, gasPriceIn) {
  if (amountIn instanceof BigNumber) {
    amountIn = parseInt(amountIn.toString());
  }
  const priceImpact = calcPriceImactWithoutFee(bestSingleRoute);
  if (!priceImpact)
    return defaultFlowNumber;
  const bestFlowAmount = Math.sqrt(
    bestSingleRoute.gasSpent * (gasPriceIn || 0) * amountIn / priceImpact
  );
  const bestFlowNumber = Math.round(amountIn / bestFlowAmount);
  if (!isFinite(bestFlowNumber))
    return maxFlowNumber;
  const realFlowNumber = Math.max(1, Math.min(bestFlowNumber, maxFlowNumber));
  return realFlowNumber;
}
function getBetterRouteExactIn(route1, route2) {
  if (route1.status == "NoWay" /* NoWay */)
    return route2;
  if (route2.status == "NoWay" /* NoWay */)
    return route1;
  if (route1.status == "Partial" /* Partial */ && route2.status == "Success" /* Success */)
    return route2;
  if (route2.status == "Partial" /* Partial */ && route1.status == "Success" /* Success */)
    return route1;
  return route1.totalAmountOut > route2.totalAmountOut ? route1 : route2;
}
function deduplicatePools(pools) {
  const poolMap = /* @__PURE__ */ new Map();
  pools.forEach((p) => {
    const chId0 = p.token0.chainId || 0;
    const chId1 = p.token1.chainId || 0;
    const chainInfo = chId0 < chId1 ? `_${chId0}_${chId1}` : `_${chId1}_${chId0}`;
    poolMap.set(p.address + chainInfo, p);
  });
  return Array.from(poolMap.values());
}
function findMultiRouteExactIn(from, to, amountIn, pools, baseTokenOrNetworks, gasPrice, flows) {
  var _a;
  pools = deduplicatePools(pools);
  checkChainId(pools, baseTokenOrNetworks);
  setTokenId(from, to);
  const g = new Graph(pools, from, baseTokenOrNetworks, gasPrice);
  if (flows !== void 0)
    return g.findBestRouteExactIn(from, to, amountIn, flows);
  const outSingle = g.findBestRouteExactIn(from, to, amountIn, 1);
  g.cleanTmpData();
  const bestFlowNumber = calcBestFlowNumber(outSingle, amountIn, (_a = g.getVert(from)) == null ? void 0 : _a.gasPrice);
  if (bestFlowNumber === 1)
    return outSingle;
  const outMulti = g.findBestRouteExactIn(from, to, amountIn, bestFlowNumber);
  return getBetterRouteExactIn(outSingle, outMulti);
}
function checkChainId(pools, baseTokenOrNetworks) {
  if (baseTokenOrNetworks instanceof Array) {
    baseTokenOrNetworks.forEach((n) => {
      if (n.chainId !== n.baseToken.chainId) {
        throw new Error(
          `Chain '${n.chainId}' has baseToken with '${n.baseToken.chainId}' that are not the same`
        );
      }
    });
  }
  const chainIds2 = baseTokenOrNetworks instanceof Array ? baseTokenOrNetworks.map((n) => n.chainId) : [baseTokenOrNetworks.chainId];
  const chainIdSet = new Set(chainIds2);
  const checkToken = (t) => {
    if (!chainIdSet.has(t.chainId)) {
      throw new Error(
        `Token ${t.name}/${t.address} chainId='${t.chainId}' is not in list of possible chains: [${chainIds2.join(", ")}]`
      );
    }
  };
  pools.forEach((p) => {
    checkToken(p.token0);
    checkToken(p.token1);
  });
}

// src/constants/addresses.ts
var INIT_CODE_HASH = {
  [ChainId_default.SMARTBCH]: "0x4eae98fedf0a51d24c5a3a59dddb69e9fbeead94344889e370a14507c35f9b4a",
  [ChainId_default.SMARTBCH_TESTNET]: "0x4eae98fedf0a51d24c5a3a59dddb69e9fbeead94344889e370a14507c35f9b4a"
};
var ROUTER_PROCESSOR_ADDRESS = {
  [ChainId_default.SMARTBCH]: "0xc420437d9E89488F90644F8a226a50D767c51BD8",
  [ChainId_default.SMARTBCH_TESTNET]: "0xe60B5F714e73281d97738ac34e8e86593E32A32A"
};
var VAULT_ADDRESS = {
  [ChainId_default.SMARTBCH]: "0xFFbE92fDA81f853bcf00d3c7686d5DAd5A6600bB",
  [ChainId_default.SMARTBCH_TESTNET]: "0xe5aFde6eD9E2aa69B1D7247E406399CBf26d7578"
};
var LOCKER_ADDRESS = {
  [ChainId_default.SMARTBCH]: "0xd9647E506Da0865f9a4E70fBD0aDA55b2B89E5b1",
  [ChainId_default.SMARTBCH_TESTNET]: "0x0714b92E09f198e53B632EbC46c78BDABE1DAd1c"
};
var FACTORY_ADDRESS = {
  [ChainId_default.SMARTBCH]: "0xE62983a68679834eD884B9673Fb6aF13db740fF0",
  [ChainId_default.SMARTBCH_TESTNET]: "0xa27588D9cff3130AC91C39b1B1c992976d492476"
};
var ROUTER_ADDRESS = {
  [ChainId_default.SMARTBCH]: "0x217057A8B0bDEb160829c19243A2E03bfe95555a",
  [ChainId_default.SMARTBCH_TESTNET]: "0xD3f256a03bf7c75ba4d08bf2847Cc7F59168DB45"
};
var DISTRIBUTOR_ADDRESS = {
  [ChainId_default.SMARTBCH]: "0x8ecb32C33AB3f7ee3D6Ce9D4020bC53fecB36Be9",
  [ChainId_default.SMARTBCH_TESTNET]: "0xFFbE92fDA81f853bcf00d3c7686d5DAd5A6600bB"
};
var MULTICALL2_ADDRESS = {
  [ChainId_default.SMARTBCH]: "0x20F9f219743556c06D2205F92548278CEd14A38B",
  [ChainId_default.SMARTBCH_TESTNET]: "0x10334769312D07dadF40bDd2217EFCae80E77910",
  [ChainId_default.BSC]: "0xa9193376D09C7f31283C54e56D013fCF370Cd9D9",
  [ChainId_default.BSC_TESTNET]: "0xA6949B8FBa9DF546b9c66F98CFCa960A96E3b68e"
};
var EMBER_ADDRESS = {
  [ChainId_default.SMARTBCH]: "0x6BAbf5277849265b6738e75AEC43AEfdde0Ce88D",
  [ChainId_default.SMARTBCH_TESTNET]: "0x217057A8B0bDEb160829c19243A2E03bfe95555a",
  [ChainId_default.BSC]: "0x6BAbf5277849265b6738e75AEC43AEfdde0Ce88D",
  [ChainId_default.BSC_TESTNET]: "0x217057A8B0bDEb160829c19243A2E03bfe95555a"
};
var FIRE_ADDRESS = {
  [ChainId_default.SMARTBCH]: "0x225FCa2A940cd5B18DFb168cD9B7f921C63d7B6E",
  [ChainId_default.SMARTBCH_TESTNET]: "0xa10da28C8D63473fD2bE8df9C37A628A188F43ea",
  [ChainId_default.BSC]: "0x6BAbf5277849265b6738e75AEC43AEfdde0Ce88D",
  [ChainId_default.BSC_TESTNET]: "0x217057A8B0bDEb160829c19243A2E03bfe95555a"
};
var EMBER = addressMapToTokenMap(
  {
    decimals: 18,
    symbol: "EMBER",
    name: "Ember"
  },
  EMBER_ADDRESS
);
var FIRE = addressMapToTokenMap(
  {
    decimals: 18,
    symbol: "FIRE",
    name: "Incinerate"
  },
  FIRE_ADDRESS
);
var BUSD_ADDRESS = {
  [ChainId_default.BSC]: "0xe9e7CEA3DedcA5984780Bafc599bD69ADd087D56"
};
var BUSD = addressMapToTokenMap(
  {
    decimals: 18,
    symbol: "BUSD",
    name: "BUSD Token"
  },
  BUSD_ADDRESS
);
var WETH9_ADDRESS = {
  [ChainId_default.BSC]: "0x2170Ed0880ac9A755fd29B2688956BD959F933F8"
};
var WETH9 = addressMapToTokenMap(
  {
    decimals: 18,
    symbol: "WETH",
    name: "Wrapped Ether"
  },
  WETH9_ADDRESS
);
var WNATIVE_ADDRESS = {
  [ChainId_default.BSC]: "0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c",
  [ChainId_default.BSC_TESTNET]: "0xae13d989daC2f0dEbFf460aC112a837C89BAa7cd",
  [ChainId_default.SMARTBCH]: "0x3743eC0673453E5009310C727Ba4eaF7b3a1cc04",
  [ChainId_default.SMARTBCH_TESTNET]: "0x17F4FCF5b6E0A95D4eE331c8529041896A073F9b"
};
var WNATIVE = {
  [ChainId_default.BSC]: new Token({
    chainId: ChainId_default.BSC,
    address: WNATIVE_ADDRESS[ChainId_default.BSC],
    decimals: 18,
    symbol: "WBNB",
    name: "Wrapped BNB"
  }),
  [ChainId_default.BSC_TESTNET]: new Token({
    chainId: ChainId_default.BSC_TESTNET,
    address: WNATIVE_ADDRESS[ChainId_default.BSC_TESTNET],
    decimals: 18,
    symbol: "WBNB",
    name: "Wrapped BNB"
  }),
  [ChainId_default.SMARTBCH]: new Token({
    chainId: ChainId_default.SMARTBCH,
    address: WNATIVE_ADDRESS[ChainId_default.SMARTBCH],
    decimals: 18,
    symbol: "WBCH",
    name: "Wrapped BCH"
  }),
  [ChainId_default.SMARTBCH_TESTNET]: new Token({
    chainId: ChainId_default.SMARTBCH_TESTNET,
    address: WNATIVE_ADDRESS[ChainId_default.SMARTBCH_TESTNET],
    decimals: 18,
    symbol: "WBCH",
    name: "Wrapped BCH"
  })
};
var SUSHI_ADDRESS = {
  [ChainId_default.BSC]: "0x947950BcC74888a40Ffa2593C5798F11Fc9124C4"
};
var SUSHI = addressMapToTokenMap(
  {
    decimals: 18,
    symbol: "SUSHI",
    name: "SushiToken"
  },
  SUSHI_ADDRESS
);
var USDC_ADDRESS = {
  [ChainId_default.BSC]: "0x8AC76a51cc950d9822D68b83fE1Ad97B32Cd580d",
  [ChainId_default.SMARTBCH]: "0x7b2B3C5308ab5b2a1d9a94d20D35CCDf61e05b72"
};
var USDC = {
  [ChainId_default.BSC]: new Token({
    chainId: ChainId_default.BSC,
    address: USDC_ADDRESS[ChainId_default.BSC],
    decimals: 6,
    symbol: "USDC",
    name: "USD Coin"
  }),
  [ChainId_default.SMARTBCH]: new Token({
    chainId: ChainId_default.SMARTBCH,
    address: USDC_ADDRESS[ChainId_default.SMARTBCH],
    decimals: 18,
    symbol: "FLEXUSD",
    name: "flexUSD"
  })
};
var USDT_ADDRESS = {
  [ChainId_default.BSC]: "0x55d398326f99059fF775485246999027B3197955",
  [ChainId_default.BSC_TESTNET]: "0xF49E250aEB5abDf660d643583AdFd0be41464EfD"
};
var USDT = __spreadProps(__spreadValues({}, addressMapToTokenMap(
  {
    decimals: 6,
    symbol: "USDT",
    name: "Tether USD"
  },
  USDT_ADDRESS
)), {
  [ChainId_default.BSC]: new Token({
    chainId: ChainId_default.BSC,
    address: USDT_ADDRESS[ChainId_default.BSC],
    decimals: 18,
    symbol: "USDT",
    name: "Tether USD"
  }),
  [ChainId_default.BSC_TESTNET]: new Token({
    chainId: ChainId_default.BSC_TESTNET,
    address: USDT_ADDRESS[ChainId_default.BSC_TESTNET],
    decimals: 18,
    symbol: "USDT",
    name: "Tether USD"
  })
});

// src/constants/routing.ts
var BASES_TO_CHECK_TRADES_AGAINST = {
  [ChainId_default.SMARTBCH]: [WNATIVE[ChainId_default.SMARTBCH], EMBER[ChainId_default.SMARTBCH], USDC[ChainId_default.SMARTBCH]],
  [ChainId_default.SMARTBCH_TESTNET]: [
    WNATIVE[ChainId_default.SMARTBCH_TESTNET],
    EMBER[ChainId_default.SMARTBCH_TESTNET],
    USDC[ChainId_default.SMARTBCH_TESTNET]
  ]
  // [ChainId.BSC]: [WNATIVE[ChainId.BSC]],
};
var ADDITIONAL_BASES = {
  [ChainId_default.SMARTBCH]: {
    [FIRE[ChainId_default.SMARTBCH].address]: [FIRE[ChainId_default.SMARTBCH]]
  }
};

// src/entities/Native.ts
var _Native = class extends Currency {
  /**
   * @param {object}native
   */
  constructor(native) {
    super(native);
    this.isNative = true;
    this.isToken = false;
    this.id = `${native.chainId}:NATIVE`;
    this.symbol = native.symbol;
    this.name = native.name;
  }
  /***/
  get wrapped() {
    const wnative = WNATIVE[this.chainId];
    invariant7(!!wnative, "WRAPPED");
    return wnative;
  }
  /**
   * @param {number}chainId
   * @return {Native}
   */
  static onChain(chainId) {
    if (chainId in this.cache) {
      return this.cache[chainId];
    }
    invariant7(!!(chainId in chains), "CHAINS");
    const { nativeCurrency } = chains[chainId];
    invariant7(!!nativeCurrency, "NATIVE_CURRENCY");
    const { decimals, name, symbol } = nativeCurrency;
    return this.cache[chainId] = new _Native({
      chainId,
      decimals,
      name,
      symbol
    });
  }
  /**
   * @param {Type}other
   * @return {boolean}
   */
  equals(other) {
    return other.isNative && other.chainId === this.chainId;
  }
};
var Native = _Native;
Native.cache = {};

// src/entities/Price.ts
import invariant8 from "tiny-invariant";
var Price = class extends Fraction_default {
  // used to adjust the raw fraction w/r/t the decimals of the {base,quote}Token
  /**
   * Construct a price, either with the base and quote currency amount, or the
   * @param {object}args
   */
  constructor(...args) {
    let baseCurrency;
    let quoteCurrency;
    let denominator;
    let numerator;
    if (args.length === 4) {
      ;
      [baseCurrency, quoteCurrency, denominator, numerator] = args;
    } else {
      const result = args[0].quoteAmount.divide(args[0].baseAmount);
      [baseCurrency, quoteCurrency, denominator, numerator] = [
        args[0].baseAmount.currency,
        args[0].quoteAmount.currency,
        result.denominator,
        result.numerator
      ];
    }
    super(numerator, denominator);
    this.baseCurrency = baseCurrency;
    this.quoteCurrency = quoteCurrency;
    this.scalar = new Fraction_default(
      default2.exponentiate(default2.BigInt(10), default2.BigInt(baseCurrency.decimals)),
      default2.exponentiate(default2.BigInt(10), default2.BigInt(quoteCurrency.decimals))
    );
  }
  /**
   * Flip the price, switching the base and quote currency
   * @return {Price<TQuote, TBase>}
   */
  invert() {
    return new Price(this.quoteCurrency, this.baseCurrency, this.numerator, this.denominator);
  }
  /**
   * Multiply the price by another price, returning a new price. The other price must have the same base currency as this price's quote currency
   * @param {Price<TQuote, TOtherQuote>}other the other price
   * @return {Price<TBase, TOtherQuote>}
   */
  multiply(other) {
    invariant8(this.quoteCurrency.equals(other.baseCurrency), "TOKEN");
    const fraction = super.multiply(other);
    return new Price(
      this.baseCurrency,
      other.quoteCurrency,
      fraction.denominator,
      fraction.numerator
    );
  }
  /**
   * Return the amount of quote currency corresponding to a given amount of the base currency
   * @param {Amount<TBase>}currencyAmount the amount of base currency to quote against the price
   * @return {Amount<TQuote>}
   */
  quote(currencyAmount) {
    invariant8(currencyAmount.currency.equals(this.baseCurrency), "TOKEN");
    const result = super.multiply(currencyAmount);
    return Amount.fromFractionalAmount(this.quoteCurrency, result.numerator, result.denominator);
  }
  /**
   * Get the value scaled by decimals for formatting
   * @private
   */
  get adjustedForDecimals() {
    return super.multiply(this.scalar);
  }
  /**
   * @param {number}significantDigits
   * @param {object}format
   * @param {Rounding}rounding
   * @return {string}
   */
  toSignificant(significantDigits = 6, format, rounding) {
    return this.adjustedForDecimals.toSignificant(significantDigits, format, rounding);
  }
  /**
   * @param {number}decimalPlaces
   * @param {object}format
   * @param {Rounding}rounding
   * @return {string}
   */
  toFixed(decimalPlaces = 4, format, rounding) {
    return this.adjustedForDecimals.toFixed(decimalPlaces, format, rounding);
  }
};

// src/entities/Error.ts
var CAN_SET_PROTOTYPE = "setPrototypeOf" in Object;
var InsufficientReservesError = class extends Error {
  /** */
  constructor() {
    super();
    this.isInsufficientReservesError = true;
    this.name = this.constructor.name;
    if (CAN_SET_PROTOTYPE)
      Object.setPrototypeOf(this, new.target.prototype);
  }
};
var InsufficientInputAmountError = class extends Error {
  /** */
  constructor() {
    super();
    this.isInsufficientInputAmountError = true;
    this.name = this.constructor.name;
    if (CAN_SET_PROTOTYPE)
      Object.setPrototypeOf(this, new.target.prototype);
  }
};

// src/entities/Pair.ts
import invariant9 from "tiny-invariant";
var Pair = class {
  /**
   * @param {Amount<Token>}AmountA
   * @param {Amount<Token>}AmountB
   * @param {string} factoryAddress
   * @param {string} initCodeHashManualOverride
   */
  constructor(AmountA, AmountB, factoryAddress, initCodeHashManualOverride) {
    this.swapGasCost = default2.BigInt(6e4);
    this.minLiquidity = default2.BigInt(1e3);
    const Amounts = AmountA.currency.sortsBefore(AmountB.currency) ? [AmountA, AmountB] : [AmountB, AmountA];
    this.liquidityToken = new Token({
      chainId: Amounts[0].currency.chainId,
      address: Pair.getAddress(
        Amounts[0].currency,
        Amounts[1].currency,
        factoryAddress,
        initCodeHashManualOverride
      ),
      decimals: 18,
      symbol: "Ember-LP",
      name: "Ember-LP"
    });
    this.tokenAmounts = Amounts;
  }
  /** Computes pair address based off token addresses
   * @param {Token} tokenA
   * @param {Token} tokenB
   * @param {string} factoryAddress
   * @param {string} initCodeHashManualOverride
   * @return {string}
   */
  static getAddress(tokenA, tokenB, factoryAddress, initCodeHashManualOverride) {
    return computePairAddress({
      tokenA,
      tokenB,
      factoryAddress,
      initCodeHashManualOverride
    });
  }
  /**
   * @param {Token}token to check
   * @return {boolean} Returns true if the token is either token0 or token1
   */
  involvesToken(token) {
    return token.equals(this.token0) || token.equals(this.token1);
  }
  /**
   * Returns the current mid price of the pair in terms of token0, i.e. the ratio of reserve1 to reserve0
   */
  get token0Price() {
    const result = this.tokenAmounts[1].divide(this.tokenAmounts[0]);
    return new Price(this.token0, this.token1, result.denominator, result.numerator);
  }
  /**
   * Returns the current mid price of the pair in terms of token1, i.e. the ratio of reserve0 to reserve1
   */
  get token1Price() {
    const result = this.tokenAmounts[0].divide(this.tokenAmounts[1]);
    return new Price(this.token1, this.token0, result.denominator, result.numerator);
  }
  /**
   * @param {Token}token to return price of
   * @return {Price<Token, Token>} Return the price of the given token in terms of the other token in the pair.
   */
  priceOf(token) {
    invariant9(this.involvesToken(token), "TOKEN");
    return token.equals(this.token0) ? this.token0Price : this.token1Price;
  }
  /** Returns the chain ID of the tokens in the pair. */
  get chainId() {
    return this.token0.chainId;
  }
  /** Returns the first token of the tokens in the pair. */
  get token0() {
    return this.tokenAmounts[0].currency;
  }
  /** Returns the second token of the tokens in the pair. */
  get token1() {
    return this.tokenAmounts[1].currency;
  }
  /** Returns the first reserve of the tokens in the pair. */
  get reserve0() {
    return this.tokenAmounts[0];
  }
  /** Returns the second reserve of the tokens in the pair. */
  get reserve1() {
    return this.tokenAmounts[1];
  }
  /**
   * @param {Token} token
   * @param {string} factoryAddress
   * @param {string} initCodeHashManualOverride
   * @return {Amount<Token>}
   */
  reserveOf(token) {
    invariant9(this.involvesToken(token), "TOKEN");
    return token.equals(this.token0) ? this.reserve0 : this.reserve1;
  }
  /**
   * @param {Amount<Token>} inputAmount
   * @param {string} factoryAddress
   * @param {string} initCodeHashManualOverride
   * @return {[Amount<Token>, Pair]}
   */
  getOutputAmount(inputAmount, factoryAddress, initCodeHashManualOverride) {
    invariant9(this.involvesToken(inputAmount.currency), "TOKEN");
    if (default2.equal(this.reserve0.quotient, ZERO) || default2.equal(this.reserve1.quotient, ZERO)) {
      throw new InsufficientReservesError();
    }
    const inputReserve = this.reserveOf(inputAmount.currency);
    const outputReserve = this.reserveOf(
      inputAmount.currency.equals(this.token0) ? this.token1 : this.token0
    );
    const inputAmountWithFee = default2.multiply(inputAmount.quotient, _997);
    const numerator = default2.multiply(inputAmountWithFee, outputReserve.quotient);
    const denominator = default2.add(default2.multiply(inputReserve.quotient, _1000), inputAmountWithFee);
    const outputAmount = Amount.fromRawAmount(
      inputAmount.currency.equals(this.token0) ? this.token1 : this.token0,
      default2.divide(numerator, denominator)
    );
    if (default2.equal(outputAmount.quotient, ZERO)) {
      throw new InsufficientInputAmountError();
    }
    return [
      outputAmount,
      new Pair(
        inputReserve.add(inputAmount),
        outputReserve.subtract(outputAmount),
        factoryAddress,
        initCodeHashManualOverride
      )
    ];
  }
  /**
   * @param {Amount<Token>} outputAmount
   * @param {string} factoryAddress
   * @param {string} initCodeHashManualOverride
   * @return {[Amount<Token>, Pair]}
   */
  getInputAmount(outputAmount, factoryAddress, initCodeHashManualOverride) {
    invariant9(this.involvesToken(outputAmount.currency), "TOKEN");
    if (default2.equal(this.reserve0.quotient, ZERO) || default2.equal(this.reserve1.quotient, ZERO) || default2.greaterThanOrEqual(outputAmount.quotient, this.reserveOf(outputAmount.currency).quotient)) {
      throw new InsufficientReservesError();
    }
    const outputReserve = this.reserveOf(outputAmount.currency);
    const inputReserve = this.reserveOf(
      outputAmount.currency.equals(this.token0) ? this.token1 : this.token0
    );
    const numerator = default2.multiply(
      default2.multiply(inputReserve.quotient, outputAmount.quotient),
      _1000
    );
    const denominator = default2.multiply(
      default2.subtract(outputReserve.quotient, outputAmount.quotient),
      _997
    );
    const inputAmount = Amount.fromRawAmount(
      outputAmount.currency.equals(this.token0) ? this.token1 : this.token0,
      default2.add(default2.divide(numerator, denominator), ONE)
    );
    return [
      inputAmount,
      new Pair(
        inputReserve.add(inputAmount),
        outputReserve.subtract(outputAmount),
        factoryAddress,
        initCodeHashManualOverride
      )
    ];
  }
  /**
   * @param {Amount<Token>} totalSupply
   * @param {Amount<Token>} tokenAmountA
   * @param {Amount<Token>} tokenAmountB
   * @return {Amount<Token>}
   */
  getLiquidityMinted(totalSupply, tokenAmountA, tokenAmountB) {
    invariant9(totalSupply.currency.equals(this.liquidityToken), "LIQUIDITY");
    const tokenAmounts = tokenAmountA.currency.sortsBefore(tokenAmountB.currency) ? [tokenAmountA, tokenAmountB] : [tokenAmountB, tokenAmountA];
    invariant9(
      tokenAmounts[0].currency.equals(this.token0) && tokenAmounts[1].currency.equals(this.token1),
      "TOKEN"
    );
    let liquidity;
    if (default2.equal(totalSupply.quotient, ZERO)) {
      liquidity = default2.subtract(
        sqrt(default2.multiply(tokenAmounts[0].quotient, tokenAmounts[1].quotient)),
        this.minLiquidity
      );
    } else {
      const amount0 = default2.divide(
        default2.multiply(tokenAmounts[0].quotient, totalSupply.quotient),
        this.reserve0.quotient
      );
      const amount1 = default2.divide(
        default2.multiply(tokenAmounts[1].quotient, totalSupply.quotient),
        this.reserve1.quotient
      );
      liquidity = default2.lessThanOrEqual(amount0, amount1) ? amount0 : amount1;
    }
    if (!default2.greaterThan(liquidity, ZERO)) {
      throw new InsufficientInputAmountError();
    }
    return Amount.fromRawAmount(this.liquidityToken, liquidity);
  }
  /**
   * @param {Token} token
   * @param {Amount<Token>} totalSupply
   * @param {Amount<Token>} liquidity
   * @param {boolean} feeOn
   * @param {BigintIsh} kLast
   * @return {Amount<Token>}
   */
  getLiquidityValue(token, totalSupply, liquidity, feeOn = false, kLast) {
    invariant9(this.involvesToken(token), "TOKEN");
    invariant9(totalSupply.currency.equals(this.liquidityToken), "TOTAL_SUPPLY");
    invariant9(liquidity.currency.equals(this.liquidityToken), "LIQUIDITY");
    invariant9(default2.lessThanOrEqual(liquidity.quotient, totalSupply.quotient), "LIQUIDITY");
    let totalSupplyAdjusted;
    if (!feeOn) {
      totalSupplyAdjusted = totalSupply;
    } else {
      invariant9(!!kLast, "K_LAST");
      const kLastParsed = default2.BigInt(kLast);
      if (!default2.equal(kLastParsed, ZERO)) {
        const rootK = sqrt(default2.multiply(this.reserve0.quotient, this.reserve1.quotient));
        const rootKLast = sqrt(kLastParsed);
        if (default2.greaterThan(rootK, rootKLast)) {
          const numerator = default2.multiply(totalSupply.quotient, default2.subtract(rootK, rootKLast));
          const denominator = default2.add(default2.multiply(rootK, FIVE), rootKLast);
          const feeLiquidity = default2.divide(numerator, denominator);
          totalSupplyAdjusted = totalSupply.add(
            Amount.fromRawAmount(this.liquidityToken, feeLiquidity)
          );
        } else {
          totalSupplyAdjusted = totalSupply;
        }
      } else {
        totalSupplyAdjusted = totalSupply;
      }
    }
    return Amount.fromRawAmount(
      token,
      default2.divide(
        default2.multiply(liquidity.quotient, this.reserveOf(token).quotient),
        totalSupplyAdjusted.quotient
      )
    );
  }
};

// src/entities/PrimaryPools.ts
var TYPICAL_SWAP_GAS_COST = 6e4;
var TYPICAL_MINIMAL_LIQUIDITY = 100;
function setTokenId(...tokens) {
  tokens.forEach((t) => {
    if (!t.tokenId)
      t.tokenId = `${t.address || ""}_${t.chainId}`;
  });
}
var RPool2 = class {
  /**
   * @param {string}address
   * @param {RToken}token0
   * @param {RToken}token1
   * @param {number}fee
   * @param {BigNumber}reserve0
   * @param {BigNumber}reserve1
   * @param {number}minLiquidity
   * @param {number}swapGasCost
   */
  constructor(address, token0, token1, fee, reserve0, reserve1, minLiquidity = TYPICAL_MINIMAL_LIQUIDITY, swapGasCost = TYPICAL_SWAP_GAS_COST) {
    this.address = address || "";
    this.token0 = token0;
    this.token1 = token1;
    if (token0 && token1) {
      setTokenId(this.token0, this.token1);
    }
    this.fee = fee;
    this.minLiquidity = minLiquidity;
    this.swapGasCost = swapGasCost;
    this.reserve0 = reserve0;
    this.reserve1 = reserve1;
  }
  /**
   * @param {BigNumber}res0
   * @param {BigNumber}res1
   */
  updateReserves(res0, res1) {
    this.reserve0 = res0;
    this.reserve1 = res1;
  }
  /**
   * @return {BigNumber}
   */
  getReserve0() {
    return this.reserve0;
  }
  /**
   * @return {BigNumber}
   */
  getReserve1() {
    return this.reserve1;
  }
  /** Should return real output, as close to the pool as possible. With rounding. No exceptions
   * @param {number}amountIn
   * @param {boolean}direction
   * @return {number}
   */
  calcOutByInReal(amountIn, direction) {
    return this.calcOutByIn(amountIn, direction).out;
  }
  // precision of calcOutByIn
  /**
   * @return {number}
   */
  granularity0() {
    return 1;
  }
  /**
   * @return {number}
   */
  granularity1() {
    return 1;
  }
  /**
   * @return {boolean}
   */
  alwaysAppropriateForPricing() {
    return false;
  }
};
var ConstantProductRPool = class extends RPool2 {
  /**
   * @param {string}address
   * @param {RToken}token0
   * @param {RToken}token1
   * @param {number}fee
   * @param {BigNumber}reserve0
   * @param {BigNumber}reserve1
   */
  constructor(address, token0, token1, fee, reserve0, reserve1) {
    super(address, token0, token1, fee, reserve0, reserve1);
    this.reserve0Number = parseInt((reserve0 == null ? void 0 : reserve0.toString()) || "0");
    this.reserve1Number = parseInt((reserve1 == null ? void 0 : reserve1.toString()) || "0");
  }
  /**
   * @param {BigNumber}res0
   * @param {BigNumber}res1
   */
  updateReserves(res0, res1) {
    this.reserve0 = res0;
    this.reserve0Number = parseInt(res0.toString());
    this.reserve1 = res1;
    this.reserve1Number = parseInt(res1.toString());
  }
  /**
   * @param {number}amountIn
   * @param {boolean}direction
   * @return {number}
   */
  calcOutByIn(amountIn, direction) {
    const x = direction ? this.reserve0Number : this.reserve1Number;
    const y = direction ? this.reserve1Number : this.reserve0Number;
    const out = y * amountIn / (x / (1 - this.fee) + amountIn);
    return { out, gasSpent: this.swapGasCost };
  }
  /**
   * @param {number}amountIn
   * @param {boolean}direction
   * @return {number}
   */
  calcOutByInReal(amountIn, direction) {
    const x = direction ? this.reserve0Number : this.reserve1Number;
    const y = direction ? this.reserve1Number : this.reserve0Number;
    const amountInWithoutFee = Math.floor(amountIn * (1 - this.fee) * 1e3);
    const out = y * amountInWithoutFee / (x * 1e3 + amountInWithoutFee);
    return Math.floor(out);
  }
  /**
   * @param {number}amountOut
   * @param {boolean}direction
   * @return {number}
   */
  calcInByOut(amountOut, direction) {
    const x = direction ? this.reserve0Number : this.reserve1Number;
    const y = direction ? this.reserve1Number : this.reserve0Number;
    if (y - amountOut < this.minLiquidity)
      return { inp: Number.POSITIVE_INFINITY, gasSpent: this.swapGasCost };
    const input = x * amountOut / (1 - this.fee) / (y - amountOut);
    return { inp: input, gasSpent: this.swapGasCost };
  }
  /**
   * @param {boolean}direction
   * @return {number}
   */
  calcCurrentPriceWithoutFee(direction) {
    return this.calcPrice(0, direction, false);
  }
  /**
   * @param {number}amountIn
   * @param {boolean}direction
   * @param {boolean}takeFeeIntoAccount
   * @return {number}
   */
  calcPrice(amountIn, direction, takeFeeIntoAccount) {
    const x = direction ? this.reserve0Number : this.reserve1Number;
    const y = direction ? this.reserve1Number : this.reserve0Number;
    const oneMinusFee = takeFeeIntoAccount ? 1 - this.fee : 1;
    const xf = x / oneMinusFee;
    return y * xf / (xf + amountIn) / (xf + amountIn);
  }
  /**
   * @param {number}price
   * @param {boolean}direction
   * @param {boolean}takeFeeIntoAccount
   * @return {number}
   */
  calcInputByPrice(price, direction, takeFeeIntoAccount) {
    const x = direction ? this.reserve0Number : this.reserve1Number;
    const y = direction ? this.reserve1Number : this.reserve0Number;
    const oneMinusFee = takeFeeIntoAccount ? 1 - this.fee : 1;
    const xf = x / oneMinusFee;
    return Math.sqrt(y * xf * price) - xf;
  }
  /**
   * @return {number}
   */
  getLiquidity() {
    return Math.sqrt(this.reserve0Number * this.reserve1Number);
  }
};
var HybridRPool = class extends RPool2 {
  // set it to 0 if reserves are changed !!
  /**
   * @param {string}address
   * @param {RToken}token0
   * @param {RToken}token1
   * @param {number}fee
   * @param {number}A
   * @param {BigNumber}reserve0
   * @param {BigNumber}reserve1
   */
  constructor(address, token0, token1, fee, A, reserve0, reserve1) {
    super(address, token0, token1, fee, reserve0, reserve1);
    this.A_PRECISION = 100;
    this.A = A;
    this.D = BigNumber.from(0);
  }
  /**
   * @param {BigNumber}res0
   * @param {BigNumber}res1
   */
  updateReserves(res0, res1) {
    this.D = BigNumber.from(0);
    this.reserve0 = res0;
    this.reserve1 = res1;
  }
  /**
   * @return {BigNumber}
   */
  computeLiquidity() {
    if (!this.D.eq(0))
      return this.D;
    const r0 = this.reserve0;
    const r1 = this.reserve1;
    if (r0.isZero() && r1.isZero())
      return BigNumber.from(0);
    const s = r0.add(r1);
    const nA = BigNumber.from(this.A * 2);
    let prevD;
    let D = s;
    for (let i = 0; i < 256; i++) {
      const dP = D.mul(D).div(r0).mul(D).div(r1).div(4);
      prevD = D;
      D = nA.mul(s).div(this.A_PRECISION).add(dP.mul(2)).mul(D).div(nA.div(this.A_PRECISION).sub(1).mul(D).add(dP.mul(3)));
      if (D.sub(prevD).abs().lte(1)) {
        break;
      }
    }
    this.D = D;
    return D;
  }
  /**
   * @param {BigNumber} x
   * @return {BigNumber}
   */
  computeY(x) {
    const D = this.computeLiquidity();
    const nA = this.A * 2;
    const c = D.mul(D).div(x.mul(2)).mul(D).div(nA * 2 / this.A_PRECISION);
    const b = D.mul(this.A_PRECISION).div(nA).add(x);
    let yPrev;
    let y = D;
    for (let i = 0; i < 256; i++) {
      yPrev = y;
      y = y.mul(y).add(c).div(y.mul(2).add(b).sub(D));
      if (y.sub(yPrev).abs().lte(1)) {
        break;
      }
    }
    return y;
  }
  /**
   * @param {number}amountIn
   * @param {boolean}direction
   * @return {number}
   */
  calcOutByIn(amountIn, direction) {
    const xBN = direction ? this.reserve0 : this.reserve1;
    const yBN = direction ? this.reserve1 : this.reserve0;
    const xNewBN = xBN.add(getBigNumber(amountIn * (1 - this.fee)));
    const yNewBN = this.computeY(xNewBN);
    const dy = parseInt(yBN.sub(yNewBN).toString());
    if (parseInt(yNewBN.toString()) < this.minLiquidity)
      console.log("Hybrid OutOfLiquidity");
    return { out: dy, gasSpent: this.swapGasCost };
  }
  /**
   * @param {number}amountOut
   * @param {boolean}direction
   * @return {number}
   */
  calcInByOut(amountOut, direction) {
    const xBN = direction ? this.reserve0 : this.reserve1;
    const yBN = direction ? this.reserve1 : this.reserve0;
    let yNewBN = yBN.sub(getBigNumber(amountOut));
    if (yNewBN.lt(1))
      yNewBN = BigNumber.from(1);
    const xNewBN = this.computeY(yNewBN);
    const input = Math.round(parseInt(xNewBN.sub(xBN).toString()) / (1 - this.fee));
    return { inp: input, gasSpent: this.swapGasCost };
  }
  /**
   * @param {boolean}direction
   * @return {number}
   */
  calcCurrentPriceWithoutFee(direction) {
    return this.calcPrice(0, direction, false);
  }
  /**
   * @param {number} amountIn
   * @param {boolean}direction
   * @param {boolean}takeFeeIntoAccount
   * @return {number}
   */
  calcPrice(amountIn, direction, takeFeeIntoAccount) {
    const xBN = direction ? this.reserve0 : this.reserve1;
    const x = parseInt(xBN.toString());
    const oneMinusFee = takeFeeIntoAccount ? 1 - this.fee : 1;
    const D = parseInt(this.computeLiquidity().toString());
    const A = this.A / this.A_PRECISION;
    const xI = x + amountIn;
    const b = 4 * A * xI + D - 4 * A * D;
    const ac4 = D * D * D / xI;
    const Ds = Math.sqrt(b * b + 4 * A * ac4);
    const res = (0.5 - (2 * b - ac4 / xI) / Ds / 4) * oneMinusFee;
    return res;
  }
  /**
   * @param {number} price
   * @param {boolean}direction
   * @param {boolean}takeFeeIntoAccount
   * @param {number} hint
   * @return {number}
   */
  calcInputByPrice(price, direction, takeFeeIntoAccount, hint = 1) {
    return revertPositive(
      (x) => 1 / this.calcPrice(x, direction, takeFeeIntoAccount),
      price,
      hint
    );
  }
};

// src/entities/BridgeBidirectionalUnlimited.ts
var BridgeUnlimited = class extends RPool2 {
  /**
   * @param {string}address
   * @param {RToken}token0
   * @param {RToken}token1
   * @param {number}fee
   * @param {number}swapGasCost
   */
  constructor(address, token0, token1, fee, swapGasCost = 15e4) {
    super(address, token0, token1, fee, BigNumber.from(-1), BigNumber.from(-1), 0, swapGasCost);
  }
  /**
   * @param {number}amountIn
   * @param {boolean}_direction
   * @return {{number, number}}
   */
  calcOutByIn(amountIn, _direction) {
    return { out: amountIn * (1 - this.fee), gasSpent: this.swapGasCost };
  }
  /**
   * @param {number}amountOut
   * @param {boolean}_direction
   * @return {{number, number}}
   */
  calcInByOut(amountOut, _direction) {
    return { inp: amountOut / (1 - this.fee), gasSpent: this.swapGasCost };
  }
  /**
   * @param {boolean}_direction
   * @return {number}
   */
  calcCurrentPriceWithoutFee(_direction) {
    return 1;
  }
  /**
   * @return {boolean}
   */
  alwaysAppropriateForPricing() {
    return true;
  }
};

// src/entities/Graph.ts
var ROUTER_DISTRIBUTION_PORTION = 65535;
var RouteStatus = /* @__PURE__ */ ((RouteStatus2) => {
  RouteStatus2["Success"] = "Success";
  RouteStatus2["NoWay"] = "NoWay";
  RouteStatus2["Partial"] = "Partial";
  return RouteStatus2;
})(RouteStatus || {});
var Edge = class {
  // debug data
  /**
   * @param {RPool} p
   * @param {Vertice} v0
   * @param {Vertice} v1
   */
  constructor(p, v0, v1) {
    this.pool = p;
    this.vert0 = v0;
    this.vert1 = v1;
    this.amountInPrevious = 0;
    this.amountOutPrevious = 0;
    this.canBeUsed = true;
    this.direction = true;
    this.spentGas = 0;
    this.spentGasNew = 0;
    this.bestEdgeIncome = 0;
  }
  /** */
  cleanTmpData() {
    this.amountInPrevious = 0;
    this.amountOutPrevious = 0;
    this.canBeUsed = true;
    this.direction = true;
    this.spentGas = 0;
    this.spentGasNew = 0;
    this.bestEdgeIncome = 0;
  }
  /**
   * @param {Vertice} v
   * @return {BigNumber}
   */
  reserve(v) {
    return v === this.vert0 ? this.pool.getReserve0() : this.pool.getReserve1();
  }
  /**
   * @param {Vertice} v
   * @param {number} amountIn
   * @return {{number, number}}
   */
  calcOutput(v, amountIn) {
    let res;
    let gas;
    if (v === this.vert1) {
      if (this.direction) {
        if (amountIn < this.amountOutPrevious) {
          const { inp, gasSpent } = this.pool.calcInByOut(this.amountOutPrevious - amountIn, true);
          res = this.amountInPrevious - inp;
          gas = gasSpent;
        } else {
          const { out, gasSpent } = this.pool.calcOutByIn(amountIn - this.amountOutPrevious, false);
          res = out + this.amountInPrevious;
          gas = gasSpent;
        }
      } else {
        const { out, gasSpent } = this.pool.calcOutByIn(this.amountOutPrevious + amountIn, false);
        res = out - this.amountInPrevious;
        gas = gasSpent;
      }
    } else {
      if (this.direction) {
        const { out, gasSpent } = this.pool.calcOutByIn(this.amountInPrevious + amountIn, true);
        res = out - this.amountOutPrevious;
        gas = gasSpent;
      } else {
        if (amountIn < this.amountInPrevious) {
          const { inp, gasSpent } = this.pool.calcInByOut(this.amountInPrevious - amountIn, false);
          res = this.amountOutPrevious - inp;
          gas = gasSpent;
        } else {
          const { out, gasSpent } = this.pool.calcOutByIn(amountIn - this.amountInPrevious, true);
          res = out + this.amountOutPrevious;
          gas = gasSpent;
        }
      }
    }
    return { out: res, gasSpent: gas - this.spentGas };
  }
  /**
   * @param {Vertice} v
   * @param {number} amountOut
   * @return {{number, number}}
   */
  calcInput(v, amountOut) {
    let res;
    let gas;
    if (v === this.vert1) {
      if (!this.direction) {
        if (amountOut < this.amountOutPrevious) {
          const { out, gasSpent } = this.pool.calcOutByIn(this.amountOutPrevious - amountOut, false);
          res = this.amountInPrevious - out;
          gas = gasSpent;
        } else {
          const { inp, gasSpent } = this.pool.calcInByOut(amountOut - this.amountOutPrevious, true);
          res = inp + this.amountInPrevious;
          gas = gasSpent;
        }
      } else {
        const { inp, gasSpent } = this.pool.calcInByOut(this.amountOutPrevious + amountOut, true);
        res = inp - this.amountInPrevious;
        gas = gasSpent;
      }
    } else {
      if (!this.direction) {
        const { inp, gasSpent } = this.pool.calcInByOut(this.amountInPrevious + amountOut, false);
        res = inp - this.amountOutPrevious;
        gas = gasSpent;
      } else {
        if (amountOut < this.amountInPrevious) {
          const { out, gasSpent } = this.pool.calcOutByIn(this.amountInPrevious - amountOut, true);
          res = this.amountOutPrevious - out;
          gas = gasSpent;
        } else {
          const { inp, gasSpent } = this.pool.calcInByOut(amountOut - this.amountInPrevious, false);
          res = inp + this.amountOutPrevious;
          gas = gasSpent;
        }
      }
    }
    return { inp: res, gasSpent: gas - this.spentGas };
  }
  /**
   * @param {Vertice} from
   * @param {number} amountOut
   * @return {boolean}
   */
  checkMinimalLiquidityExceededAfterSwap(from, amountOut) {
    if (from === this.vert0) {
      const r1 = parseInt(this.pool.getReserve1().toString());
      if (this.direction) {
        return r1 - amountOut - this.amountOutPrevious < this.pool.minLiquidity;
      } else {
        return r1 - amountOut + this.amountOutPrevious < this.pool.minLiquidity;
      }
    } else {
      const r0 = parseInt(this.pool.getReserve0().toString());
      if (this.direction) {
        return r0 - amountOut + this.amountInPrevious < this.pool.minLiquidity;
      } else {
        return r0 - amountOut - this.amountInPrevious < this.pool.minLiquidity;
      }
    }
  }
  // doesn't used in production - just for testing
  /**
   * @param {Vertice} from
   * @param {number} amountIn
   * @param {number} amountOut
   * @return {string}
   */
  testApply(from, amountIn, amountOut) {
    console.assert(this.amountInPrevious * this.amountOutPrevious >= 0);
    const inPrev = this.direction ? this.amountInPrevious : -this.amountInPrevious;
    const outPrev = this.direction ? this.amountOutPrevious : -this.amountOutPrevious;
    const to = from.getNeibour(this);
    let directionNew;
    let amountInNew = 0;
    let amountOutNew = 0;
    if (to) {
      const inInc = from === this.vert0 ? amountIn : -amountOut;
      const outInc = from === this.vert0 ? amountOut : -amountIn;
      const inNew = inPrev + inInc;
      const outNew = outPrev + outInc;
      console.assert(inNew * outNew >= 0);
      if (inNew >= 0) {
        directionNew = true;
        amountInNew = inNew;
        amountOutNew = outNew;
      } else {
        directionNew = false;
        amountInNew = -inNew;
        amountOutNew = -outNew;
      }
    } else
      console.error("Error 221");
    if (directionNew) {
      const calc = this.pool.calcOutByIn(amountInNew, true).out;
      const res = closeValues(amountOutNew, calc, 1e-6);
      if (!res)
        console.log("Err 225-1 !!", amountOutNew, calc, Math.abs(calc / amountOutNew - 1));
      return res;
    } else {
      const calc = this.pool.calcOutByIn(amountOutNew, false).out;
      const res = closeValues(amountInNew, calc, 1e-6);
      if (!res)
        console.log("Err 225-2!!", amountInNew, calc, Math.abs(calc / amountInNew - 1));
      return res;
    }
  }
  /**
   * @param {Vertice} from
   */
  applySwap(from) {
    console.assert(this.amountInPrevious * this.amountOutPrevious >= 0);
    const inPrev = this.direction ? this.amountInPrevious : -this.amountInPrevious;
    const outPrev = this.direction ? this.amountOutPrevious : -this.amountOutPrevious;
    const to = from.getNeibour(this);
    if (to) {
      const inInc = from === this.vert0 ? from.bestIncome : -to.bestIncome;
      const outInc = from === this.vert0 ? to.bestIncome : -from.bestIncome;
      const inNew = inPrev + inInc;
      const outNew = outPrev + outInc;
      console.assert(inNew * outNew >= 0);
      if (inNew >= 0) {
        this.direction = true;
        this.amountInPrevious = inNew;
        this.amountOutPrevious = outNew;
      } else {
        this.direction = false;
        this.amountInPrevious = -inNew;
        this.amountOutPrevious = -outNew;
      }
    } else
      console.error("Error 221");
    this.spentGas = this.spentGasNew;
    ASSERT(() => {
      const precision = 1e-9;
      if (this.direction) {
        const granularity = this.pool.granularity1();
        return closeValues(
          this.amountOutPrevious / granularity,
          this.pool.calcOutByIn(this.amountInPrevious, this.direction).out / granularity,
          precision
        );
      } else {
        const granularity = this.pool.granularity0();
        return closeValues(
          this.amountInPrevious / granularity,
          this.pool.calcOutByIn(this.amountOutPrevious, this.direction).out / granularity,
          precision
        );
      }
    }, `Error 225`);
  }
};
var Vertice = class {
  // debug data
  /**
   * @param {RToken} t
   */
  constructor(t) {
    this.token = t;
    setTokenId(this.token);
    this.edges = [];
    this.price = 0;
    this.gasPrice = 0;
    this.bestIncome = 0;
    this.gasSpent = 0;
    this.bestTotal = 0;
    this.bestSource = void 0;
    this.checkLine = -1;
  }
  /** */
  cleanTmpData() {
    this.bestIncome = 0;
    this.gasSpent = 0;
    this.bestTotal = 0;
    this.bestSource = void 0;
    this.checkLine = -1;
  }
  /**
   * @param {Edge} e
   * @return {Vertice}
   */
  getNeibour(e) {
    if (!e)
      return;
    return e.vert0 === this ? e.vert1 : e.vert0;
  }
  /**
   * @return {Edge[]}
   */
  getOutputEdges() {
    return this.edges.filter((e) => {
      if (!e.canBeUsed)
        return false;
      if (e.amountInPrevious === 0)
        return false;
      if (e.direction !== (e.vert0 === this))
        return false;
      return true;
    });
  }
  /**
   * @return {Edge[]}
   */
  getInputEdges() {
    return this.edges.filter((e) => {
      if (!e.canBeUsed)
        return false;
      if (e.amountInPrevious === 0)
        return false;
      if (e.direction === (e.vert0 === this))
        return false;
      return true;
    });
  }
};
var Graph = class {
  // Single network usage: (pools, baseToken, gasPrice)
  // Multiple Network usage: (pools, networks)
  /**
   * @param {RPool[]}pools
   * @param {RToken}start
   * @param {RToken | NetworkInfo[]}baseTokenOrNetworks
   * @param {number}gasPriceSingleNetwork
   * @param {number}minPriceLiquidity
   * @param {boolean} priceLogging
   */
  constructor(pools, start, baseTokenOrNetworks, gasPriceSingleNetwork, minPriceLiquidity = 0, priceLogging = false) {
    const networks = baseTokenOrNetworks instanceof Array ? baseTokenOrNetworks : [
      {
        chainId: baseTokenOrNetworks.chainId,
        baseToken: baseTokenOrNetworks,
        // baseTokenPrice: 1,
        gasPrice: gasPriceSingleNetwork || 0
      }
    ];
    setTokenId(...networks.map((n) => n.baseToken));
    this.vertices = [];
    this.edges = [];
    this.tokens = /* @__PURE__ */ new Map();
    pools.forEach((p) => {
      const v0 = this.getOrCreateVertice(p.token0);
      const v1 = this.getOrCreateVertice(p.token1);
      const edge = new Edge(p, v0, v1);
      v0.edges.push(edge);
      v1.edges.push(edge);
      this.edges.push(edge);
    });
    const startV = this.getVert(start);
    if (startV !== void 0)
      this.setPricesStable(startV, 1, networks, minPriceLiquidity, priceLogging);
  }
  /**
   * @param {RToken} t
   * @return {Vertice | undefined}
   */
  getVert(t) {
    return this.tokens.get(t.tokenId);
  }
  /** */
  cleanTmpData() {
    this.edges.forEach((e) => e.cleanTmpData());
    this.vertices.forEach((v) => v.cleanTmpData());
  }
  /** Set prices using greedy algorithm
   * @param {Vertice} from
   * @param {number} price
   * @param {NetworkInfo[]} networks
   * @param {number}minLiquidity
   * @param {boolean} logging
   */
  setPricesStable(from, price, networks, minLiquidity = 0, logging = false) {
    const processedVert = /* @__PURE__ */ new Set();
    let nextEdges = [];
    const edgeValues = /* @__PURE__ */ new Map();
    const value = (e) => edgeValues.get(e);
    function addVertice(v, price2) {
      v.price = price2;
      const newEdges = v.edges.filter((e) => {
        if (processedVert.has(v.getNeibour(e)))
          return false;
        if (e.pool.alwaysAppropriateForPricing())
          return true;
        const liquidity = price2 * parseInt(e.reserve(v).toString());
        if (liquidity < minLiquidity)
          return false;
        edgeValues.set(e, liquidity);
        return true;
      });
      newEdges.sort((e1, e2) => value(e1) - value(e2));
      const res = [];
      while (nextEdges.length && newEdges.length) {
        if (value(nextEdges[0]) < value(newEdges[0]))
          res.push(nextEdges.shift());
        else
          res.push(newEdges.shift());
      }
      nextEdges = [...res, ...nextEdges, ...newEdges];
      processedVert.add(v);
    }
    if (logging)
      console.log(`Pricing: Initial token ${from.token.symbol} price=${price}`);
    addVertice(from, price);
    while (nextEdges.length > 0) {
      const bestEdge = nextEdges.pop();
      const [vFrom, vTo] = processedVert.has(bestEdge.vert1) ? [bestEdge.vert1, bestEdge.vert0] : [bestEdge.vert0, bestEdge.vert1];
      if (processedVert.has(vTo))
        continue;
      const p = bestEdge.pool.calcCurrentPriceWithoutFee(vFrom === bestEdge.vert1);
      if (logging)
        console.log(
          `Pricing: + Token ${vTo.token.symbol} price=${vFrom.price * p} from ${vFrom.token.symbol} pool=${bestEdge.pool.address} liquidity=${edgeValues.get(
            bestEdge
          )}`
        );
      addVertice(vTo, vFrom.price * p);
    }
    const gasPrice = /* @__PURE__ */ new Map();
    networks.forEach((n) => {
      var _a;
      const vPrice = ((_a = this.getVert(n.baseToken)) == null ? void 0 : _a.price) || 0;
      gasPrice.set(n.chainId, n.gasPrice * vPrice);
    });
    processedVert.forEach((v) => {
      const gasPriceChainId = gasPrice.get(v.token.chainId);
      console.assert(gasPriceChainId !== void 0, "Error 427");
      console.assert(v.price !== 0, "Error 428");
      v.gasPrice = gasPriceChainId / v.price;
    });
  }
  /** Set prices using greedy algorithm
   * @param {Vertice} from
   * @param {number} price
   * @param {number} gasPrice
   */
  setPricesStableInsideChain(from, price, gasPrice) {
    const processedVert = /* @__PURE__ */ new Set();
    let nextEdges = [];
    const edgeValues = /* @__PURE__ */ new Map();
    const value = (e) => edgeValues.get(e);
    function addVertice(v, price2, gasPrice2) {
      v.price = price2;
      v.gasPrice = gasPrice2;
      const newEdges = v.edges.filter((e) => {
        const newV = v.getNeibour(e);
        return (newV == null ? void 0 : newV.token.chainId) === v.token.chainId && !processedVert.has(v.getNeibour(e));
      });
      newEdges.forEach((e) => edgeValues.set(e, price2 * parseInt(e.reserve(v).toString())));
      newEdges.sort((e1, e2) => value(e1) - value(e2));
      const res = [];
      while (nextEdges.length && newEdges.length) {
        if (value(nextEdges[0]) < value(newEdges[0]))
          res.push(nextEdges.shift());
        else
          res.push(newEdges.shift());
      }
      nextEdges = [...res, ...nextEdges, ...newEdges];
      processedVert.add(v);
    }
    addVertice(from, price, gasPrice);
    while (nextEdges.length > 0) {
      const bestEdge = nextEdges.pop();
      const [vFrom, vTo] = processedVert.has(bestEdge.vert1) ? [bestEdge.vert1, bestEdge.vert0] : [bestEdge.vert0, bestEdge.vert1];
      if (processedVert.has(vTo))
        continue;
      const p = bestEdge.pool.calcCurrentPriceWithoutFee(vFrom === bestEdge.vert1);
      addVertice(vTo, vFrom.price * p, vFrom.gasPrice / p);
    }
  }
  /** Set prices by search in depth
   * @param {Vertice} from
   * @param {number} price
   * @param {number} gasPrice
   */
  setPrices(from, price, gasPrice) {
    if (from.price !== 0)
      return;
    from.price = price;
    from.gasPrice = gasPrice;
    const edges = from.edges.map((e) => [e, parseInt(e.reserve(from).toString())]).sort(([_1, r1], [_2, r2]) => r2 - r1);
    edges.forEach(([e, _]) => {
      const v = e.vert0 === from ? e.vert1 : e.vert0;
      if (v.price !== 0)
        return;
      const p = e.pool.calcCurrentPriceWithoutFee(from === e.vert1);
      this.setPrices(v, price * p, gasPrice / p);
    });
  }
  /**
   * @param {RToken} token
   * @return {Vertice}
   */
  getOrCreateVertice(token) {
    let vert = this.getVert(token);
    if (vert)
      return vert;
    vert = new Vertice(token);
    this.vertices.push(vert);
    this.tokens.set(token.tokenId, vert);
    return vert;
  }
  /* exportPath(from: RToken, to: RToken) {
  
      const fromVert = this.getVert(from) as Vertice
      const toVert = this.getVert(to) as Vertice
      const initValue = (fromVert.bestIncome * fromVert.price) / toVert.price
  
      const route = new Set<Edge>()
      for (let v = toVert; v !== fromVert; v = v.getNeibour(v.bestSource) as Vertice) {
        if (v.bestSource) route.add(v.bestSource)
      }
  
      function edgeStyle(e: Edge) {
        const finish = e.vert1.bestSource === e
        const start = e.vert0.bestSource === e
        let label
        if (e.bestEdgeIncome === -1) label = 'label: "low_liq"'
        if (e.bestEdgeIncome !== 0) label = `label: "${print((e.bestEdgeIncome / initValue - 1) * 100, 3)}%"`
        const edgeValue = route.has(e) ? 'value: 2' : undefined
        let arrow
        if (finish && start) arrow = 'arrows: "from,to"'
        if (finish) arrow = 'arrows: "to"'
        if (start) arrow = 'arrows: "from"'
        return ['', label, edgeValue, arrow].filter((a) => a !== undefined).join(', ')
      }
  
      function print(n: number, digits: number) {
        let out
        if (n === 0) out = '0'
        else {
          const n0 = n > 0 ? n : -n
          const shift = digits - Math.ceil(Math.log(n0) / Math.LN10)
          if (shift <= 0) out = `${Math.round(n0)}`
          else {
            const mult = Math.pow(10, shift)
            out = `${Math.round(n0 * mult) / mult}`
          }
          if (n < 0) out = -out
        }
        return out
      }
  
      function nodeLabel(v: Vertice) {
        const value = (v.bestIncome * v.price) / toVert.price
        const income = `${print(value, 3)}`
        const total = `${print(v.bestTotal, 3)}`
        // const income = `${print((value/initValue-1)*100, 3)}%`
        // const total = `${print((v.bestTotal/initValue-1)*100, 3)}%`
        const checkLine = v.checkLine === -1 ? undefined : `${v.checkLine}`
        return [checkLine, income, total].filter((a) => a !== undefined).join(':')
      }
  
      const nodes = `var nodes = new vis.DataSet([
        ${this.vertices.map((t) => `{ id: ${t.token.name}, label: "${nodeLabel(t)}"}`).join(',\n\t\t')}
      ]);\n`
      const edges = `var edges = new vis.DataSet([
        ${this.edges
          .map((p) => `{ from: ${p.vert0.token.name}, to: ${p.vert1.token.name}${edgeStyle(p)}}`)
          .join(',\n\t\t')}
      ]);\n`
      const data = `var data = {
          nodes: nodes,
          edges: edges,
      };\n`
  
      // TODO: This should be removed, this pacakge will not be installable on a client while this remains.
      const fs = require("fs");
      fs.writeFileSync(
        "D:/Info/Notes/GraphVisualization/data.js",
        nodes + edges + data
      );
    }*/
  /**
   * @param {RToken}from
   * @param {RToken}to
   * @param {number}amountIn
   * @return {[Edge[], number, number, number]}
   */
  findBestPathExactIn(from, to, amountIn) {
    const start = this.getVert(from);
    const finish = this.getVert(to);
    if (!start || !finish)
      return;
    this.edges.forEach((e) => {
      e.bestEdgeIncome = 0;
      e.spentGasNew = 0;
    });
    this.vertices.forEach((v) => {
      v.bestIncome = 0;
      v.gasSpent = 0;
      v.bestTotal = 0;
      v.bestSource = void 0;
      v.checkLine = -1;
    });
    start.bestIncome = amountIn;
    start.bestTotal = amountIn;
    const processedVert = /* @__PURE__ */ new Set();
    const nextVertList = [start];
    let debug_info = ``;
    let checkLine = 0;
    for (; ; ) {
      let closestVert;
      let closestTotal;
      let closestPosition = 0;
      nextVertList.forEach((v, i) => {
        if (closestTotal === void 0 || v.bestTotal > closestTotal) {
          closestTotal = v.bestTotal;
          closestVert = v;
          closestPosition = i;
        }
      });
      if (!closestVert)
        return;
      closestVert.checkLine = checkLine++;
      if (closestVert === finish) {
        const bestPath = [];
        for (let v = finish; v == null ? void 0 : v.bestSource; v = v.getNeibour(v.bestSource)) {
          bestPath.unshift(v.bestSource);
        }
        DEBUG(() => console.log(debug_info));
        return {
          path: bestPath,
          output: finish.bestIncome,
          gasSpent: finish.gasSpent,
          totalOutput: finish.bestTotal
        };
      }
      nextVertList.splice(closestPosition, 1);
      closestVert.edges.forEach((e) => {
        const v2 = closestVert === e.vert0 ? e.vert1 : e.vert0;
        if (processedVert.has(v2))
          return;
        let newIncome;
        let gas;
        try {
          const { out, gasSpent } = e.calcOutput(
            closestVert,
            closestVert.bestIncome
          );
          if (!isFinite(out) || !isFinite(gasSpent))
            return;
          newIncome = out;
          gas = gasSpent;
        } catch (err) {
          e.bestEdgeIncome = -1;
          return;
        }
        const newGasSpent = closestVert.gasSpent + gas;
        const price = v2.price / finish.price;
        const gasPrice = v2.gasPrice * price;
        const newTotal = newIncome * price - newGasSpent * gasPrice;
        console.assert(e.bestEdgeIncome === 0, "Error 373");
        e.bestEdgeIncome = newIncome * price;
        e.spentGasNew = e.spentGas + gas;
        if (!v2.bestSource)
          nextVertList.push(v2);
        if (!v2.bestSource || newTotal > v2.bestTotal) {
          DEBUG(() => {
            const st = (closestVert == null ? void 0 : closestVert.token) == from ? "*" : "";
            const fn = (v2 == null ? void 0 : v2.token) == to ? "*" : "";
            debug_info += `${st}${closestVert == null ? void 0 : closestVert.token.name}->${v2.token.name}${fn} ${v2.bestIncome} -> ${newIncome}
`;
          });
          v2.bestIncome = newIncome;
          v2.gasSpent = newGasSpent;
          v2.bestTotal = newTotal;
          v2.bestSource = e;
        }
      });
      processedVert.add(closestVert);
    }
  }
  /**
   * @param {RToken}from
   * @param {RToken}to
   * @param {number}amountOut
   * @return {[Edge[], number, number, number]}
   */
  findBestPathExactOut(from, to, amountOut) {
    const start = this.getVert(to);
    const finish = this.getVert(from);
    if (!start || !finish)
      return;
    this.edges.forEach((e) => {
      e.bestEdgeIncome = 0;
      e.spentGasNew = 0;
    });
    this.vertices.forEach((v) => {
      v.bestIncome = 0;
      v.gasSpent = 0;
      v.bestTotal = 0;
      v.bestSource = void 0;
      v.checkLine = -1;
    });
    start.bestIncome = amountOut;
    start.bestTotal = amountOut;
    const processedVert = /* @__PURE__ */ new Set();
    const nextVertList = [start];
    let debug_info = "";
    let checkLine = 0;
    for (; ; ) {
      let closestVert;
      let closestTotal;
      let closestPosition = 0;
      nextVertList.forEach((v, i) => {
        if (closestTotal === void 0 || v.bestTotal < closestTotal) {
          closestTotal = v.bestTotal;
          closestVert = v;
          closestPosition = i;
        }
      });
      if (!closestVert)
        return;
      closestVert.checkLine = checkLine++;
      if (closestVert === finish) {
        const bestPath = [];
        for (let v = finish; v == null ? void 0 : v.bestSource; v = v.getNeibour(v.bestSource)) {
          bestPath.push(v.bestSource);
        }
        DEBUG(() => console.log(debug_info));
        return {
          path: bestPath,
          input: finish.bestIncome,
          gasSpent: finish.gasSpent,
          totalInput: finish.bestTotal
        };
      }
      nextVertList.splice(closestPosition, 1);
      closestVert.edges.forEach((e) => {
        const v2 = closestVert === e.vert0 ? e.vert1 : e.vert0;
        if (processedVert.has(v2))
          return;
        let newIncome;
        let gas;
        try {
          const { inp, gasSpent } = e.calcInput(
            closestVert,
            closestVert.bestIncome
          );
          if (!isFinite(inp) || !isFinite(gasSpent))
            return;
          if (inp < 0)
            return;
          newIncome = inp;
          gas = gasSpent;
        } catch (e2) {
          return;
        }
        const newGasSpent = closestVert.gasSpent + gas;
        const price = v2.price / finish.price;
        const gasPrice = v2.gasPrice * price;
        const newTotal = newIncome * price + newGasSpent * gasPrice;
        console.assert(e.bestEdgeIncome === 0, "Error 373");
        e.bestEdgeIncome = newIncome * price;
        e.spentGasNew = e.spentGas + gas;
        if (!v2.bestSource)
          nextVertList.push(v2);
        if (!v2.bestSource || newTotal < v2.bestTotal) {
          DEBUG(() => {
            const st = (v2 == null ? void 0 : v2.token) == from ? "*" : "";
            const fn = (closestVert == null ? void 0 : closestVert.token) == to ? "*" : "";
            debug_info += `${st}${closestVert == null ? void 0 : closestVert.token.name}<-${v2.token.name}${fn} ${v2.bestIncome} -> ${newIncome}
`;
          });
          v2.bestIncome = newIncome;
          v2.gasSpent = newGasSpent;
          v2.bestTotal = newTotal;
          v2.bestSource = e;
        }
      });
      processedVert.add(closestVert);
    }
  }
  /**
   * @param {Vertice | undefined} from
   * @param {Vertice | undefined} to
   * @param {Edge[]} path
   */
  addPath(from, to, path) {
    let _from = from;
    path.forEach((e) => {
      if (_from) {
        e.applySwap(_from);
        _from = _from.getNeibour(e);
      } else {
        console.error("Unexpected 315");
      }
    });
    ASSERT(() => {
      const res = this.vertices.every((v) => {
        let total = 0;
        let totalModule = 0;
        v.edges.forEach((e) => {
          if (e.vert0 === v) {
            if (e.direction) {
              total -= e.amountInPrevious;
            } else {
              total += e.amountInPrevious;
            }
            totalModule += e.amountInPrevious;
          } else {
            if (e.direction) {
              total += e.amountOutPrevious;
            } else {
              total -= e.amountOutPrevious;
            }
            totalModule += e.amountOutPrevious;
          }
        });
        if (v === from)
          return total <= 0;
        if (v === to)
          return total >= 0;
        if (totalModule === 0)
          return total === 0;
        return Math.abs(total / totalModule) < 1e10;
      });
      return res;
    }, "Error 290");
  }
  /**
   * @param {Vertice | undefined} from
   * @param {Edge[]} path
   * @return {number}
   */
  getPrimaryPriceForPath(from, path) {
    let p = 1;
    let prevToken = from;
    path.forEach((edge) => {
      const direction = edge.vert0 === prevToken;
      const edgePrice = edge.pool.calcCurrentPriceWithoutFee(direction);
      p *= edgePrice;
      prevToken = prevToken.getNeibour(edge);
    });
    return p;
  }
  /**
   * @param {RToken} from
   * @param {RToken} to
   * @param {BigNumber | number} amountIn
   * @param {number | number[]} mode
   * @return {MultiRoute}
   */
  findBestRouteExactIn(from, to, amountIn, mode) {
    var _a, _b;
    let amountInBN;
    if (amountIn instanceof BigNumber) {
      amountInBN = amountIn;
      amountIn = parseInt(amountIn.toString());
    } else {
      amountInBN = getBigNumber(amountIn);
    }
    let routeValues = [];
    if (Array.isArray(mode)) {
      const sum = mode.reduce((a, b) => a + b, 0);
      routeValues = mode.map((e) => e / sum);
    } else {
      for (let i = 0; i < mode; ++i)
        routeValues.push(1 / mode);
    }
    this.edges.forEach((e) => {
      e.amountInPrevious = 0;
      e.amountOutPrevious = 0;
      e.direction = true;
    });
    let output = 0;
    let gasSpentInit = 0;
    let totalOutput = 0;
    let totalrouted = 0;
    let primaryPrice;
    let step;
    for (step = 0; step < routeValues.length; ++step) {
      const p = this.findBestPathExactIn(from, to, amountIn * routeValues[step]);
      if (!p) {
        break;
      } else {
        output += p.output;
        gasSpentInit += p.gasSpent;
        totalOutput += p.totalOutput;
        this.addPath(this.getVert(from), this.getVert(to), p.path);
        totalrouted += routeValues[step];
      }
    }
    if (step == 0 || output == 0)
      return {
        status: "NoWay" /* NoWay */,
        fromToken: from,
        toToken: to,
        amountIn: 0,
        amountInBN: BigNumber.from(0),
        amountOut: 0,
        amountOutBN: BigNumber.from(0),
        legs: [],
        gasSpent: 0,
        totalAmountOut: 0,
        totalAmountOutBN: BigNumber.from(0)
      };
    let status;
    if (step < routeValues.length)
      status = "Partial" /* Partial */;
    else
      status = "Success" /* Success */;
    this.removeEdgesWithLowFlow(1e-3);
    const fromVert = this.getVert(from);
    const toVert = this.getVert(to);
    const { legs, gasSpent } = this.getRouteLegs(fromVert, toVert);
    console.assert(gasSpent <= gasSpentInit, "Internal Error 491");
    output = this.updateLegsAmountOut(legs, amountIn * totalrouted);
    totalOutput = output - toVert.gasPrice * gasSpent;
    if (output == 0) {
      status = "NoWay" /* NoWay */;
      totalOutput = 0;
    }
    let swapPrice;
    let priceImpact;
    try {
      swapPrice = output / amountIn / totalrouted;
      const priceTo = (_a = this.getVert(to)) == null ? void 0 : _a.price;
      const priceFrom = (_b = this.getVert(from)) == null ? void 0 : _b.price;
      primaryPrice = priceTo && priceFrom ? priceFrom / priceTo : void 0;
      priceImpact = primaryPrice !== void 0 ? 1 - swapPrice / primaryPrice : void 0;
    } catch (e) {
    }
    return {
      status,
      fromToken: from,
      toToken: to,
      primaryPrice,
      swapPrice,
      priceImpact,
      amountIn: amountIn * totalrouted,
      amountInBN: status == "Success" /* Success */ ? amountInBN : getBigNumber(amountIn * totalrouted),
      amountOut: output,
      amountOutBN: getBigNumber(output),
      legs,
      gasSpent,
      totalAmountOut: totalOutput,
      totalAmountOutBN: getBigNumber(totalOutput)
    };
  }
  /**
   * @param {RToken} from
   * @param {RToken} to
   * @param {BigNumber | number} amountOut
   * @param {number | number[]} mode
   * @return {MultiRoute}
   */
  findBestRouteExactOut(from, to, amountOut, mode) {
    var _a, _b;
    let routeValues = [];
    if (Array.isArray(mode)) {
      const sum = mode.reduce((a, b) => a + b, 0);
      routeValues = mode.map((e) => e / sum);
    } else {
      for (let i = 0; i < mode; ++i)
        routeValues.push(1 / mode);
    }
    this.edges.forEach((e) => {
      e.amountInPrevious = 0;
      e.amountOutPrevious = 0;
      e.direction = true;
    });
    let input = 0;
    let gasSpentInit = 0;
    let totalrouted = 0;
    let primaryPrice;
    let step;
    for (step = 0; step < routeValues.length; ++step) {
      const p = this.findBestPathExactOut(from, to, amountOut * routeValues[step]);
      if (!p) {
        break;
      } else {
        input += p.input;
        gasSpentInit += p.gasSpent;
        this.addPath(this.getVert(from), this.getVert(to), p.path);
        totalrouted += routeValues[step];
      }
    }
    if (step == 0)
      return {
        status: "NoWay" /* NoWay */,
        fromToken: from,
        toToken: to,
        amountIn: 0,
        amountInBN: BigNumber.from(0),
        amountOut: 0,
        amountOutBN: BigNumber.from(0),
        legs: [],
        gasSpent: 0,
        totalAmountOut: 0,
        totalAmountOutBN: BigNumber.from(0)
      };
    let status;
    if (step < routeValues.length)
      status = "Partial" /* Partial */;
    else
      status = "Success" /* Success */;
    const removedEdgesNumber = this.removeEdgesWithLowFlow(1e-3);
    const fromVert = this.getVert(from);
    const toVert = this.getVert(to);
    const { legs, gasSpent, topologyWasChanged } = this.getRouteLegs(fromVert, toVert);
    console.assert(gasSpent <= gasSpentInit, "Internal Error 491");
    if (topologyWasChanged || removedEdgesNumber > 0) {
      input = this.calcLegsAmountIn(legs, amountOut);
    }
    let swapPrice;
    let priceImpact;
    try {
      swapPrice = amountOut / input;
      const priceTo = (_a = this.getVert(to)) == null ? void 0 : _a.price;
      const priceFrom = (_b = this.getVert(from)) == null ? void 0 : _b.price;
      primaryPrice = priceTo && priceFrom ? priceFrom / priceTo : void 0;
      priceImpact = primaryPrice !== void 0 ? 1 - swapPrice / primaryPrice : void 0;
    } catch (e) {
    }
    return {
      status,
      fromToken: from,
      toToken: to,
      primaryPrice,
      swapPrice,
      priceImpact,
      amountIn: input,
      amountInBN: getBigNumber(input),
      amountOut: amountOut * totalrouted,
      amountOutBN: getBigNumber(amountOut * totalrouted),
      legs,
      gasSpent,
      totalAmountOut: amountOut - gasSpent * toVert.gasPrice,
      // TODO: should be totalAmountIn instead !!!!
      totalAmountOutBN: getBigNumber(amountOut - gasSpent * toVert.gasPrice)
      // TODO: should be totalAmountInBN instead !!!!
    };
  }
  /**
   * @param {Vertice}from
   * @param {Vertice}to
   * @return {[RouteLeg[], number, boolean]}
   */
  getRouteLegs(from, to) {
    const { vertices, topologyWasChanged } = this.cleanTopology(from, to);
    const legs = [];
    let gasSpent = 0;
    vertices.forEach((n) => {
      const outEdges = n.getOutputEdges().map((e) => {
        const from2 = this.edgeFrom(e);
        return from2 ? [e, from2.vert, from2.amount] : [e];
      });
      let outAmount = outEdges.reduce((a, b) => a + b[2], 0);
      if (outAmount <= 0)
        return;
      const total = outAmount;
      outEdges.forEach((e, i) => {
        const p = e[2];
        const quantity = i + 1 === outEdges.length ? 1 : p / outAmount;
        const edge = e[0];
        const poolType = edge.pool instanceof BridgeUnlimited ? "Wrap" : edge.pool instanceof ConstantProductRPool ? "Classic" : "Unknown";
        legs.push({
          poolAddress: edge.pool.address,
          poolType,
          poolFee: edge.pool.fee,
          tokenFrom: n.token,
          tokenTo: n.getNeibour(edge).token,
          assumedAmountIn: edge.direction ? edge.amountInPrevious : edge.amountOutPrevious,
          assumedAmountOut: edge.direction ? edge.amountOutPrevious : edge.amountInPrevious,
          swapPortion: quantity,
          absolutePortion: p / total
        });
        gasSpent += e[0].pool.swapGasCost;
        outAmount -= p;
      });
      console.assert(outAmount / total < 1e-12, "Error 281");
    });
    return { legs, gasSpent, topologyWasChanged };
  }
  /**
   * @param {Edge} e
   * @return {[Vertice, number] | undefined}
   */
  edgeFrom(e) {
    if (e.amountInPrevious === 0)
      return void 0;
    return e.direction ? { vert: e.vert0, amount: e.amountInPrevious } : { vert: e.vert1, amount: e.amountOutPrevious };
  }
  /**  Removes all edges that have lesser than minFraction portion of vertex output liquidity
   *   Such edges can appear as an accumulation of forward and backward streams
   *   They spend more gas than provide slippage reduction
   *   They confuse users
   *   Also, route processor can fail trying to process them
   * @param {number} minFraction
   * @return {number}
   */
  removeEdgesWithLowFlow(minFraction) {
    const weakEdgeList = [];
    this.vertices.forEach((v) => {
      const outEdges = v.getOutputEdges();
      if (outEdges.length <= 1)
        return;
      const amounts = outEdges.map((e) => {
        const data = this.edgeFrom(e);
        if (data !== void 0)
          return data.amount;
        console.error("Tines: Internal Error 1123");
        return;
      });
      const totalOut = amounts.reduce((a, b) => a += b, 0);
      outEdges.forEach((e, i) => {
        if (amounts[i] / totalOut < minFraction)
          weakEdgeList.push(e);
      });
    });
    weakEdgeList.forEach((e) => e.canBeUsed = false);
    return weakEdgeList.length;
  }
  /** returns route output
   * @param {RouteLeg[]} legs
   * @param {number} amountIn
   * @return {number}
   */
  updateLegsAmountOut(legs, amountIn) {
    const amounts = /* @__PURE__ */ new Map();
    amounts.set(legs[0].tokenFrom.tokenId, amountIn);
    legs.forEach((l) => {
      const vert = this.getVert(l.tokenFrom);
      console.assert(vert !== void 0, "Internal Error 570");
      const edge = vert.edges.find((e) => e.pool.address === l.poolAddress);
      console.assert(edge !== void 0, "Internel Error 569");
      const pool = edge.pool;
      const direction = vert === edge.vert0;
      const inputTotal = amounts.get(l.tokenFrom.tokenId);
      console.assert(inputTotal !== void 0, "Internal Error 564");
      const routerPortion = Math.round(l.swapPortion * ROUTER_DISTRIBUTION_PORTION) / ROUTER_DISTRIBUTION_PORTION;
      const input = Math.floor(inputTotal * routerPortion);
      amounts.set(l.tokenFrom.tokenId, inputTotal - input);
      const output = pool.calcOutByInReal(input, direction);
      const vertNext = vert.getNeibour(edge);
      const prevAmount = amounts.get(vertNext.token.tokenId);
      amounts.set(vertNext.token.tokenId, (prevAmount || 0) + output);
      l.assumedAmountIn = input;
      l.assumedAmountOut = output;
    });
    return amounts.get(legs[legs.length - 1].tokenTo.tokenId) || 0;
  }
  /** TODO: make full test coverage!
   * @param {RouteLeg[]} legs
   * @param {number} amountOut
   * @return {number}
   */
  calcLegsAmountIn(legs, amountOut) {
    const totalOutputAssumed = /* @__PURE__ */ new Map();
    legs.forEach((l) => {
      const prevValue = totalOutputAssumed.get(l.tokenFrom.tokenId) || 0;
      totalOutputAssumed.set(l.tokenFrom.tokenId, prevValue + l.assumedAmountOut);
    });
    const amounts = /* @__PURE__ */ new Map();
    amounts.set(legs[legs.length - 1].tokenTo.tokenId, amountOut);
    for (let i = legs.length - 1; i >= 0; --i) {
      const l = legs[i];
      const vert = this.getVert(l.tokenTo);
      console.assert(vert !== void 0, "Internal Error 884");
      const edge = vert.edges.find((e) => e.pool.address === l.poolAddress);
      console.assert(edge !== void 0, "Internel Error 888");
      const pool = edge.pool;
      const direction = vert === edge.vert1;
      const outputTotal = amounts.get(l.tokenTo.tokenId);
      console.assert(outputTotal !== void 0, "Internal Error 893");
      const totalAssumed = totalOutputAssumed.get(l.tokenFrom.tokenId);
      console.assert(totalAssumed !== void 0, "Internal Error 903");
      const output = outputTotal * l.assumedAmountOut / totalAssumed;
      const input = pool.calcInByOut(output, direction).inp;
      const vertNext = vert.getNeibour(edge);
      const prevAmount = amounts.get(vertNext.token.tokenId);
      amounts.set(vertNext.token.tokenId, (prevAmount || 0) + input);
    }
    return amounts.get(legs[0].tokenFrom.tokenId) || 0;
  }
  /** removes all cycles if there are any, then removes all dead end could appear after cycle removing
   * @param {Vertice} from
   * @param {Vertice} to
   * @return {[Vertice[], boolean]} Returns clean result topologically sorted
   */
  cleanTopology(from, to) {
    let topologyWasChanged = false;
    let result = this.topologySort(from, to);
    if (result.status !== 2) {
      topologyWasChanged = true;
      while (result.status === 0) {
        this.removeWeakestEdge(result.vertices);
        result = this.topologySort(from, to);
      }
      if (result.status === 3) {
        this.removeDeadEnds(result.vertices);
        result = this.topologySort(from, to);
      }
      console.assert(result.status === 2, "Internal Error 563");
      if (result.status !== 2)
        return { vertices: [], topologyWasChanged };
    }
    return { vertices: result.vertices, topologyWasChanged };
  }
  /**
   * @param {Vertice[]} verts
   */
  removeDeadEnds(verts) {
    verts.forEach((v) => {
      v.getInputEdges().forEach((e) => {
        e.canBeUsed = false;
      });
    });
  }
  /**
   * @param {Vertice[]} verts
   */
  removeWeakestEdge(verts) {
    let minVert;
    let minVertNext;
    let minOutput = Number.MAX_VALUE;
    verts.forEach((v1, i) => {
      const v2 = i === 0 ? verts[verts.length - 1] : verts[i - 1];
      let out = 0;
      v1.getOutputEdges().forEach((e) => {
        if (v1.getNeibour(e) !== v2)
          return;
        out += e.direction ? e.amountOutPrevious : e.amountInPrevious;
      });
      if (out < minOutput) {
        minVert = v1;
        minVertNext = v2;
        minOutput = out;
      }
    });
    minVert.getOutputEdges().forEach((e) => {
      if (minVert.getNeibour(e) !== minVertNext)
        return;
      e.canBeUsed = false;
    });
  }
  /** topological sort
   *  if there is a cycle - returns [0, <List of envolved vertices in the cycle>]
   *  if there are no cycles but deadends- returns [3, <List of all envolved deadend vertices>]
   *  if there are no cycles or deadends- returns [2, <List of all envolved vertices topologically sorted>]
   * @param {Vertice} from
   * @param {Vertice} to
   * @return {[number, Vertice[]]}
   */
  topologySort(from, to) {
    const vertState = /* @__PURE__ */ new Map();
    const vertsFinished = [];
    const foundCycle = [];
    const foundDeadEndVerts = [];
    function topSortRecursive(current) {
      const state = vertState.get(current);
      if (state === 2 || state === 3)
        return state;
      if (state === 1) {
        console.assert(foundCycle.length == 0, "Internal Error 566");
        foundCycle.push(current);
        return 1;
      }
      vertState.set(current, 1);
      let successors2Exist = false;
      const outEdges = current.getOutputEdges();
      for (let i = 0; i < outEdges.length; ++i) {
        const e = outEdges[i];
        const res2 = topSortRecursive(current.getNeibour(e));
        if (res2 === 0)
          return 0;
        if (res2 === 1) {
          if (foundCycle[0] === current)
            return 0;
          else {
            foundCycle.push(current);
            return 1;
          }
        }
        if (res2 === 2)
          successors2Exist = true;
      }
      if (successors2Exist) {
        console.assert(current !== to, "Internal Error 589");
        vertsFinished.push(current);
        vertState.set(current, 2);
        return 2;
      } else {
        if (current !== to) {
          foundDeadEndVerts.push(current);
          vertState.set(current, 3);
          return 3;
        }
        vertsFinished.push(current);
        vertState.set(current, 2);
        return 2;
      }
    }
    const res = topSortRecursive(from);
    if (res === 0)
      return { status: 0, vertices: foundCycle };
    if (foundDeadEndVerts.length)
      return { status: 3, vertices: foundDeadEndVerts };
    ASSERT(() => {
      if (vertsFinished[0] !== to)
        return false;
      if (vertsFinished[vertsFinished.length - 1] !== from)
        return false;
      return true;
    }, "Internal Error 614");
    if (res === 2)
      return { status: 2, vertices: vertsFinished.reverse() };
    console.assert(true, "Internal Error 612");
    return { status: 1, vertices: [] };
  }
};

// src/entities/Trade.ts
import invariant10 from "tiny-invariant";
var Trade = class {
  /**
   * @param {MultiRoute} route
   * @param {TradeType} tradeType
   * @param {TradeVersion} tradeVersion
   * @param {{JSBI, JSBI}} currencyInRebase
   * @param {{JSBI, JSBI}} currencyOutRebase
   */
  constructor(route, tradeType, tradeVersion, currencyInRebase = { base: default2.BigInt(0), elastic: default2.BigInt(0) }, currencyOutRebase = { base: default2.BigInt(0), elastic: default2.BigInt(0) }) {
    /**
     * The percent difference between the mid price before the trade and the trade execution price.
     */
    this.priceImpact = new Percent_default(default2.BigInt(0), default2.BigInt(1e4));
    this.currencyInRebase = { base: default2.BigInt(0), elastic: default2.BigInt(0) };
    this.currencyOutRebase = { base: default2.BigInt(0), elastic: default2.BigInt(0) };
    this.route = route;
    this.tradeType = tradeType;
    this.tradeVersion = tradeVersion;
    this.currencyInRebase = currencyInRebase;
    this.currencyOutRebase = currencyOutRebase;
    const amountIn = Amount.fromShare(
      route.fromToken,
      route.amountInBN.toString(),
      currencyInRebase,
      tradeVersion === 1 /* V2 */
    );
    const amountOut = Amount.fromShare(
      route.toToken,
      route.amountOutBN.toString(),
      currencyOutRebase,
      tradeVersion === 1 /* V2 */
    );
    if (tradeType === 0 /* EXACT_INPUT */) {
      this.inputAmount = Amount.fromFractionalAmount(
        amountIn.currency,
        amountIn.numerator,
        amountIn.denominator
      );
      this.outputAmount = Amount.fromFractionalAmount(
        amountOut.currency,
        amountOut.numerator,
        amountOut.denominator
      );
    } else {
      this.inputAmount = Amount.fromFractionalAmount(
        amountIn.currency,
        amountOut.numerator,
        amountOut.denominator
      );
      this.outputAmount = Amount.fromFractionalAmount(
        amountOut.currency,
        amountIn.numerator,
        amountIn.denominator
      );
    }
    this.executionPrice = new Price(
      this.inputAmount.currency,
      this.outputAmount.currency,
      this.inputAmount.quotient,
      this.outputAmount.quotient
    );
    if (this.route.priceImpact) {
      this.priceImpact = new Percent_default(
        default2.BigInt(Math.round(this.route.priceImpact * 1e4)),
        default2.BigInt(1e4)
      );
    }
  }
  /**
   * Constructs an exact in trade with the given amount in and route
   * @param {MultiRoute}route route of the exact in trade
   * @param {Amount<TInput>}amountIn the amount being passed in
   * @param {TOutput}currencyOut the output currency
   * @param {TVersion} version
   * @param {{JSBI, JSBI}}currencyInRebase
   * @param {{JSBI, JSBI}}currencyOutRebase
   * @param {BigNumber[]} distribution
   * @param {BigNumber} flags
   * @return {Trade<TInput, TOutput, Type.EXACT_INPUT>}
   */
  static exactIn(route, amountIn, currencyOut, version4, currencyInRebase = { base: default2.BigInt(0), elastic: default2.BigInt(0) }, currencyOutRebase = { base: default2.BigInt(0), elastic: default2.BigInt(0) }) {
    return new Trade(
      __spreadProps(__spreadValues({}, route), {
        fromToken: amountIn.currency,
        toToken: currencyOut
      }),
      0 /* EXACT_INPUT */,
      version4,
      currencyInRebase,
      currencyOutRebase
    );
  }
  /**
   * Constructs an exact out trade with the given amount out and route
   * @param {MultiRoute}route route of the exact out trade
   * @param {TInput}currencyIn the output currency
   * @param {Amount<TOutput>}amountOut the amount returned by the trade
   * @param {TVersion} version
   * @param {{JSBI, JSBI}}currencyInRebase
   * @param {{JSBI, JSBI}}currencyOutRebase
   * @return {Trade<TInput, TOutput, Type.EXACT_OUTPUT>}
   */
  static exactOut(route, currencyIn, amountOut, version4, currencyInRebase = { base: default2.BigInt(0), elastic: default2.BigInt(0) }, currencyOutRebase = { base: default2.BigInt(0), elastic: default2.BigInt(0) }) {
    return new Trade(
      __spreadProps(__spreadValues({}, route), { fromToken: currencyIn, toToken: amountOut.currency }),
      1 /* EXACT_OUTPUT */,
      version4,
      currencyInRebase,
      currencyOutRebase
    );
  }
  /**
   * Get the minimum amount that must be received from this trade for the given slippage tolerance
   * @param {Percent}slippageTolerance tolerance of unfavorable slippage from the execution price of this trade
   * @return {Amount<TOutput>}
   */
  minimumAmountOut(slippageTolerance) {
    invariant10(!slippageTolerance.lessThan(ZERO), "SLIPPAGE_TOLERANCE");
    if (this.tradeType === 1 /* EXACT_OUTPUT */) {
      return this.outputAmount;
    } else {
      const slippageAdjustedAmountOut = new Fraction_default(ONE).add(slippageTolerance).invert().multiply(this.outputAmount.quotient).quotient;
      return Amount.fromRawAmount(this.outputAmount.currency, slippageAdjustedAmountOut);
    }
  }
  /**
   * Get the maximum amount in that can be spent via this trade for the given slippage tolerance
   * @param {Percent}slippageTolerance tolerance of unfavorable slippage from the execution price of this trade
   * @return {Amount<TInput>}
   */
  maximumAmountIn(slippageTolerance) {
    invariant10(!slippageTolerance.lessThan(ZERO), "SLIPPAGE_TOLERANCE");
    if (this.tradeType === 0 /* EXACT_INPUT */) {
      return this.inputAmount;
    } else {
      const slippageAdjustedAmountIn = new Fraction_default(ONE).add(slippageTolerance).multiply(this.inputAmount.quotient).quotient;
      return Amount.fromRawAmount(this.inputAmount.currency, slippageAdjustedAmountIn);
    }
  }
  /**
   * Return the execution price after accounting for slippage tolerance
   * @param {Percent}slippageTolerance the allowed tolerated slippage
   * @return {Amount<TInput>}
   */
  worstExecutionPrice(slippageTolerance) {
    return new Price(
      this.inputAmount.currency,
      this.outputAmount.currency,
      this.maximumAmountIn(slippageTolerance).quotient,
      this.minimumAmountOut(slippageTolerance).quotient
    );
  }
  /**
   * @return {boolean}
   */
  isV1() {
    return this.tradeVersion === 0 /* V1 */;
  }
  /**
   * @return {boolean}
   */
  isV2() {
    return this.tradeVersion === 1 /* V2 */;
  }
  /**
   * @return {string}
   */
  routeType() {
    if (this.isComplex())
      return "Complex Path";
    if (this.isSingle())
      return "Single Path";
    if (this.isSinglePool())
      return "Single Pool";
    return "Not Found";
  }
  /**
   * @return {boolean}
   */
  isNotFound() {
    return !this.route.legs.length;
  }
  /**
   * @return {boolean}
   */
  isComplex() {
    return new Set(this.route.legs.map((leg) => leg.tokenFrom.address)).size !== this.route.legs.length;
  }
  /**
   * @return {boolean}
   */
  isSinglePool() {
    return this.route.legs.length === 1;
  }
  /**
   * @return {boolean}
   */
  isSingle() {
    return new Set(this.route.legs.map((leg) => leg.tokenFrom.address)).size === this.route.legs.length;
  }
};

// src/entities/Pool.ts
var Pool = class {
};

// src/entities/SushiSwapRouter.ts
import { getAddress as getAddress2 } from "@ethersproject/address";
import invariant11 from "tiny-invariant";
import warning from "tiny-warning";
function validateAndParseAddress(address) {
  try {
    const checksummedAddress = getAddress2(address);
    warning(address === checksummedAddress, `${address} is not checksummed.`);
    return checksummedAddress;
  } catch (error) {
    invariant11(false, `${address} is not a valid address.`);
  }
}
var ZERO_HEX = "0x0";
var SushiSwapRouter = class {
  /**
   * Cannot be constructed.
   */
  constructor() {
  }
  /**
   * Produces the on-chain method name to call and the hex encoded parameters to pass as arguments for a given trade.
   * @param {Trade<Currency, Currency, TradeType, Version.V1 | Version.V2>}trade to produce call parameters for
   * @param {TradeOptions | TradeOptionsDeadline}options options for the call parameters
   * @return {SwapParameters}
   */
  static swapCallParameters(trade, options) {
    const etherIn = trade.inputAmount.currency.isNative;
    const etherOut = trade.outputAmount.currency.isNative;
    invariant11(!(etherIn && etherOut), "ETHER_IN_OUT");
    invariant11(!("ttl" in options) || options.ttl > 0, "TTL");
    const to = validateAndParseAddress(options.recipient);
    const amountIn = trade.maximumAmountIn(options.allowedSlippage).toHex();
    const amountOut = trade.minimumAmountOut(options.allowedSlippage).toHex();
    const path = trade.route.legs.reduce(
      (previousValue, currentValue) => [...previousValue, currentValue.tokenTo.address],
      [trade.route.legs[0].tokenFrom.address]
    );
    const deadline = "ttl" in options ? `0x${(Math.floor((/* @__PURE__ */ new Date()).getTime() / 1e3) + options.ttl).toString(16)}` : `0x${options.deadline.toString(16)}`;
    const useFeeOnTransfer = Boolean(options.feeOnTransfer);
    let methodName;
    let args;
    let value;
    switch (trade.tradeType) {
      case 0 /* EXACT_INPUT */:
        if (etherIn) {
          methodName = useFeeOnTransfer ? "swapExactETHForTokensSupportingFeeOnTransferTokens" : "swapExactETHForTokens";
          args = [amountOut, path, to, deadline];
          value = amountIn;
        } else if (etherOut) {
          methodName = useFeeOnTransfer ? "swapExactTokensForETHSupportingFeeOnTransferTokens" : "swapExactTokensForETH";
          args = [amountIn, amountOut, path, to, deadline];
          value = ZERO_HEX;
        } else {
          methodName = useFeeOnTransfer ? "swapExactTokensForTokensSupportingFeeOnTransferTokens" : "swapExactTokensForTokens";
          args = [amountIn, amountOut, path, to, deadline];
          value = ZERO_HEX;
        }
        break;
      case 1 /* EXACT_OUTPUT */:
        invariant11(!useFeeOnTransfer, "EXACT_OUT_FOT");
        if (etherIn) {
          methodName = "swapETHForExactTokens";
          args = [amountOut, path, to, deadline];
          value = amountIn;
        } else if (etherOut) {
          methodName = "swapTokensForExactETH";
          args = [amountOut, amountIn, path, to, deadline];
          value = ZERO_HEX;
        } else {
          methodName = "swapTokensForExactTokens";
          args = [amountOut, amountIn, path, to, deadline];
          value = ZERO_HEX;
        }
        break;
    }
    return {
      methodName,
      args,
      value
    };
  }
};

// src/entities/Exchange.ts
import { getAddress as getAddress3 } from "@ethersproject/address";
import invariant12 from "tiny-invariant";
var Exchange = class {
  /**
   * Constructs an instance of the abstract class `Currency`.
   * @param {number | string}chainId the chain ID on which this currency resides
   * @param {number | string}decimals decimals of the currency
   * @param {string}symbol symbol of the currency
   * @param {string}name of the currency
   * @param {object}rebase of the currency
   */
  constructor({
    chainId,
    name,
    address,
    exchangeURI,
    initCodeHash
  }) {
    invariant12(Number.isSafeInteger(Number(chainId)), "CHAIN_ID");
    try {
      this.address = getAddress3(address);
    } catch (e) {
      console.log`${address} is not a valid address`;
    }
    this.chainId = Number(chainId);
    this.name = name;
    this.exchangeURI = exchangeURI;
    this.initCodeHash = initCodeHash;
  }
};

// src/entities/liquidity-providers/LiquidityProvider.ts
var LiquidityProviders = /* @__PURE__ */ ((LiquidityProviders2) => {
  LiquidityProviders2["EmberSwapV2"] = "EmberSwapV2";
  LiquidityProviders2["MistSwapV2"] = "MistSwapV2";
  LiquidityProviders2["SushiSwapV2"] = "SushiSwapV2";
  LiquidityProviders2["SushiSwapV3"] = "SushiSwapV3";
  LiquidityProviders2["UniswapV3"] = "UniswapV3";
  LiquidityProviders2["PancakeSwap"] = "PancakeSwap";
  LiquidityProviders2["NativeWrap"] = "NativeWrap";
  return LiquidityProviders2;
})(LiquidityProviders || {});
var LiquidityProvider = class {
  /**
   * @param {ChainId}chainId
   * @param {PublicClient}client
   */
  constructor(chainId) {
    this.poolCodes = [];
    this.ON_DEMAND_POOLS_LIFETIME_IN_SECONDS = 60;
    this.FETCH_AVAILABLE_POOLS_AFTER_SECONDS = 900;
    this.getTradeId = (t0, t1) => [t0.address.toLowerCase(), t1.address.toLowerCase()].sort((first, second) => first > second ? -1 : 1).join(":");
    this.chainId = chainId;
  }
};

// src/entities/HEXer.ts
var HEXer = class {
  /** */
  constructor() {
    this.hex = "";
  }
  /**
   * @return {string}
   */
  toString() {
    return this.hex;
  }
  /**
   * @return {string}
   */
  toHexString() {
    return `0x${this.hex}`;
  }
  /**
   * @return {string}
   */
  toString0x() {
    return this.toHexString();
  }
  /**
   * @param {number} data
   * @return {HEXer}
   */
  uint8(data) {
    if (data > 255 || data < 0 || data !== Math.round(data)) {
      throw new Error("Wrong uint8: " + data);
    }
    this.hex += data.toString(16).padStart(2, "0");
    return this;
  }
  /**
   * @param {boolean} data
   * @return {HEXer}
   */
  bool(data) {
    return this.uint8(data ? 1 : 0);
  }
  /**
   * @param {number} data
   * @return {HEXer}
   */
  uint16(data) {
    if (data >= 256 * 256 || data < 0 || data !== Math.round(data)) {
      throw new Error("Wrong uint16: " + data);
    }
    this.hex += data.toString(16).padStart(4, "0");
    return this;
  }
  /**
   * @param {number} data
   * @return {HEXer}
   */
  uint24(data) {
    if (data >= 256 * 256 * 256 || data < 0 || data !== Math.round(data)) {
      throw new Error("Wrong uint24: " + data);
    }
    this.hex += data.toString(16).padStart(6, "0");
    return this;
  }
  /**
   * @param {number} share
   * @return {HEXer}
   */
  share16(share) {
    return this.uint16(Math.round(share * 65535));
  }
  /**
   * @param {number} data
   * @return {HEXer}
   */
  uint32(data) {
    if (data >= 256 * 256 * 256 * 256 || data < 0 || data !== Math.round(data)) {
      throw new Error("Wrong uint32: " + data);
    }
    this.hex += data.toString(16).padStart(8, "0");
    return this;
  }
  /**
   * @param {BigNumber | number} data
   * @return {HEXer}
   */
  uint256(data) {
    if (typeof data == "number") {
      if (data > Number.MAX_SAFE_INTEGER || data < 0 || data !== Math.round(data)) {
        throw new Error("Wrong uint256: " + data);
      }
      this.hex += data.toString(16).padStart(64, "0");
      return this;
    } else {
      const hex = data.toHexString().slice(2).padStart(64, "0");
      if (data.lt(0) || hex.length > 64) {
        throw new Error("Wrong uin256: " + data.toString());
      }
      this.hex += hex;
      return this;
    }
  }
  /**
   * @param {BigNumber | number} data
   * @return {HEXer}
   */
  uint(data) {
    return this.uint256(data);
  }
  /**
   * @param {string} addr
   * @return {HEXer}
   */
  address(addr) {
    if (addr.length > 42 || addr === "RouteProcessor") {
      throw new Error("Wrong address: " + addr);
    }
    this.hex += addr.slice(2).padStart(40, "0");
    return this;
  }
  /**
   * @param {string} data
   * @return {HEXer}
   */
  hexData(data) {
    if (data.length % 2 != 0) {
      throw new Error("Wrong hex data length: " + data.length);
    }
    if (data.startsWith("0x"))
      data = data.slice(2);
    this.hex += data;
    return this;
  }
  /**
   * @param {string} data
   * @return {HEXer}
   */
  bytes(data) {
    if (data.length % 2 != 0) {
      throw new Error("Wrong bytes length: " + data.length);
    }
    if (data.startsWith("0x"))
      data = data.slice(2);
    this.uint(data.length / 2);
    this.hex += data;
    return this;
  }
  /**
   * @param {string} data
   * @return {HEXer}
   */
  bytes32(data) {
    if (data.startsWith("0x"))
      data = data.slice(2);
    if (data.length > 64) {
      throw new Error("Wrong bytes32 length: " + data.length);
    }
    this.hex += data.padEnd(64, "0");
    return this;
  }
};

// src/entities/pools/PoolCode.ts
var PoolCode = class {
  /**
   * @param {RPool}pool
   * @param {LiquidityProviders}liquidityProvider
   * @param {string}poolName
   * @param {string}exchangeUri
   */
  constructor(pool, liquidityProvider, poolName, exchangeUri) {
    this.pool = pool;
    this.liquidityProvider = liquidityProvider;
    this.poolName = poolName;
    this.exchangeUri = exchangeUri;
  }
  // the address where should be swap amount of liquidity before the swap
  // returns RouteProcessorAddress if it is a RouteProcessor
  /**
   * @param {RouteLeg}_leg
   * @param {MultiRoute}_route
   * @return {string}
   */
  getStartPoint(_leg, _route) {
    return this.pool.address;
  }
  /**
   * @param {RouteLeg}_leg
   * @param {MultiRoute}_route
   * @param {string}_to
   * @return {string}
   */
  getSwapCodeForRouteProcessor2(_leg, _route, _to) {
    return "unimplemented";
  }
};
PoolCode.RouteProcessorAddress = "RouteProcessor";

// src/entities/TinesToRouteProcessor2.ts
var TokenType = /* @__PURE__ */ ((TokenType2) => {
  TokenType2["NATIVE"] = "NATIVE";
  TokenType2["ERC20"] = "ERC20";
  return TokenType2;
})(TokenType || {});
function getTokenType(token) {
  if (token.address == "")
    return "NATIVE" /* NATIVE */;
  return "ERC20" /* ERC20 */;
}
var TinesToRouteProcessor2 = class {
  // presendedLegs: Set<RouteLeg> = new Set()
  /**
   *
   * @param {string}routeProcessorAddress
   * @param {ChainId}chainId
   * @param {Map<string, PoolCode>}pools
   */
  constructor(routeProcessorAddress, chainId, pools) {
    this.tokenOutputLegs = /* @__PURE__ */ new Map();
    this.routeProcessorAddress = routeProcessorAddress;
    this.chainId = chainId;
    this.pools = pools;
  }
  /**
   * @param {MultiRoute}route
   * @param {string}toAddress
   * @param {PermitData[]}permits
   * @return {string}
   */
  getRouteProcessorCode(route, toAddress, permits = []) {
    if (route.status == "NoWay" /* NoWay */ || route.legs.length == 0)
      return "";
    this.calcTokenOutputLegs(route);
    let res = "0x";
    res += this.processPermits(permits);
    const processedTokens = /* @__PURE__ */ new Set();
    route.legs.forEach((l, i) => {
      const token = l.tokenFrom;
      if (processedTokens.has(token.tokenId))
        return;
      processedTokens.add(token.tokenId);
      if (i > 0) {
        if (token.address === "")
          throw new Error("unexpected native inside the route: " + token.symbol);
        if (this.isOnePoolOptimization(token, route))
          res += this.processOnePoolCode(token, route, toAddress);
        else if (getTokenType(token) == "ERC20" /* ERC20 */)
          res += this.processERC20Code(true, token, route, toAddress);
      } else {
        if (token.address == "")
          res += this.processNativeCode(token, route, toAddress);
        else
          res += this.processERC20Code(false, token, route, toAddress);
      }
    });
    return res;
  }
  /**
   * @param {PermitData[]}permits
   * @return {string}
   */
  processPermits(permits) {
    const hex = new HEXer();
    permits.forEach((p) => {
      hex.uint8(5).uint(p.value).uint(p.deadline).uint8(p.v).bytes32(p.r).bytes32(p.s);
    });
    return hex.toString();
  }
  /**
   * @param {RToken}token
   * @param {MultiRoute}route
   * @param {string}toAddress
   * @return {string}
   */
  processNativeCode(token, route, toAddress) {
    const outputLegs = this.tokenOutputLegs.get(token.tokenId);
    if (!outputLegs || outputLegs.length !== 1) {
      throw new Error("Not 1 output pool for native token: " + (outputLegs == null ? void 0 : outputLegs.length));
    }
    const hex = new HEXer().uint8(3).uint8(outputLegs.length);
    outputLegs.forEach((l) => {
      hex.share16(l.swapPortion).hexData(this.swapCode(l, route, toAddress));
    });
    return hex.toString();
  }
  /**
   * @param {boolean}fromMe
   * @param {RToken}token
   * @param {MultiRoute}route
   * @param {string}toAddress
   * @return {string}
   */
  processERC20Code(fromMe, token, route, toAddress) {
    const outputLegs = this.tokenOutputLegs.get(token.tokenId);
    if (!outputLegs || outputLegs.length == 0) {
      throw new Error("No output legs for token " + token.symbol);
    }
    const hex = new HEXer().uint8(fromMe ? 1 : 2).address(token.address).uint8(outputLegs.length);
    outputLegs.forEach((l) => {
      hex.share16(l.swapPortion).hexData(this.swapCode(l, route, toAddress));
    });
    return hex.toString();
  }
  /**
   * @param {RToken}token
   * @param {MultiRoute}route
   * @param {string}toAddress
   * @return {string}
   */
  processOnePoolCode(token, route, toAddress) {
    const outputLegs = this.tokenOutputLegs.get(token.tokenId);
    if (!outputLegs || outputLegs.length != 1) {
      throw new Error("1 output leg expected " + (outputLegs == null ? void 0 : outputLegs.length));
    }
    const hex = new HEXer().uint8(4).address(token.address).hexData(this.swapCode(outputLegs[0], route, toAddress));
    return hex.toString();
  }
  /**
   * @param {RToken}token
   * @param {MultiRoute}route
   * @param {string}toAddress
   * @return {string}
   */
  processBentoCode(token, route, toAddress) {
    const outputLegs = this.tokenOutputLegs.get(token.tokenId);
    if (!outputLegs || outputLegs.length == 0) {
      throw new Error("No output legs for token " + (outputLegs == null ? void 0 : outputLegs.length));
    }
    const hex = new HEXer().uint8(5).address(token.address).uint8(outputLegs.length);
    outputLegs.forEach((l) => {
      hex.share16(l.swapPortion).hexData(this.swapCode(l, route, toAddress));
    });
    return hex.toString();
  }
  /**
   * @param {RouteLeg}leg
   * @param {MultiRoute}route
   * @param {string}toAddress
   * @return {string}
   */
  swapCode(leg, route, toAddress) {
    const pc = this.getPoolCode(leg);
    const to = this.getPoolOutputAddress(leg, route, toAddress);
    return pc.getSwapCodeForRouteProcessor2(leg, route, to);
  }
  /**
   * @param {RouteLeg}l
   * @param {MultiRoute}route
   * @param {string}toAddress
   * @return {string}
   */
  getPoolOutputAddress(l, route, toAddress) {
    let outAddress;
    const outputDistribution = this.tokenOutputLegs.get(l.tokenTo.tokenId) || [];
    if (outputDistribution.length == 0) {
      outAddress = toAddress;
    } else if (outputDistribution.length == 1) {
      outAddress = this.getPoolCode(outputDistribution[0]).getStartPoint(l, route);
      if (outAddress == PoolCode.RouteProcessorAddress)
        outAddress = this.routeProcessorAddress;
    } else {
      outAddress = this.routeProcessorAddress;
    }
    return outAddress;
  }
  /**
   * @param {RToken}token
   * @param {MultiRoute}route
   * @return {boolean}
   */
  isOnePoolOptimization(token, route) {
    const outputDistribution = this.tokenOutputLegs.get(token.tokenId) || [];
    if (outputDistribution.length != 1)
      return false;
    const startPoint = this.getPoolCode(outputDistribution[0]).getStartPoint(
      outputDistribution[0],
      route
    );
    return startPoint == outputDistribution[0].poolAddress;
  }
  /**
   * @param {RouteLeg} l
   * @return {PoolCode}
   */
  getPoolCode(l) {
    const pc = this.pools.get(l.poolAddress);
    if (pc === void 0) {
      throw new Error(`unknown pool: ${l.poolAddress}`);
    }
    return pc;
  }
  /**
   * @param {MultiRoute}route
   */
  calcTokenOutputLegs(route) {
    const res = /* @__PURE__ */ new Map();
    route.legs.forEach((l) => {
      var _a;
      const tokenId = (_a = l.tokenFrom.tokenId) == null ? void 0 : _a.toString();
      if (tokenId === void 0) {
        console.assert(0, "Unseted tokenId");
      } else {
        const legsOutput = res.get(tokenId) || [];
        legsOutput.push(l);
        res.set(tokenId, legsOutput);
      }
    });
    this.tokenOutputLegs = res;
  }
};
function getRouteProcessor2Code(route, routeProcessorAddress, toAddress, pools, permits = []) {
  const rpc = new TinesToRouteProcessor2(
    routeProcessorAddress,
    route.fromToken.chainId,
    pools
  );
  return rpc.getRouteProcessorCode(route, toAddress, permits);
}

// src/entities/Router.ts
var Router = class {
  /**
   * @param {Map<string, PoolCode>}poolCodesMap
   * @param {ChainId}chainId
   * @param {Type}fromToken
   * @param {BigNumber}amountIn
   * @param {Type}toToken
   * @param {number}gasPrice
   * @return {MultiRoute}
   */
  static findSushiRoute(poolCodesMap, chainId, fromToken, amountIn, toToken, gasPrice) {
    return Router.findBestRoute(poolCodesMap, chainId, fromToken, amountIn, toToken, gasPrice, [
      "NativeWrap" /* NativeWrap */,
      "SushiSwapV2" /* SushiSwapV2 */,
      "SushiSwapV3" /* SushiSwapV3 */
    ]);
  }
  /**
   * @param {Map<string, PoolCode>}poolCodesMap
   * @param {ChainId}chainId
   * @param {Type}fromToken
   * @param {BigNumber}amountIn
   * @param {Type}toToken
   * @param {number}gasPrice
   * @param {number} maxPriceImpact
   * @return {MultiRoute}
   */
  static findSpecialRoute(poolCodesMap, chainId, fromToken, amountIn, toToken, gasPrice, maxPriceImpact = 10) {
    const preferrableRoute = Router.findBestRoute(
      poolCodesMap,
      chainId,
      fromToken,
      amountIn,
      toToken,
      gasPrice,
      [
        "NativeWrap" /* NativeWrap */,
        "MistSwapV2" /* MistSwapV2 */,
        "SushiSwapV3" /* SushiSwapV3 */,
        "EmberSwapV2" /* EmberSwapV2 */,
        "UniswapV3" /* UniswapV3 */
      ]
    );
    if (preferrableRoute.status === "Success" /* Success */ && preferrableRoute.priceImpact !== void 0 && preferrableRoute.priceImpact < maxPriceImpact / 100) {
      return preferrableRoute;
    }
    return Router.findBestRoute(poolCodesMap, chainId, fromToken, amountIn, toToken, gasPrice);
  }
  /**
   * @param {Map<string, PoolCode>}poolCodesMap
   * @param {ChainId}chainId
   * @param {Type}fromToken
   * @param {BigNumber}amountIn
   * @param {Type}toToken
   * @param {number}gasPrice
   * @param {LiquidityProviders[]} providers
   * @param {PoolFilter} poolFilter
   * @return {MultiRoute}
   */
  static findBestRoute(poolCodesMap, chainId, fromToken, amountIn, toToken, gasPrice, providers, poolFilter) {
    const networks = [
      {
        chainId,
        baseToken: WNATIVE[chainId],
        gasPrice
      }
    ];
    let poolCodes = Array.from(poolCodesMap.values());
    if (providers) {
      poolCodes = poolCodes.filter(
        (pc) => [...providers, "NativeWrap" /* NativeWrap */].includes(pc.liquidityProvider)
      );
    }
    let pools = Array.from(poolCodes).map((pc) => pc.pool);
    if (poolFilter)
      pools = pools.filter(poolFilter);
    const route = findMultiRouteExactIn(
      fromToken,
      toToken,
      amountIn,
      pools,
      networks,
      gasPrice
    );
    return __spreadProps(__spreadValues({}, route), {
      legs: route.legs.map((l) => {
        var _a, _b, _c, _d;
        return __spreadProps(__spreadValues({}, l), {
          poolName: (_b = (_a = poolCodesMap.get(l.poolAddress)) == null ? void 0 : _a.poolName) != null ? _b : "Unknown Pool",
          exchangeUri: (_d = (_c = poolCodesMap.get(l.poolAddress)) == null ? void 0 : _c.exchangeUri) != null ? _d : "Unknown URI"
        });
      })
    });
  }
  /**
   * @param {Map<string, PoolCode>}poolCodesMap
   * @param {MultiRoute}route
   * @param {Type}fromToken
   * @param {Type}toToken
   * @param {string}to
   * @param {string}RPAddr
   * @param {number} maxPriceImpact
   * @return {RPParams}
   */
  static routeProcessorParams(poolCodesMap, route, fromToken, toToken, to, RPAddr, maxPriceImpact = 5e-3) {
    const tokenIn = (
      /* fromToken instanceof Token ?*/
      !fromToken.isNative ? fromToken.wrapped.address : "0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE"
    );
    const tokenOut = (
      /* toToken instanceof Token ?*/
      !toToken.isNative ? toToken.wrapped.address : "0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE"
    );
    const amountOutMin = BigInt(
      route.amountOutBN.mul(getBigNumber((1 - maxPriceImpact) * 1e6)).div(1e6).toString()
    );
    return {
      tokenIn,
      amountIn: BigInt(route.amountInBN.toString()),
      tokenOut,
      amountOutMin,
      to,
      routeCode: getRouteProcessor2Code(route, RPAddr, to, poolCodesMap),
      value: !fromToken.isNative ? void 0 : BigInt(route.amountInBN.toString())
    };
  }
  /**
   * @param {Map<string, PoolCode>}poolCodesMap
   * @param {MultiRoute}route
   * @param {Type}fromToken
   * @param {Type}toToken
   * @param {string}to
   * @param {string}RPAddr
   * @param {PermitData[]} permits
   * @param {number} maxPriceImpact
   * @return {RPParams}
   */
  static routeProcessor2Params(poolCodesMap, route, fromToken, toToken, to, RPAddr, permits = [], maxPriceImpact = 5e-3) {
    const tokenIn = !fromToken.isNative ? fromToken.wrapped.address : "0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE";
    const tokenOut = !toToken.isNative ? toToken.wrapped.address : "0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE";
    const amountOutMin = BigInt(
      route.amountOutBN.mul(getBigNumber((1 - maxPriceImpact) * 1e6)).div(1e6).toString()
    );
    return [
      tokenIn,
      BigInt(route.amountInBN.toString()),
      tokenOut,
      amountOutMin,
      to,
      getRouteProcessor2Code(route, RPAddr, to, poolCodesMap, permits)
    ];
  }
  /**
   * @param {Map<string, PoolCode>}poolCodesMap
   * @param {MultiRoute}route
   * @param {Type}fromToken
   * @param {Type}toToken
   * @param {string}to
   * @param {string}RPAddr
   * @param {PermitData[]} permits
   * @param {number} maxPriceImpact
   * @return {RPParams}
   */
  static routeProcessor3Params(poolCodesMap, route, fromToken, toToken, to, RPAddr, permits = [], maxPriceImpact = 5e-3) {
    return Router.routeProcessor2Params(
      poolCodesMap,
      route,
      fromToken,
      toToken,
      to,
      RPAddr,
      permits,
      maxPriceImpact
    );
  }
  /** Human-readable route printing
   * @param {Map<string, PoolCode>}poolCodesMap
   * @param {MultiRoute}route
   * @param {Type}fromToken
   * @param {Type}toToken
   * @param {string}shiftPrimary
   * @param {string}shiftSub
   * @return {string}
   */
  static routeToHumanString(poolCodesMap, route, fromToken, toToken, shiftPrimary = "", shiftSub = "    ") {
    let res = "";
    res += shiftPrimary + "Route Status: " + route.status + "\n";
    res += shiftPrimary + `Input: ${route.amountIn / Math.pow(10, fromToken.decimals)} ${fromToken.symbol}
`;
    route.legs.forEach((l, i) => {
      var _a;
      res += shiftSub + `${i + 1}. ${l.tokenFrom.symbol} ${Math.round(l.absolutePortion * 100)}% -> [${(_a = poolCodesMap.get(l.poolAddress)) == null ? void 0 : _a.poolName}] -> ${l.tokenTo.symbol}
`;
    });
    const output = parseInt(route.amountOutBN.toString()) / Math.pow(10, toToken.decimals);
    res += shiftPrimary + `Output: ${output} ${route.toToken.symbol}`;
    return res;
  }
};
function tokenQuantityString(token, amount) {
  const denominator = BigNumber.from(10).pow(token.decimals);
  const integer = amount.div(denominator);
  const fractional = amount.sub(integer.mul(denominator));
  if (fractional.isZero())
    return `${integer} ${token.symbol}`;
  const paddedFractional = fractional.toString().padStart(token.decimals, "0");
  return `${integer}.${paddedFractional} ${token.symbol}`;
}

// src/entities/WrappedTokenInfo.ts
import { getAddress as getAddress4, isAddress } from "@ethersproject/address";
var WrappedTokenInfo = class {
  /**
   * @param {TokenInfo}tokenInfo
   * @param {TokenList}list
   */
  constructor(tokenInfo, list) {
    this.isNative = false;
    this.isToken = true;
    this.rebase = { base: default2.BigInt(1), elastic: default2.BigInt(1) };
    this._checksummedAddress = null;
    this._tags = null;
    this.id = `${tokenInfo.chainId}:${tokenInfo.address}`;
    this.tokenInfo = tokenInfo;
    this.list = list;
  }
  /** */
  get address() {
    if (this._checksummedAddress)
      return this._checksummedAddress;
    if (!isAddress(this.tokenInfo.address))
      throw new Error(`Invalid token address: ${this.tokenInfo.address}`);
    const checksummedAddress = getAddress4(this.tokenInfo.address);
    return this._checksummedAddress = checksummedAddress;
  }
  /** */
  get chainId() {
    return this.tokenInfo.chainId;
  }
  /** */
  get decimals() {
    return this.tokenInfo.decimals;
  }
  /** */
  get name() {
    return this.tokenInfo.name;
  }
  /** */
  get symbol() {
    return this.tokenInfo.symbol;
  }
  /** */
  get logoURI() {
    return this.tokenInfo.logoURI;
  }
  /**  */
  get tags() {
    var _a;
    if (this._tags !== null)
      return this._tags;
    if (!this.tokenInfo.tags)
      return this._tags = [];
    const listTags = (_a = this.list) == null ? void 0 : _a.tags;
    if (!listTags)
      return this._tags = [];
    return this._tags = this.tokenInfo.tags.map((tagId) => {
      return __spreadProps(__spreadValues({}, listTags[tagId]), {
        id: tagId
      });
    });
  }
  /**
   * @param {Type}other
   * @return {boolean}
   */
  equals(other) {
    return other.chainId === this.chainId && other.isToken && other.address.toLowerCase() === this.address.toLowerCase();
  }
  /**
   * @param {Token}other
   * @return {boolean}
   */
  sortsBefore(other) {
    if (this.equals(other))
      throw new Error("Addresses should not be equal");
    return this.address.toLowerCase() < other.address.toLowerCase();
  }
  /** */
  get wrapped() {
    return this;
  }
};
export {
  Amount,
  BridgeUnlimited,
  Chain,
  ConstantProductRPool,
  Edge,
  Exchange,
  Fraction_default as Fraction,
  Graph,
  HEXer,
  HybridRPool,
  InsufficientInputAmountError,
  InsufficientReservesError,
  LiquidityProvider,
  LiquidityProviders,
  Native,
  Pair,
  Percent_default as Percent,
  Pool,
  PoolCode,
  Price,
  RPool2 as RPool,
  RouteStatus,
  Router,
  Share,
  SushiSwapRouter,
  TYPICAL_MINIMAL_LIQUIDITY,
  TYPICAL_SWAP_GAS_COST,
  TinesToRouteProcessor2,
  Token,
  TokenType,
  Trade,
  Vertice,
  WrappedTokenInfo,
  getRouteProcessor2Code,
  getTokenType,
  setTokenId,
  tokenQuantityString
};
//# sourceMappingURL=index.mjs.map